(function() {	try {		if (typeof document != "undefined") {			var elementStyle = document.createElement("style");			elementStyle.setAttribute("id", "arbitrium-react-styles");			elementStyle.appendChild(document.createTextNode("/*\n * Semantic tokens aliased to the Vue host's design tokens. Custom properties\n * are excluded from the island's `:host { all: initial }` reset and still\n * inherit into the shadow root, so these resolve to the host theme in the app\n * and fall back to the literal values when rendered standalone.\n */\n:host {\n  --aml-fg: var(--text-color-base, #1a1a1a);\n  --aml-fg-dimmed: var(--text-color-dimmed, #616161);\n  --aml-bg: var(--card-background, #ffffff);\n  --aml-border: var(--divider-color, #e0e0e0);\n  --aml-overlay: var(--overlay, rgba(0, 0, 0, 0.5));\n  --aml-success: var(--text-success, #388e3c);\n  --aml-warning: var(--text-warning, #ffa000);\n  --aml-danger: var(--text-danger, #d32f2f);\n  --aml-transition-fast: var(--animation-fast, 200ms);\n  --aml-hover-bg: var(--button-default-hover-background, #e9ecef);\n\n  /* No host equivalent for these subtle-badge / secondary-action tokens, so\n   * they're literal values from the Figma mock rather than aliases. */\n  --aml-card-border: #c8d4e0;\n  --aml-avatar-bg: #f3f5f8;\n  --aml-avatar-border: #dae1e8;\n  --aml-primary-bg: #339af0;\n  --aml-primary-fg: #ffffff;\n  --aml-secondary-bg: #d0ebff;\n  --aml-secondary-fg: #1c7ed6;\n  --aml-success-subtle-bg: #d3f9d8;\n  --aml-success-subtle-fg: #40c057;\n  --aml-danger-subtle-bg: #ffe3e3;\n  --aml-danger-subtle-fg: #fa5252;\n  --aml-neutral-subtle-bg: #eceff1;\n  --aml-neutral-subtle-fg: #66707a;\n}\n\n/*\n * Empty class that exists so importers keep a consumed binding (`styles.root`)\n * into this file — without it Vite/Rollup tree-shakes the side-effect-only\n * import and drops the :host block above. Apply it on the outermost element.\n */\n._root_1lqrb_37 {\n}\n/* Layout for the AML screening modal (Figma: node 351:4810 / 351:7593).\n * Shared across AmlScreeningRoot and its subcomponents in ./components. */\n\n._root_471lr_4 {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;\n  font-size: 14px;\n}\n\n._header_471lr_15 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border-bottom: 1px solid var(--aml-border);\n  flex-shrink: 0;\n}\n\n._headerIdentity_471lr_25 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n._avatarBadge_471lr_31 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border-radius: 2px;\n  background: var(--aml-avatar-bg);\n  border: 1px solid var(--aml-avatar-border);\n  color: var(--aml-fg-dimmed);\n}\n\n._personName_471lr_44 {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n._personDob_471lr_49 {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--aml-fg-dimmed);\n}\n\n._closeButton_471lr_55 {\n  display: flex;\n  border: none;\n  border-radius: 4px;\n  padding: 4px;\n  background: none;\n  color: var(--aml-fg-dimmed);\n  cursor: pointer;\n}\n\n._closeButton_471lr_55:hover {\n  background: var(--aml-hover-bg);\n}\n\n._toolbar_471lr_69 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n._toolbarListLabel_471lr_78 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n._toolbarSelectWrapper_471lr_84 {\n  position: relative;\n  width: 240px;\n}\n\n._toolbarSelect_471lr_84 {\n  appearance: none;\n  width: 100%;\n  height: 32px;\n  padding: 4px 32px 4px 8px;\n  border: 1px solid var(--aml-border);\n  border-radius: 4px;\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n  font-size: 16px;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n._toolbarSelectChevron_471lr_103 {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  color: var(--aml-fg-dimmed);\n  pointer-events: none;\n}\n\n._selectAllButton_471lr_112 {\n  height: 32px;\n  padding: 4px 16px;\n  border: 1px solid var(--aml-secondary-bg);\n  border-radius: 4px;\n  background: var(--aml-secondary-bg);\n  color: var(--aml-secondary-fg);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n._selectAllButton_471lr_112:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n._bulkBar_471lr_129 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 8px 16px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n._bulkBarCount_471lr_138 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--aml-fg);\n}\n\n._bulkBarSetAs_471lr_144 {\n  font-size: 14px;\n  color: var(--aml-fg-dimmed);\n}\n\n._bulkBarActions_471lr_149 {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n._criteriaBar_471lr_155 {\n  display: flex;\n  gap: 32px;\n  flex-wrap: wrap;\n  margin: 0 16px;\n  padding: 8px;\n  border: 1px solid var(--aml-border);\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n._criteriaItem_471lr_166 {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 150px;\n}\n\n._criteriaLabel_471lr_173 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--aml-fg-dimmed);\n}\n\n._criteriaValue_471lr_179 {\n  font-size: 14px;\n  color: var(--aml-fg-dimmed);\n}\n\n._divider_471lr_184 {\n  border: none;\n  border-top: 1px solid var(--aml-border);\n  margin: 16px 0 0;\n  flex-shrink: 0;\n}\n\n._matchList_471lr_191 {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n}\n\n._card_471lr_200 {\n  display: flex;\n  gap: 10px;\n  padding: 16px;\n  border: 1px solid var(--aml-card-border);\n  border-radius: 8px;\n  background: var(--aml-bg);\n  box-shadow: 0 1px 5px rgba(142, 160, 175, 0.14);\n}\n\n._cardCheckbox_471lr_210 {\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n._cardBody_471lr_217 {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n._badgeRow_471lr_225 {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n._badge_471lr_225 {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n._badge--success_471lr_241 {\n  background: var(--aml-success-subtle-bg);\n  color: var(--aml-success-subtle-fg);\n}\n\n._badge--danger_471lr_246 {\n  background: var(--aml-danger-subtle-bg);\n  color: var(--aml-danger-subtle-fg);\n}\n\n._badge--neutral_471lr_251 {\n  background: var(--aml-neutral-subtle-bg);\n  color: var(--aml-neutral-subtle-fg);\n}\n\n._cardMain_471lr_256 {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n}\n\n._avatar_471lr_31 {\n  width: 80px;\n  height: 80px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  background: var(--aml-avatar-bg);\n  border: 1px solid var(--aml-avatar-border);\n  color: var(--aml-fg-dimmed);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n._avatar_471lr_31 img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n._entityName_471lr_282 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 4px;\n}\n\n._flagRow_471lr_288 {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n._matchFlag_471lr_296 {\n  width: 20px;\n  height: 15px;\n  border-radius: 2px;\n  /* Inset outline so predominantly-white flags stay visible on the card. */\n  box-shadow: inset 0 0 0 1px var(--aml-card-border);\n}\n\n._fieldGroup_471lr_304 {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 52px;\n}\n\n._fieldGroup--grow_471lr_311 {\n  flex: 1;\n  min-width: 0;\n}\n\n._fieldLabel_471lr_316 {\n  font-size: 14px;\n  color: var(--aml-fg-dimmed);\n  margin: 0;\n}\n\n._fieldValue_471lr_322 {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n}\n\n._cardActions_471lr_328 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-top: 10px;\n  border-top: 1px solid var(--aml-border);\n}\n\n._secondaryActions_471lr_338 {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n._secondaryButton_471lr_344 {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 4px 16px 4px 12px;\n  border: 1px solid var(--aml-border);\n  border-radius: 4px;\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n._secondaryButton_471lr_344:hover {\n  background: var(--aml-hover-bg);\n}\n\n._primaryButton_471lr_363 {\n  height: 32px;\n  padding: 4px 16px;\n  border: 1px solid var(--aml-primary-bg);\n  border-radius: 4px;\n  background: var(--aml-primary-bg);\n  color: var(--aml-primary-fg);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n._primaryButton_471lr_363:hover {\n  opacity: 0.9;\n}\n\n._emptyState_471lr_379 {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 32px;\n  text-align: center;\n}\n\n._emptyIcon_471lr_390 {\n  width: 64px;\n  height: 64px;\n  border-radius: 4px;\n  background: var(--aml-avatar-bg);\n  border: 1px solid var(--aml-avatar-border);\n  color: var(--aml-fg-dimmed);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n._emptyHeading_471lr_402 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  color: var(--aml-fg-dimmed);\n}\n\n._emptyDescription_471lr_409 {\n  font-size: 14px;\n  margin: 0;\n  color: var(--aml-fg-dimmed);\n}\n\n._loadingState_471lr_415 {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n  color: var(--aml-fg-dimmed);\n}\n\n/* Dimming + spinner over the drawer while a write is in flight. Absolutely\n * positioned over .root (hence its `position: relative`); the fixed-position\n * overlays are unaffected. */\n._busyOverlay_471lr_428 {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--aml-overlay);\n}\n\n._spinner_471lr_438 {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--aml-border);\n  border-top-color: var(--aml-primary-bg);\n  border-radius: 50%;\n  animation: _aml-spin_471lr_1 0.7s linear infinite;\n}\n\n@keyframes _aml-spin_471lr_1 {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Per-match detail overlay: a centered modal floating above the screen, not\n * docked in the drawer — hence the fixed, full-viewport backdrop. No portal\n * needed: nothing clips or transforms between the shadow root and the viewport,\n * so `position: fixed` covers the screen and paints above AmlHeader by DOM\n * order within the same stacking context. */\n._detailBackdrop_471lr_458 {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--aml-overlay);\n  /* Fades in/out as AmlMatchDetail toggles the `--visible` modifier below. */\n  opacity: 0;\n  transition: opacity var(--aml-transition-fast) ease;\n}\n\n._detailBackdrop--visible_471lr_470 {\n  opacity: 1;\n}\n\n._detailModal_471lr_474 {\n  display: flex;\n  flex-direction: column;\n  width: min(1296px, 92vw);\n  height: min(764px, 90vh);\n  background: var(--aml-bg);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 0.25rem 1rem var(--shadow-color);\n  /* Same choreography as .detailBackdrop, plus a slight scale-in. */\n  opacity: 0;\n  transform: scale(0.96) translateY(8px);\n  transition:\n    opacity var(--aml-transition-fast) ease,\n    transform var(--aml-transition-fast) ease;\n}\n\n._detailModal--visible_471lr_491 {\n  opacity: 1;\n  transform: none;\n}\n\n/* \"Match profile\" confirmation dialog: a centered card reusing .detailBackdrop\n * for the overlay, with the same choreography as .detailModal. */\n._confirmModal_471lr_498 {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: min(480px, 92vw);\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 16px;\n  background: var(--aml-bg);\n  border: 1px solid var(--aml-border);\n  border-radius: 16px;\n  box-shadow: 0 0.25rem 1rem var(--shadow-color);\n  opacity: 0;\n  transform: scale(0.96) translateY(8px);\n  transition:\n    opacity var(--aml-transition-fast) ease,\n    transform var(--aml-transition-fast) ease;\n}\n\n._confirmModal--visible_471lr_517 {\n  opacity: 1;\n  transform: none;\n}\n\n._confirmBody_471lr_522 {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n._confirmTitleRow_471lr_528 {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n}\n\n._confirmTitleGroup_471lr_534 {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n._confirmTitle_471lr_528 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n._confirmSubtitle_471lr_548 {\n  font-size: 16px;\n  color: var(--aml-fg-dimmed);\n  margin: 0;\n}\n\n._field_471lr_304 {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n._confirmFieldLabel_471lr_560 {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--aml-fg);\n}\n\n._textarea_471lr_566 {\n  width: 100%;\n  min-height: 80px;\n  padding: 8px 12px;\n  border: 1px solid var(--aml-border);\n  border-radius: 4px;\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 20px;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n._confirmCheckbox_471lr_581 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  color: var(--aml-fg);\n  cursor: pointer;\n}\n\n._confirmCheckboxInput_471lr_590 {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  accent-color: var(--aml-primary-bg);\n  cursor: pointer;\n}\n\n._confirmActions_471lr_598 {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n._dialogButton_471lr_604 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  padding: 8px 24px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n._dialogButtonSecondary_471lr_616 {\n  border: 1px solid var(--aml-border);\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n}\n\n._dialogButtonSecondary_471lr_616:hover {\n  background: var(--aml-hover-bg);\n}\n\n._dialogButtonPrimary_471lr_626 {\n  border: 1px solid var(--aml-primary-bg);\n  background: var(--aml-primary-bg);\n  color: var(--aml-primary-fg);\n}\n\n._dialogButtonPrimary_471lr_626:hover {\n  opacity: 0.9;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  /* A hair above zero, not 0s: useModalTransition reads this computed duration\n   * to time the unmount, so a tiny numeric value keeps that path working\n   * without a zero-duration special case. */\n  ._detailBackdrop_471lr_458,\n  ._detailModal_471lr_474,\n  ._confirmModal_471lr_498 {\n    transition-duration: 0.01ms;\n  }\n}\n\n._detailTitle_471lr_647 {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n._tabs_471lr_652 {\n  display: flex;\n  gap: 24px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--aml-border);\n  flex-shrink: 0;\n}\n\n._tab_471lr_652 {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  padding: 12px 0;\n  background: none;\n  color: var(--aml-fg-dimmed);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n._tab--active_471lr_675 {\n  border-bottom-color: var(--aml-secondary-fg);\n  color: var(--aml-secondary-fg);\n}\n\n/* Record-count pill shown next to a tab label. Neutral by default; the active\n * tab's badge picks up the secondary/blue accent to match the Figma mock. Both\n * the background and the text are fixed literals (not the themed --aml-fg): the\n * pill stays a light chip in either theme, so the text must be a fixed dark tone\n * or it turns near-white-on-near-white and unreadable in dark mode. */\n._tabBadge_471lr_685 {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: var(--aml-neutral-subtle-bg);\n  color: var(--aml-neutral-subtle-fg);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n._tabBadge--active_471lr_697 {\n  background: var(--aml-secondary-bg);\n  color: var(--aml-secondary-fg);\n}\n\n/* Segmented control that switches categories within a tab (e.g. Associations:\n * Individuals | Business). Unlike .tabBadge it is fully themed so the elevated\n * \"selected\" pill reads correctly in both light and dark: a subtle themed track\n * with the active segment lifted onto the card surface. */\n._segmentedControl_471lr_706 {\n  display: inline-flex;\n  align-self: flex-start;\n  flex-shrink: 0;\n  gap: 4px;\n  margin: 16px 16px 0;\n  padding: 4px;\n  border-radius: 4px;\n  background: var(--aml-hover-bg);\n}\n\n._segment_471lr_706 {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  padding: 4px 16px;\n  border-radius: 4px;\n  background: none;\n  color: var(--aml-fg-dimmed);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n._segment--active_471lr_732 {\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n  box-shadow:\n    0 1px 1.5px rgba(0, 0, 0, 0.05),\n    0 1px 1px rgba(0, 0, 0, 0.1);\n}\n\n._segmentCount_471lr_740 {\n  color: var(--aml-fg-dimmed);\n}\n\n._profileSections_471lr_744 {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n}\n\n._profileOverview_471lr_753 {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n}\n\n._profilePhoto_471lr_759 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n._profilePhotoPager_471lr_767 {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--aml-fg-dimmed);\n  font-size: 14px;\n}\n\n._profilePhotoPagerButton_471lr_775 {\n  display: flex;\n  border: none;\n  border-radius: 4px;\n  padding: 2px;\n  background: none;\n  color: inherit;\n  cursor: pointer;\n}\n\n._profilePhotoPagerButton_471lr_775:hover:not(:disabled) {\n  background: var(--aml-hover-bg);\n}\n\n._profilePhotoPagerButton_471lr_775:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n._profileSectionHeading_471lr_794 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 12px;\n}\n\n/* Full-width content wrapper inside a .card — the fields column next to the\n * photo, or the sole child of the Notes / Additional Information cards. */\n._profileSection_471lr_744 {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n._profileRow_471lr_810 {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n._profileLabel_471lr_816 {\n  min-width: 140px;\n  flex-shrink: 0;\n  color: var(--aml-fg-dimmed);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n._profileValue_471lr_824 {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n}\n\n._profileAddressLabel_471lr_833 {\n  font-weight: 600;\n  margin: 0;\n}\n\n._notesList_471lr_838 {\n  margin: 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n}\n\n._profileEmpty_471lr_847 {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  color: var(--aml-fg-dimmed);\n}\n\n/* --- Events + evidence -----------------------------------------------------\n * Shared by the Sanctions, Adverse Media, and Other Sources tabs: an \"Events\"\n * row where each event expands into evidence cards (Figma nodes 351:5555 /\n * 351:6641). */\n\n/* Category heading + its card, one per adverse-media / regulatory entry. */\n._eventCategory_471lr_862 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n._eventCategoryHeading_471lr_868 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--aml-fg-dimmed);\n}\n\n._eventBlock_471lr_874 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n._eventType_471lr_880 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--aml-fg);\n}\n\n._evidenceList_471lr_886 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n._evidenceToggle_471lr_893 {\n  display: inline-flex;\n  align-self: flex-start;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  background: none;\n  padding: 0;\n  color: var(--aml-fg-dimmed);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n/* Count pill next to \"Evidence\". Fixed literal background pairs with a fixed\n * literal foreground so it stays readable in either theme (same rule as\n * .tabBadge). */\n._evidenceCountPill_471lr_910 {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: var(--aml-neutral-subtle-bg);\n  color: var(--aml-neutral-subtle-fg);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n._evidenceChevron_471lr_923 {\n  transition: transform var(--aml-transition-fast) ease;\n}\n\n._evidenceChevron--open_471lr_927 {\n  transform: rotate(180deg);\n}\n\n._evidenceCards_471lr_931 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 8px;\n  width: 100%;\n}\n\n._evidenceCard_471lr_931 {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  border: 1px solid var(--aml-border);\n  border-radius: 8px;\n  background: var(--aml-hover-bg);\n}\n\n._evidenceCardTitle_471lr_948 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--aml-fg);\n}\n\n._evidenceSummaryBlock_471lr_954 {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n._evidenceSummary_471lr_954 {\n  margin: 0;\n  font-size: 14px;\n  color: var(--aml-fg);\n}\n\n._evidenceSummary--clamped_471lr_966 {\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n._evidenceReadMore_471lr_973 {\n  align-self: flex-start;\n  border: none;\n  background: none;\n  padding: 2px;\n  color: var(--aml-secondary-fg);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n._evidenceRow_471lr_984 {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  font-size: 14px;\n}\n\n._evidenceRowCenter_471lr_991 {\n  align-items: center;\n}\n\n._evidenceRowLabel_471lr_995 {\n  min-width: 140px;\n  flex-shrink: 0;\n  color: var(--aml-fg-dimmed);\n}\n\n._evidenceRowValue_471lr_1001 {\n  flex: 1;\n  min-width: 0;\n  font-weight: 600;\n  color: var(--aml-fg);\n  overflow-wrap: anywhere;\n}\n\n._evidenceLinkValue_471lr_1009 {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n._evidenceLinkText_471lr_1017 {\n  flex: 1;\n  min-width: 0;\n  color: var(--aml-secondary-fg);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n  text-decoration: none;\n}\n\n._evidenceLinkText_471lr_1017:hover {\n  text-decoration: underline;\n}\n\n._evidenceIconButtons_471lr_1030 {\n  display: inline-flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n._evidenceIconButton_471lr_1030 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--aml-border);\n  border-radius: 4px;\n  background: var(--aml-bg);\n  color: var(--aml-fg);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n._evidenceIconButton_471lr_1030:hover {\n  background: var(--aml-hover-bg);\n}\n/*$vite$:1*/"));			document.head.appendChild(elementStyle);		}	} catch (e) {		console.error("vite-plugin-css-injected-by-js", e);	}})();
import React, { createContext, createElement, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/typeof.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
	return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/objectSpread2.js
function ownKeys(e, r) {
	var t = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(e);
		r && (o = o.filter(function(r) {
			return Object.getOwnPropertyDescriptor(e, r).enumerable;
		})), t.push.apply(t, o);
	}
	return t;
}
function _objectSpread2(e) {
	for (var r = 1; r < arguments.length; r++) {
		var t = null != arguments[r] ? arguments[r] : {};
		r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
			_defineProperty(e, r, t[r]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
			Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
		});
	}
	return e;
}
//#endregion
//#region ../../node_modules/react-i18next/dist/es/utils.js
var warn = (i18n, code, msg, rest) => {
	var _i18n$services, _i18n$services2, _console;
	const args = [msg, _objectSpread2({ code }, rest || {})];
	if (i18n === null || i18n === void 0 || (_i18n$services = i18n.services) === null || _i18n$services === void 0 || (_i18n$services = _i18n$services.logger) === null || _i18n$services === void 0 ? void 0 : _i18n$services.forward) return i18n.services.logger.forward(args, "warn", "react-i18next::", true);
	if (isString$1(args[0])) args[0] = `react-i18next:: ${args[0]}`;
	if (i18n === null || i18n === void 0 || (_i18n$services2 = i18n.services) === null || _i18n$services2 === void 0 || (_i18n$services2 = _i18n$services2.logger) === null || _i18n$services2 === void 0 ? void 0 : _i18n$services2.warn) i18n.services.logger.warn(...args);
	else if ((_console = console) === null || _console === void 0 ? void 0 : _console.warn) console.warn(...args);
};
var alreadyWarned = {};
var warnOnce = (i18n, code, msg, rest) => {
	if (isString$1(msg) && alreadyWarned[msg]) return;
	if (isString$1(msg)) alreadyWarned[msg] = /* @__PURE__ */ new Date();
	warn(i18n, code, msg, rest);
};
var loadedClb = (i18n, cb) => () => {
	if (i18n.isInitialized) cb();
	else {
		const initialized = () => {
			setTimeout(() => {
				i18n.off("initialized", initialized);
			}, 0);
			cb();
		};
		i18n.on("initialized", initialized);
	}
};
var loadNamespaces$1 = (i18n, ns, cb) => {
	i18n.loadNamespaces(ns, loadedClb(i18n, cb));
};
var loadLanguages$1 = (i18n, lng, ns, cb) => {
	if (isString$1(ns)) ns = [ns];
	if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return loadNamespaces$1(i18n, ns, cb);
	ns.forEach((n) => {
		if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
	});
	i18n.loadLanguages(lng, loadedClb(i18n, cb));
};
var hasLoadedNamespace$1 = (ns, i18n, options = {}) => {
	if (!i18n.languages || !i18n.languages.length) {
		warnOnce(i18n, "NO_LANGUAGES", "i18n.languages were undefined or empty", { languages: i18n.languages });
		return true;
	}
	return i18n.hasLoadedNamespace(ns, {
		lng: options.lng,
		precheck: (i18nInstance, loadNotPending) => {
			if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
		}
	});
};
var isString$1 = (obj) => typeof obj === "string";
var isObject = (obj) => typeof obj === "object" && obj !== null;
//#endregion
//#region ../../node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
	"&amp;": "&",
	"&#38;": "&",
	"&lt;": "<",
	"&#60;": "<",
	"&gt;": ">",
	"&#62;": ">",
	"&apos;": "'",
	"&#39;": "'",
	"&quot;": "\"",
	"&#34;": "\"",
	"&nbsp;": " ",
	"&#160;": " ",
	"&copy;": "©",
	"&#169;": "©",
	"&reg;": "®",
	"&#174;": "®",
	"&hellip;": "…",
	"&#8230;": "…",
	"&#x2F;": "/",
	"&#47;": "/"
};
var unescapeHtmlEntity = (m) => htmlEntities[m];
var unescape = (text) => text.replace(matchHtmlEntity, unescapeHtmlEntity);
//#endregion
//#region ../../node_modules/react-i18next/dist/es/defaults.js
var defaultOptions = {
	bindI18n: "languageChanged",
	bindI18nStore: "",
	transEmptyNodeValue: "",
	transSupportBasicHtmlNodes: true,
	transWrapTextNodes: "",
	transKeepBasicHtmlNodesFor: [
		"br",
		"strong",
		"i",
		"p"
	],
	useSuspense: true,
	unescape
};
var setDefaults = (options = {}) => {
	defaultOptions = _objectSpread2(_objectSpread2({}, defaultOptions), options);
};
var getDefaults = () => defaultOptions;
//#endregion
//#region ../../node_modules/react-i18next/dist/es/i18nInstance.js
var i18nInstance;
var setI18n = (instance) => {
	i18nInstance = instance;
};
var getI18n = () => i18nInstance;
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose$1(r, e) {
	if (null == r) return {};
	var t = {};
	for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
		if (e.includes(n)) continue;
		t[n] = r[n];
	}
	return t;
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties$1(e, t) {
	if (null == e) return {};
	var o, r, i = _objectWithoutPropertiesLoose$1(e, t);
	if (Object.getOwnPropertySymbols) {
		var s = Object.getOwnPropertySymbols(e);
		for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	}
	return i;
}
//#endregion
//#region ../../node_modules/react-i18next/dist/es/initReactI18next.js
var initReactI18next = {
	type: "3rdParty",
	init(instance) {
		setDefaults(instance.options.react);
		setI18n(instance);
	}
};
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(n, t, e, r, o, a, c) {
	try {
		var i = n[a](c), u = i.value;
	} catch (n) {
		e(n);
		return;
	}
	i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
	return function() {
		var t = this, e = arguments;
		return new Promise(function(r, o) {
			var a = n.apply(t, e);
			function _next(n) {
				asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
			}
			function _throw(n) {
				asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
			}
			_next(void 0);
		});
	};
}
//#endregion
//#region ../../node_modules/react-i18next/dist/es/context.js
var I18nContext = createContext();
var ReportNamespaces = class {
	constructor() {
		this.usedNamespaces = {};
	}
	addUsedNamespaces(namespaces) {
		namespaces.forEach((ns) => {
			if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
		});
	}
	getUsedNamespaces() {
		return Object.keys(this.usedNamespaces);
	}
};
//#endregion
//#region ../../node_modules/react-i18next/dist/es/useTranslation.js
var usePrevious = (value, ignore) => {
	const ref = useRef();
	useEffect(() => {
		ref.current = ignore ? ref.current : value;
	}, [value, ignore]);
	return ref.current;
};
var alwaysNewT = (i18n, language, namespace, keyPrefix) => i18n.getFixedT(language, namespace, keyPrefix);
var useMemoizedT = (i18n, language, namespace, keyPrefix) => useCallback(alwaysNewT(i18n, language, namespace, keyPrefix), [
	i18n,
	language,
	namespace,
	keyPrefix
]);
var useTranslation = (ns, props = {}) => {
	var _i18n$options$react, _i18n$options, _i18n$reportNamespace, _i18n$reportNamespace2;
	const { i18n: i18nFromProps } = props;
	const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = useContext(I18nContext) || {};
	const i18n = i18nFromProps || i18nFromContext || getI18n();
	if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
	if (!i18n) {
		warnOnce(i18n, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
		const notReadyT = (k, optsOrDefaultValue) => {
			if (isString$1(optsOrDefaultValue)) return optsOrDefaultValue;
			if (isObject(optsOrDefaultValue) && isString$1(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
			return Array.isArray(k) ? k[k.length - 1] : k;
		};
		const retNotReady = [
			notReadyT,
			{},
			false
		];
		retNotReady.t = notReadyT;
		retNotReady.i18n = {};
		retNotReady.ready = false;
		return retNotReady;
	}
	if ((_i18n$options$react = i18n.options.react) === null || _i18n$options$react === void 0 ? void 0 : _i18n$options$react.wait) warnOnce(i18n, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
	const i18nOptions = _objectSpread2(_objectSpread2(_objectSpread2({}, getDefaults()), i18n.options.react), props);
	const { useSuspense, keyPrefix } = i18nOptions;
	let namespaces = ns || defaultNSFromContext || ((_i18n$options = i18n.options) === null || _i18n$options === void 0 ? void 0 : _i18n$options.defaultNS);
	namespaces = isString$1(namespaces) ? [namespaces] : namespaces || ["translation"];
	(_i18n$reportNamespace = (_i18n$reportNamespace2 = i18n.reportNamespaces).addUsedNamespaces) === null || _i18n$reportNamespace === void 0 || _i18n$reportNamespace.call(_i18n$reportNamespace2, namespaces);
	const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n) => hasLoadedNamespace$1(n, i18n, i18nOptions));
	const memoGetT = useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
	const getT = () => memoGetT;
	const getNewT = () => alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
	const [t, setT] = useState(getT);
	let joinedNS = namespaces.join();
	if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
	const previousJoinedNS = usePrevious(joinedNS);
	const isMounted = useRef(true);
	useEffect(() => {
		const { bindI18n, bindI18nStore } = i18nOptions;
		isMounted.current = true;
		if (!ready && !useSuspense) if (props.lng) loadLanguages$1(i18n, props.lng, namespaces, () => {
			if (isMounted.current) setT(getNewT);
		});
		else loadNamespaces$1(i18n, namespaces, () => {
			if (isMounted.current) setT(getNewT);
		});
		if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
		const boundReset = () => {
			if (isMounted.current) setT(getNewT);
		};
		if (bindI18n) i18n === null || i18n === void 0 || i18n.on(bindI18n, boundReset);
		if (bindI18nStore) i18n === null || i18n === void 0 || i18n.store.on(bindI18nStore, boundReset);
		return () => {
			isMounted.current = false;
			if (i18n && bindI18n) bindI18n === null || bindI18n === void 0 || bindI18n.split(" ").forEach((e) => i18n.off(e, boundReset));
			if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e) => i18n.store.off(e, boundReset));
		};
	}, [i18n, joinedNS]);
	useEffect(() => {
		if (isMounted.current && ready) setT(getT);
	}, [
		i18n,
		keyPrefix,
		ready
	]);
	const ret = [
		t,
		i18n,
		ready
	];
	ret.t = t;
	ret.i18n = i18n;
	ret.ready = ready;
	if (ready) return ret;
	if (!ready && !useSuspense) return ret;
	throw new Promise((resolve) => {
		if (props.lng) loadLanguages$1(i18n, props.lng, namespaces, () => resolve());
		else loadNamespaces$1(i18n, namespaces, () => resolve());
	});
};
//#endregion
//#region ../../node_modules/react-i18next/dist/es/I18nextProvider.js
function I18nextProvider({ i18n, defaultNS, children }) {
	const value = useMemo(() => ({
		i18n,
		defaultNS
	}), [i18n, defaultNS]);
	return createElement(I18nContext.Provider, { value }, children);
}
//#endregion
//#region ../../node_modules/i18next/dist/esm/i18next.js
var isString = (obj) => typeof obj === "string";
var defer = () => {
	let res;
	let rej;
	const promise = new Promise((resolve, reject) => {
		res = resolve;
		rej = reject;
	});
	promise.resolve = res;
	promise.reject = rej;
	return promise;
};
var makeString = (object) => {
	if (object == null) return "";
	return "" + object;
};
var copy = (a, s, t) => {
	a.forEach((m) => {
		if (s[m]) t[m] = s[m];
	});
};
var lastOfPathSeparatorRegExp = /###/g;
var cleanKey = (key) => key && key.indexOf("###") > -1 ? key.replace(lastOfPathSeparatorRegExp, ".") : key;
var canNotTraverseDeeper = (object) => !object || isString(object);
var getLastOfPath = (object, path, Empty) => {
	const stack = !isString(path) ? path : path.split(".");
	let stackIndex = 0;
	while (stackIndex < stack.length - 1) {
		if (canNotTraverseDeeper(object)) return {};
		const key = cleanKey(stack[stackIndex]);
		if (!object[key] && Empty) object[key] = new Empty();
		if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
		else object = {};
		++stackIndex;
	}
	if (canNotTraverseDeeper(object)) return {};
	return {
		obj: object,
		k: cleanKey(stack[stackIndex])
	};
};
var setPath = (object, path, newValue) => {
	const { obj, k } = getLastOfPath(object, path, Object);
	if (obj !== void 0 || path.length === 1) {
		obj[k] = newValue;
		return;
	}
	let e = path[path.length - 1];
	let p = path.slice(0, path.length - 1);
	let last = getLastOfPath(object, p, Object);
	while (last.obj === void 0 && p.length) {
		e = `${p[p.length - 1]}.${e}`;
		p = p.slice(0, p.length - 1);
		last = getLastOfPath(object, p, Object);
		if ((last === null || last === void 0 ? void 0 : last.obj) && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = void 0;
	}
	last.obj[`${last.k}.${e}`] = newValue;
};
var pushPath = (object, path, newValue, concat) => {
	const { obj, k } = getLastOfPath(object, path, Object);
	obj[k] = obj[k] || [];
	obj[k].push(newValue);
};
var getPath = (object, path) => {
	const { obj, k } = getLastOfPath(object, path);
	if (!obj) return void 0;
	if (!Object.prototype.hasOwnProperty.call(obj, k)) return void 0;
	return obj[k];
};
var getPathWithDefaults = (data, defaultData, key) => {
	const value = getPath(data, key);
	if (value !== void 0) return value;
	return getPath(defaultData, key);
};
var deepExtend = (target, source, overwrite) => {
	for (const prop in source) if (prop !== "__proto__" && prop !== "constructor") if (prop in target) if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
		if (overwrite) target[prop] = source[prop];
	} else deepExtend(target[prop], source[prop], overwrite);
	else target[prop] = source[prop];
	return target;
};
var regexEscape = (str) => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var _entityMap = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;",
	"/": "&#x2F;"
};
var escape = (data) => {
	if (isString(data)) return data.replace(/[&<>"'\/]/g, (s) => _entityMap[s]);
	return data;
};
var RegExpCache = class {
	constructor(capacity) {
		this.capacity = capacity;
		this.regExpMap = /* @__PURE__ */ new Map();
		this.regExpQueue = [];
	}
	getRegExp(pattern) {
		const regExpFromCache = this.regExpMap.get(pattern);
		if (regExpFromCache !== void 0) return regExpFromCache;
		const regExpNew = new RegExp(pattern);
		if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
		this.regExpMap.set(pattern, regExpNew);
		this.regExpQueue.push(pattern);
		return regExpNew;
	}
};
var chars = [
	" ",
	",",
	"?",
	"!",
	";"
];
var looksLikeObjectPathRegExpCache = new RegExpCache(20);
var looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
	nsSeparator = nsSeparator || "";
	keySeparator = keySeparator || "";
	const possibleChars = chars.filter((c) => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
	if (possibleChars.length === 0) return true;
	const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c) => c === "?" ? "\\?" : c).join("|")})`);
	let matched = !r.test(key);
	if (!matched) {
		const ki = key.indexOf(keySeparator);
		if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
	}
	return matched;
};
var deepFind = function(obj, path) {
	let keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
	if (!obj) return void 0;
	if (obj[path]) {
		if (!Object.prototype.hasOwnProperty.call(obj, path)) return void 0;
		return obj[path];
	}
	const tokens = path.split(keySeparator);
	let current = obj;
	for (let i = 0; i < tokens.length;) {
		if (!current || typeof current !== "object") return;
		let next;
		let nextPath = "";
		for (let j = i; j < tokens.length; ++j) {
			if (j !== i) nextPath += keySeparator;
			nextPath += tokens[j];
			next = current[nextPath];
			if (next !== void 0) {
				if ([
					"string",
					"number",
					"boolean"
				].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
				i += j - i + 1;
				break;
			}
		}
		current = next;
	}
	return current;
};
var getCleanedCode = (code) => code === null || code === void 0 ? void 0 : code.replace("_", "-");
var consoleLogger = {
	type: "logger",
	log(args) {
		this.output("log", args);
	},
	warn(args) {
		this.output("warn", args);
	},
	error(args) {
		this.output("error", args);
	},
	output(type, args) {
		var _console, _console$apply;
		(_console = console) === null || _console === void 0 || (_console = _console[type]) === null || _console === void 0 || (_console$apply = _console.apply) === null || _console$apply === void 0 || _console$apply.call(_console, console, args);
	}
};
var baseLogger = new class Logger {
	constructor(concreteLogger) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		this.init(concreteLogger, options);
	}
	init(concreteLogger) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		this.prefix = options.prefix || "i18next:";
		this.logger = concreteLogger || consoleLogger;
		this.options = options;
		this.debug = options.debug;
	}
	log() {
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		return this.forward(args, "log", "", true);
	}
	warn() {
		for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
		return this.forward(args, "warn", "", true);
	}
	error() {
		for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
		return this.forward(args, "error", "");
	}
	deprecate() {
		for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
		return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
	}
	forward(args, lvl, prefix, debugOnly) {
		if (debugOnly && !this.debug) return null;
		if (isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
		return this.logger[lvl](args);
	}
	create(moduleName) {
		return new Logger(this.logger, _objectSpread2(_objectSpread2({}, { prefix: `${this.prefix}:${moduleName}:` }), this.options));
	}
	clone(options) {
		options = options || this.options;
		options.prefix = options.prefix || this.prefix;
		return new Logger(this.logger, options);
	}
}();
var EventEmitter = class {
	constructor() {
		this.observers = {};
	}
	on(events, listener) {
		events.split(" ").forEach((event) => {
			if (!this.observers[event]) this.observers[event] = /* @__PURE__ */ new Map();
			const numListeners = this.observers[event].get(listener) || 0;
			this.observers[event].set(listener, numListeners + 1);
		});
		return this;
	}
	off(event, listener) {
		if (!this.observers[event]) return;
		if (!listener) {
			delete this.observers[event];
			return;
		}
		this.observers[event].delete(listener);
	}
	emit(event) {
		for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
		if (this.observers[event]) Array.from(this.observers[event].entries()).forEach((_ref) => {
			let [observer, numTimesAdded] = _ref;
			for (let i = 0; i < numTimesAdded; i++) observer(...args);
		});
		if (this.observers["*"]) Array.from(this.observers["*"].entries()).forEach((_ref2) => {
			let [observer, numTimesAdded] = _ref2;
			for (let i = 0; i < numTimesAdded; i++) observer.apply(observer, [event, ...args]);
		});
	}
};
var ResourceStore = class extends EventEmitter {
	constructor(data) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
			ns: ["translation"],
			defaultNS: "translation"
		};
		super();
		this.data = data || {};
		this.options = options;
		if (this.options.keySeparator === void 0) this.options.keySeparator = ".";
		if (this.options.ignoreJSONStructure === void 0) this.options.ignoreJSONStructure = true;
	}
	addNamespaces(ns) {
		if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
	}
	removeNamespaces(ns) {
		const index = this.options.ns.indexOf(ns);
		if (index > -1) this.options.ns.splice(index, 1);
	}
	getResource(lng, ns, key) {
		var _this$data;
		let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
		const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
		const ignoreJSONStructure = options.ignoreJSONStructure !== void 0 ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
		let path;
		if (lng.indexOf(".") > -1) path = lng.split(".");
		else {
			path = [lng, ns];
			if (key) if (Array.isArray(key)) path.push(...key);
			else if (isString(key) && keySeparator) path.push(...key.split(keySeparator));
			else path.push(key);
		}
		const result = getPath(this.data, path);
		if (!result && !ns && !key && lng.indexOf(".") > -1) {
			lng = path[0];
			ns = path[1];
			key = path.slice(2).join(".");
		}
		if (result || !ignoreJSONStructure || !isString(key)) return result;
		return deepFind((_this$data = this.data) === null || _this$data === void 0 || (_this$data = _this$data[lng]) === null || _this$data === void 0 ? void 0 : _this$data[ns], key, keySeparator);
	}
	addResource(lng, ns, key, value) {
		let options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : { silent: false };
		const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
		let path = [lng, ns];
		if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
		if (lng.indexOf(".") > -1) {
			path = lng.split(".");
			value = ns;
			ns = path[1];
		}
		this.addNamespaces(ns);
		setPath(this.data, path, value);
		if (!options.silent) this.emit("added", lng, ns, key, value);
	}
	addResources(lng, ns, resources) {
		let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : { silent: false };
		for (const m in resources) if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], { silent: true });
		if (!options.silent) this.emit("added", lng, ns, resources);
	}
	addResourceBundle(lng, ns, resources, deep, overwrite) {
		let options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
			silent: false,
			skipCopy: false
		};
		let path = [lng, ns];
		if (lng.indexOf(".") > -1) {
			path = lng.split(".");
			deep = resources;
			resources = ns;
			ns = path[1];
		}
		this.addNamespaces(ns);
		let pack = getPath(this.data, path) || {};
		if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
		if (deep) deepExtend(pack, resources, overwrite);
		else pack = _objectSpread2(_objectSpread2({}, pack), resources);
		setPath(this.data, path, pack);
		if (!options.silent) this.emit("added", lng, ns, resources);
	}
	removeResourceBundle(lng, ns) {
		if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
		this.removeNamespaces(ns);
		this.emit("removed", lng, ns);
	}
	hasResourceBundle(lng, ns) {
		return this.getResource(lng, ns) !== void 0;
	}
	getResourceBundle(lng, ns) {
		if (!ns) ns = this.options.defaultNS;
		return this.getResource(lng, ns);
	}
	getDataByLanguage(lng) {
		return this.data[lng];
	}
	hasLanguageSomeTranslations(lng) {
		const data = this.getDataByLanguage(lng);
		return !!(data && Object.keys(data) || []).find((v) => data[v] && Object.keys(data[v]).length > 0);
	}
	toJSON() {
		return this.data;
	}
};
var postProcessor = {
	processors: {},
	addPostProcessor(module) {
		this.processors[module.name] = module;
	},
	handle(processors, value, key, options, translator) {
		processors.forEach((processor) => {
			var _this$processors$proc, _this$processors$proc2;
			value = (_this$processors$proc = (_this$processors$proc2 = this.processors[processor]) === null || _this$processors$proc2 === void 0 ? void 0 : _this$processors$proc2.process(value, key, options, translator)) !== null && _this$processors$proc !== void 0 ? _this$processors$proc : value;
		});
		return value;
	}
};
var checkedLoadedFor = {};
var shouldHandleAsObject = (res) => !isString(res) && typeof res !== "boolean" && typeof res !== "number";
var Translator = class Translator extends EventEmitter {
	constructor(services) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		super();
		copy([
			"resourceStore",
			"languageUtils",
			"pluralResolver",
			"interpolator",
			"backendConnector",
			"i18nFormat",
			"utils"
		], services, this);
		this.options = options;
		if (this.options.keySeparator === void 0) this.options.keySeparator = ".";
		this.logger = baseLogger.create("translator");
	}
	changeLanguage(lng) {
		if (lng) this.language = lng;
	}
	exists(key) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { interpolation: {} };
		if (key == null) return false;
		const resolved = this.resolve(key, options);
		return (resolved === null || resolved === void 0 ? void 0 : resolved.res) !== void 0;
	}
	extractFromKey(key, options) {
		let nsSeparator = options.nsSeparator !== void 0 ? options.nsSeparator : this.options.nsSeparator;
		if (nsSeparator === void 0) nsSeparator = ":";
		const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
		let namespaces = options.ns || this.options.defaultNS || [];
		const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
		const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
		if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
			const m = key.match(this.interpolator.nestingRegexp);
			if (m && m.length > 0) return {
				key,
				namespaces: isString(namespaces) ? [namespaces] : namespaces
			};
			const parts = key.split(nsSeparator);
			if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
			key = parts.join(keySeparator);
		}
		return {
			key,
			namespaces: isString(namespaces) ? [namespaces] : namespaces
		};
	}
	translate(keys, options, lastKey) {
		if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
		if (typeof options === "object") options = _objectSpread2({}, options);
		if (!options) options = {};
		if (keys == null) return "";
		if (!Array.isArray(keys)) keys = [String(keys)];
		const returnDetails = options.returnDetails !== void 0 ? options.returnDetails : this.options.returnDetails;
		const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
		const { key, namespaces } = this.extractFromKey(keys[keys.length - 1], options);
		const namespace = namespaces[namespaces.length - 1];
		const lng = options.lng || this.language;
		const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
		if ((lng === null || lng === void 0 ? void 0 : lng.toLowerCase()) === "cimode") {
			if (appendNamespaceToCIMode) {
				const nsSeparator = options.nsSeparator || this.options.nsSeparator;
				if (returnDetails) return {
					res: `${namespace}${nsSeparator}${key}`,
					usedKey: key,
					exactUsedKey: key,
					usedLng: lng,
					usedNS: namespace,
					usedParams: this.getUsedParamsDetails(options)
				};
				return `${namespace}${nsSeparator}${key}`;
			}
			if (returnDetails) return {
				res: key,
				usedKey: key,
				exactUsedKey: key,
				usedLng: lng,
				usedNS: namespace,
				usedParams: this.getUsedParamsDetails(options)
			};
			return key;
		}
		const resolved = this.resolve(keys, options);
		let res = resolved === null || resolved === void 0 ? void 0 : resolved.res;
		const resUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.usedKey) || key;
		const resExactUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.exactUsedKey) || key;
		const noObject = [
			"[object Number]",
			"[object Function]",
			"[object RegExp]"
		];
		const joinArrays = options.joinArrays !== void 0 ? options.joinArrays : this.options.joinArrays;
		const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
		const needsPluralHandling = options.count !== void 0 && !isString(options.count);
		const hasDefaultValue = Translator.hasDefaultValue(options);
		const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
		const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, { ordinal: false }) : "";
		const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
		const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
		let resForObjHndl = res;
		if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
		const handleAsObject = shouldHandleAsObject(resForObjHndl);
		const resType = Object.prototype.toString.apply(resForObjHndl);
		if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(resForObjHndl))) {
			if (!options.returnObjects && !this.options.returnObjects) {
				if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
				const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, _objectSpread2(_objectSpread2({}, options), {}, { ns: namespaces })) : `key '${key} (${this.language})' returned an object instead of string.`;
				if (returnDetails) {
					resolved.res = r;
					resolved.usedParams = this.getUsedParamsDetails(options);
					return resolved;
				}
				return r;
			}
			if (keySeparator) {
				const resTypeIsArray = Array.isArray(resForObjHndl);
				const copy = resTypeIsArray ? [] : {};
				const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
				for (const m in resForObjHndl) if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
					const deepKey = `${newKeyToUse}${keySeparator}${m}`;
					if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, _objectSpread2(_objectSpread2({}, options), {}, { defaultValue: shouldHandleAsObject(defaultValue) ? defaultValue[m] : void 0 }, {
						joinArrays: false,
						ns: namespaces
					}));
					else copy[m] = this.translate(deepKey, _objectSpread2(_objectSpread2({}, options), {
						joinArrays: false,
						ns: namespaces
					}));
					if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
				}
				res = copy;
			}
		} else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
			res = res.join(joinArrays);
			if (res) res = this.extendTranslation(res, keys, options, lastKey);
		} else {
			let usedDefault = false;
			let usedKey = false;
			if (!this.isValidLookup(res) && hasDefaultValue) {
				usedDefault = true;
				res = defaultValue;
			}
			if (!this.isValidLookup(res)) {
				usedKey = true;
				res = key;
			}
			const resForMissing = (options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && usedKey ? void 0 : res;
			const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
			if (usedKey || usedDefault || updateMissing) {
				this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
				if (keySeparator) {
					const fk = this.resolve(key, _objectSpread2(_objectSpread2({}, options), {}, { keySeparator: false }));
					if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
				}
				let lngs = [];
				const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
				if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for (let i = 0; i < fallbackLngs.length; i++) lngs.push(fallbackLngs[i]);
				else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
				else lngs.push(options.lng || this.language);
				const send = (l, k, specificDefaultValue) => {
					var _this$backendConnecto;
					const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
					if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
					else if ((_this$backendConnecto = this.backendConnector) === null || _this$backendConnecto === void 0 ? void 0 : _this$backendConnecto.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
					this.emit("missingKey", l, namespace, k, res);
				};
				if (this.options.saveMissing) if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language) => {
					const suffixes = this.pluralResolver.getSuffixes(language, options);
					if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
					suffixes.forEach((suffix) => {
						send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
					});
				});
				else send(lngs, key, defaultValue);
			}
			res = this.extendTranslation(res, keys, options, resolved, lastKey);
			if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
			if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : void 0);
		}
		if (returnDetails) {
			resolved.res = res;
			resolved.usedParams = this.getUsedParamsDetails(options);
			return resolved;
		}
		return res;
	}
	extendTranslation(res, key, options, resolved, lastKey) {
		var _this$i18nFormat;
		var _this = this;
		if ((_this$i18nFormat = this.i18nFormat) === null || _this$i18nFormat === void 0 ? void 0 : _this$i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread2(_objectSpread2({}, this.options.interpolation.defaultVariables), options), options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved });
		else if (!options.skipInterpolation) {
			var _options$interpolatio;
			if (options.interpolation) this.interpolator.init(_objectSpread2(_objectSpread2({}, options), { interpolation: _objectSpread2(_objectSpread2({}, this.options.interpolation), options.interpolation) }));
			const skipOnVariables = isString(res) && ((options === null || options === void 0 || (_options$interpolatio = options.interpolation) === null || _options$interpolatio === void 0 ? void 0 : _options$interpolatio.skipOnVariables) !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
			let nestBef;
			if (skipOnVariables) {
				const nb = res.match(this.interpolator.nestingRegexp);
				nestBef = nb && nb.length;
			}
			let data = options.replace && !isString(options.replace) ? options.replace : options;
			if (this.options.interpolation.defaultVariables) data = _objectSpread2(_objectSpread2({}, this.options.interpolation.defaultVariables), data);
			res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
			if (skipOnVariables) {
				const na = res.match(this.interpolator.nestingRegexp);
				const nestAft = na && na.length;
				if (nestBef < nestAft) options.nest = false;
			}
			if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
			if (options.nest !== false) res = this.interpolator.nest(res, function() {
				for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
				if ((lastKey === null || lastKey === void 0 ? void 0 : lastKey[0]) === args[0] && !options.context) {
					_this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
					return null;
				}
				return _this.translate(...args, key);
			}, options);
			if (options.interpolation) this.interpolator.reset();
		}
		const postProcess = options.postProcess || this.options.postProcess;
		const postProcessorNames = isString(postProcess) ? [postProcess] : postProcess;
		if (res != null && (postProcessorNames === null || postProcessorNames === void 0 ? void 0 : postProcessorNames.length) && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread2({ i18nResolved: _objectSpread2(_objectSpread2({}, resolved), {}, { usedParams: this.getUsedParamsDetails(options) }) }, options) : options, this);
		return res;
	}
	resolve(keys) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let found;
		let usedKey;
		let exactUsedKey;
		let usedLng;
		let usedNS;
		if (isString(keys)) keys = [keys];
		keys.forEach((k) => {
			if (this.isValidLookup(found)) return;
			const extracted = this.extractFromKey(k, options);
			const key = extracted.key;
			usedKey = key;
			let namespaces = extracted.namespaces;
			if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
			const needsPluralHandling = options.count !== void 0 && !isString(options.count);
			const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
			const needsContextHandling = options.context !== void 0 && (isString(options.context) || typeof options.context === "number") && options.context !== "";
			const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
			namespaces.forEach((ns) => {
				var _this$utils, _this$utils2;
				if (this.isValidLookup(found)) return;
				usedNS = ns;
				if (!checkedLoadedFor[`${codes[0]}-${ns}`] && ((_this$utils = this.utils) === null || _this$utils === void 0 ? void 0 : _this$utils.hasLoadedNamespace) && !((_this$utils2 = this.utils) === null || _this$utils2 === void 0 ? void 0 : _this$utils2.hasLoadedNamespace(usedNS))) {
					checkedLoadedFor[`${codes[0]}-${ns}`] = true;
					this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
				}
				codes.forEach((code) => {
					var _this$i18nFormat2;
					if (this.isValidLookup(found)) return;
					usedLng = code;
					const finalKeys = [key];
					if ((_this$i18nFormat2 = this.i18nFormat) === null || _this$i18nFormat2 === void 0 ? void 0 : _this$i18nFormat2.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
					else {
						let pluralSuffix;
						if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
						const zeroSuffix = `${this.options.pluralSeparator}zero`;
						const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
						if (needsPluralHandling) {
							finalKeys.push(key + pluralSuffix);
							if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
							if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
						}
						if (needsContextHandling) {
							const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
							finalKeys.push(contextKey);
							if (needsPluralHandling) {
								finalKeys.push(contextKey + pluralSuffix);
								if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
								if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
							}
						}
					}
					let possibleKey;
					while (possibleKey = finalKeys.pop()) if (!this.isValidLookup(found)) {
						exactUsedKey = possibleKey;
						found = this.getResource(code, ns, possibleKey, options);
					}
				});
			});
		});
		return {
			res: found,
			usedKey,
			exactUsedKey,
			usedLng,
			usedNS
		};
	}
	isValidLookup(res) {
		return res !== void 0 && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
	}
	getResource(code, ns, key) {
		var _this$i18nFormat3;
		let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
		if ((_this$i18nFormat3 = this.i18nFormat) === null || _this$i18nFormat3 === void 0 ? void 0 : _this$i18nFormat3.getResource) return this.i18nFormat.getResource(code, ns, key, options);
		return this.resourceStore.getResource(code, ns, key, options);
	}
	getUsedParamsDetails() {
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		const optionsKeys = [
			"defaultValue",
			"ordinal",
			"context",
			"replace",
			"lng",
			"lngs",
			"fallbackLng",
			"ns",
			"keySeparator",
			"nsSeparator",
			"returnObjects",
			"returnDetails",
			"joinArrays",
			"postProcess",
			"interpolation"
		];
		const useOptionsReplaceForData = options.replace && !isString(options.replace);
		let data = useOptionsReplaceForData ? options.replace : options;
		if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
		if (this.options.interpolation.defaultVariables) data = _objectSpread2(_objectSpread2({}, this.options.interpolation.defaultVariables), data);
		if (!useOptionsReplaceForData) {
			data = _objectSpread2({}, data);
			for (const key of optionsKeys) delete data[key];
		}
		return data;
	}
	static hasDefaultValue(options) {
		const prefix = "defaultValue";
		for (const option in options) if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, 12) && void 0 !== options[option]) return true;
		return false;
	}
};
var LanguageUtil = class {
	constructor(options) {
		this.options = options;
		this.supportedLngs = this.options.supportedLngs || false;
		this.logger = baseLogger.create("languageUtils");
	}
	getScriptPartFromCode(code) {
		code = getCleanedCode(code);
		if (!code || code.indexOf("-") < 0) return null;
		const p = code.split("-");
		if (p.length === 2) return null;
		p.pop();
		if (p[p.length - 1].toLowerCase() === "x") return null;
		return this.formatLanguageCode(p.join("-"));
	}
	getLanguagePartFromCode(code) {
		code = getCleanedCode(code);
		if (!code || code.indexOf("-") < 0) return code;
		const p = code.split("-");
		return this.formatLanguageCode(p[0]);
	}
	formatLanguageCode(code) {
		if (isString(code) && code.indexOf("-") > -1) {
			let formattedCode;
			try {
				formattedCode = Intl.getCanonicalLocales(code)[0];
			} catch (e) {}
			if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
			if (formattedCode) return formattedCode;
			if (this.options.lowerCaseLng) return code.toLowerCase();
			return code;
		}
		return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	}
	isSupportedCode(code) {
		if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
		return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
	}
	getBestMatchFromCodes(codes) {
		if (!codes) return null;
		let found;
		codes.forEach((code) => {
			if (found) return;
			const cleanedLng = this.formatLanguageCode(code);
			if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
		});
		if (!found && this.options.supportedLngs) codes.forEach((code) => {
			if (found) return;
			const lngOnly = this.getLanguagePartFromCode(code);
			if (this.isSupportedCode(lngOnly)) return found = lngOnly;
			found = this.options.supportedLngs.find((supportedLng) => {
				if (supportedLng === lngOnly) return supportedLng;
				if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
				if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
				if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
			});
		});
		if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
		return found;
	}
	getFallbackCodes(fallbacks, code) {
		if (!fallbacks) return [];
		if (typeof fallbacks === "function") fallbacks = fallbacks(code);
		if (isString(fallbacks)) fallbacks = [fallbacks];
		if (Array.isArray(fallbacks)) return fallbacks;
		if (!code) return fallbacks.default || [];
		let found = fallbacks[code];
		if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
		if (!found) found = fallbacks[this.formatLanguageCode(code)];
		if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
		if (!found) found = fallbacks.default;
		return found || [];
	}
	toResolveHierarchy(code, fallbackCode) {
		const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
		const codes = [];
		const addCode = (c) => {
			if (!c) return;
			if (this.isSupportedCode(c)) codes.push(c);
			else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
		};
		if (isString(code) && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
			if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
			if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
			if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
		} else if (isString(code)) addCode(this.formatLanguageCode(code));
		fallbackCodes.forEach((fc) => {
			if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
		});
		return codes;
	}
};
var suffixesOrder = {
	zero: 0,
	one: 1,
	two: 2,
	few: 3,
	many: 4,
	other: 5
};
var dummyRule = {
	select: (count) => count === 1 ? "one" : "other",
	resolvedOptions: () => ({ pluralCategories: ["one", "other"] })
};
var PluralResolver = class {
	constructor(languageUtils) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		this.languageUtils = languageUtils;
		this.options = options;
		this.logger = baseLogger.create("pluralResolver");
		this.pluralRulesCache = {};
	}
	addRule(lng, obj) {
		this.rules[lng] = obj;
	}
	clearCache() {
		this.pluralRulesCache = {};
	}
	getRule(code) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		const cleanedCode = getCleanedCode(code === "dev" ? "en" : code);
		const type = options.ordinal ? "ordinal" : "cardinal";
		const cacheKey = JSON.stringify({
			cleanedCode,
			type
		});
		if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
		let rule;
		try {
			rule = new Intl.PluralRules(cleanedCode, { type });
		} catch (err) {
			if (!Intl) {
				this.logger.error("No Intl support, please use an Intl polyfill!");
				return dummyRule;
			}
			if (!code.match(/-|_/)) return dummyRule;
			const lngPart = this.languageUtils.getLanguagePartFromCode(code);
			rule = this.getRule(lngPart, options);
		}
		this.pluralRulesCache[cacheKey] = rule;
		return rule;
	}
	needsPlural(code) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let rule = this.getRule(code, options);
		if (!rule) rule = this.getRule("dev", options);
		return (rule === null || rule === void 0 ? void 0 : rule.resolvedOptions().pluralCategories.length) > 1;
	}
	getPluralFormsOfKey(code, key) {
		let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		return this.getSuffixes(code, options).map((suffix) => `${key}${suffix}`);
	}
	getSuffixes(code) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let rule = this.getRule(code, options);
		if (!rule) rule = this.getRule("dev", options);
		if (!rule) return [];
		return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map((pluralCategory) => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
	}
	getSuffix(code, count) {
		let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		const rule = this.getRule(code, options);
		if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
		this.logger.warn(`no plural rule found for: ${code}`);
		return this.getSuffix("dev", count, options);
	}
};
var deepFindWithDefaults = function(data, defaultData, key) {
	let keySeparator = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
	let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
	let path = getPathWithDefaults(data, defaultData, key);
	if (!path && ignoreJSONStructure && isString(key)) {
		path = deepFind(data, key, keySeparator);
		if (path === void 0) path = deepFind(defaultData, key, keySeparator);
	}
	return path;
};
var regexSafe = (val) => val.replace(/\$/g, "$$$$");
var Interpolator = class {
	constructor() {
		var _options$interpolatio2;
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		this.logger = baseLogger.create("interpolator");
		this.options = options;
		this.format = (options === null || options === void 0 || (_options$interpolatio2 = options.interpolation) === null || _options$interpolatio2 === void 0 ? void 0 : _options$interpolatio2.format) || ((value) => value);
		this.init(options);
	}
	init() {
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (!options.interpolation) options.interpolation = { escapeValue: true };
		const { escape: escape$1, escapeValue, useRawValueToEscape, prefix, prefixEscaped, suffix, suffixEscaped, formatSeparator, unescapeSuffix, unescapePrefix, nestingPrefix, nestingPrefixEscaped, nestingSuffix, nestingSuffixEscaped, nestingOptionsSeparator, maxReplaces, alwaysFormat } = options.interpolation;
		this.escape = escape$1 !== void 0 ? escape$1 : escape;
		this.escapeValue = escapeValue !== void 0 ? escapeValue : true;
		this.useRawValueToEscape = useRawValueToEscape !== void 0 ? useRawValueToEscape : false;
		this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || "{{";
		this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || "}}";
		this.formatSeparator = formatSeparator || ",";
		this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
		this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
		this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape("$t(");
		this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(")");
		this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
		this.maxReplaces = maxReplaces || 1e3;
		this.alwaysFormat = alwaysFormat !== void 0 ? alwaysFormat : false;
		this.resetRegExp();
	}
	reset() {
		if (this.options) this.init(this.options);
	}
	resetRegExp() {
		const getOrResetRegExp = (existingRegExp, pattern) => {
			if ((existingRegExp === null || existingRegExp === void 0 ? void 0 : existingRegExp.source) === pattern) {
				existingRegExp.lastIndex = 0;
				return existingRegExp;
			}
			return new RegExp(pattern, "g");
		};
		this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
		this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
		this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
	}
	interpolate(str, data, lng, options) {
		var _options$interpolatio3;
		let match;
		let value;
		let replaces;
		const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
		const handleFormat = (key) => {
			if (key.indexOf(this.formatSeparator) < 0) {
				const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
				return this.alwaysFormat ? this.format(path, void 0, lng, _objectSpread2(_objectSpread2(_objectSpread2({}, options), data), {}, { interpolationkey: key })) : path;
			}
			const p = key.split(this.formatSeparator);
			const k = p.shift().trim();
			const f = p.join(this.formatSeparator).trim();
			return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, _objectSpread2(_objectSpread2(_objectSpread2({}, options), data), {}, { interpolationkey: k }));
		};
		this.resetRegExp();
		const missingInterpolationHandler = (options === null || options === void 0 ? void 0 : options.missingInterpolationHandler) || this.options.missingInterpolationHandler;
		const skipOnVariables = (options === null || options === void 0 || (_options$interpolatio3 = options.interpolation) === null || _options$interpolatio3 === void 0 ? void 0 : _options$interpolatio3.skipOnVariables) !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
		[{
			regex: this.regexpUnescape,
			safeValue: (val) => regexSafe(val)
		}, {
			regex: this.regexp,
			safeValue: (val) => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
		}].forEach((todo) => {
			replaces = 0;
			while (match = todo.regex.exec(str)) {
				const matchedVar = match[1].trim();
				value = handleFormat(matchedVar);
				if (value === void 0) if (typeof missingInterpolationHandler === "function") {
					const temp = missingInterpolationHandler(str, match, options);
					value = isString(temp) ? temp : "";
				} else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
				else if (skipOnVariables) {
					value = match[0];
					continue;
				} else {
					this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
					value = "";
				}
				else if (!isString(value) && !this.useRawValueToEscape) value = makeString(value);
				const safeValue = todo.safeValue(value);
				str = str.replace(match[0], safeValue);
				if (skipOnVariables) {
					todo.regex.lastIndex += value.length;
					todo.regex.lastIndex -= match[0].length;
				} else todo.regex.lastIndex = 0;
				replaces++;
				if (replaces >= this.maxReplaces) break;
			}
		});
		return str;
	}
	nest(str, fc) {
		let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		let match;
		let value;
		let clonedOptions;
		const handleHasOptions = (key, inheritedOptions) => {
			var _matchedSingleQuotes$;
			const sep = this.nestingOptionsSeparator;
			if (key.indexOf(sep) < 0) return key;
			const c = key.split(new RegExp(`${sep}[ ]*{`));
			let optionsString = `{${c[1]}`;
			key = c[0];
			optionsString = this.interpolate(optionsString, clonedOptions);
			const matchedSingleQuotes = optionsString.match(/'/g);
			const matchedDoubleQuotes = optionsString.match(/"/g);
			if (((_matchedSingleQuotes$ = matchedSingleQuotes === null || matchedSingleQuotes === void 0 ? void 0 : matchedSingleQuotes.length) !== null && _matchedSingleQuotes$ !== void 0 ? _matchedSingleQuotes$ : 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, "\"");
			try {
				clonedOptions = JSON.parse(optionsString);
				if (inheritedOptions) clonedOptions = _objectSpread2(_objectSpread2({}, inheritedOptions), clonedOptions);
			} catch (e) {
				this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
				return `${key}${sep}${optionsString}`;
			}
			if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
			return key;
		};
		while (match = this.nestingRegexp.exec(str)) {
			let formatters = [];
			clonedOptions = _objectSpread2({}, options);
			clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
			clonedOptions.applyPostProcessor = false;
			delete clonedOptions.defaultValue;
			let doReduce = false;
			if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
				const r = match[1].split(this.formatSeparator).map((elem) => elem.trim());
				match[1] = r.shift();
				formatters = r;
				doReduce = true;
			}
			value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
			if (value && match[0] === str && !isString(value)) return value;
			if (!isString(value)) value = makeString(value);
			if (!value) {
				this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
				value = "";
			}
			if (doReduce) value = formatters.reduce((v, f) => this.format(v, f, options.lng, _objectSpread2(_objectSpread2({}, options), {}, { interpolationkey: match[1].trim() })), value.trim());
			str = str.replace(match[0], value);
			this.regexp.lastIndex = 0;
		}
		return str;
	}
};
var parseFormatStr = (formatStr) => {
	let formatName = formatStr.toLowerCase().trim();
	const formatOptions = {};
	if (formatStr.indexOf("(") > -1) {
		const p = formatStr.split("(");
		formatName = p[0].toLowerCase().trim();
		const optStr = p[1].substring(0, p[1].length - 1);
		if (formatName === "currency" && optStr.indexOf(":") < 0) {
			if (!formatOptions.currency) formatOptions.currency = optStr.trim();
		} else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
			if (!formatOptions.range) formatOptions.range = optStr.trim();
		} else optStr.split(";").forEach((opt) => {
			if (opt) {
				const [key, ...rest] = opt.split(":");
				const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
				const trimmedKey = key.trim();
				if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
				if (val === "false") formatOptions[trimmedKey] = false;
				if (val === "true") formatOptions[trimmedKey] = true;
				if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
			}
		});
	}
	return {
		formatName,
		formatOptions
	};
};
var createCachedFormatter = (fn) => {
	const cache = {};
	return (val, lng, options) => {
		let optForCache = options;
		if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = _objectSpread2(_objectSpread2({}, optForCache), {}, { [options.interpolationkey]: void 0 });
		const key = lng + JSON.stringify(optForCache);
		let formatter = cache[key];
		if (!formatter) {
			formatter = fn(getCleanedCode(lng), options);
			cache[key] = formatter;
		}
		return formatter(val);
	};
};
var Formatter = class {
	constructor() {
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		this.logger = baseLogger.create("formatter");
		this.options = options;
		this.formats = {
			number: createCachedFormatter((lng, opt) => {
				const formatter = new Intl.NumberFormat(lng, _objectSpread2({}, opt));
				return (val) => formatter.format(val);
			}),
			currency: createCachedFormatter((lng, opt) => {
				const formatter = new Intl.NumberFormat(lng, _objectSpread2(_objectSpread2({}, opt), {}, { style: "currency" }));
				return (val) => formatter.format(val);
			}),
			datetime: createCachedFormatter((lng, opt) => {
				const formatter = new Intl.DateTimeFormat(lng, _objectSpread2({}, opt));
				return (val) => formatter.format(val);
			}),
			relativetime: createCachedFormatter((lng, opt) => {
				const formatter = new Intl.RelativeTimeFormat(lng, _objectSpread2({}, opt));
				return (val) => formatter.format(val, opt.range || "day");
			}),
			list: createCachedFormatter((lng, opt) => {
				const formatter = new Intl.ListFormat(lng, _objectSpread2({}, opt));
				return (val) => formatter.format(val);
			})
		};
		this.init(options);
	}
	init(services) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { interpolation: {} };
		this.formatSeparator = options.interpolation.formatSeparator || ",";
	}
	add(name, fc) {
		this.formats[name.toLowerCase().trim()] = fc;
	}
	addCached(name, fc) {
		this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
	}
	format(value, format, lng) {
		let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
		const formats = format.split(this.formatSeparator);
		if (formats.length > 1 && formats[0].indexOf("(") > 1 && formats[0].indexOf(")") < 0 && formats.find((f) => f.indexOf(")") > -1)) {
			const lastIndex = formats.findIndex((f) => f.indexOf(")") > -1);
			formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
		}
		return formats.reduce((mem, f) => {
			const { formatName, formatOptions } = parseFormatStr(f);
			if (this.formats[formatName]) {
				let formatted = mem;
				try {
					var _options$formatParams;
					const valOptions = (options === null || options === void 0 || (_options$formatParams = options.formatParams) === null || _options$formatParams === void 0 ? void 0 : _options$formatParams[options.interpolationkey]) || {};
					const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
					formatted = this.formats[formatName](mem, l, _objectSpread2(_objectSpread2(_objectSpread2({}, formatOptions), options), valOptions));
				} catch (error) {
					this.logger.warn(error);
				}
				return formatted;
			} else this.logger.warn(`there was no format function for ${formatName}`);
			return mem;
		}, value);
	}
};
var removePending = (q, name) => {
	if (q.pending[name] !== void 0) {
		delete q.pending[name];
		q.pendingCount--;
	}
};
var Connector = class extends EventEmitter {
	constructor(backend, store, services) {
		var _this$backend, _this$backend$init;
		let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
		super();
		this.backend = backend;
		this.store = store;
		this.services = services;
		this.languageUtils = services.languageUtils;
		this.options = options;
		this.logger = baseLogger.create("backendConnector");
		this.waitingReads = [];
		this.maxParallelReads = options.maxParallelReads || 10;
		this.readingCalls = 0;
		this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
		this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
		this.state = {};
		this.queue = [];
		(_this$backend = this.backend) === null || _this$backend === void 0 || (_this$backend$init = _this$backend.init) === null || _this$backend$init === void 0 || _this$backend$init.call(_this$backend, services, options.backend, options);
	}
	queueLoad(languages, namespaces, options, callback) {
		const toLoad = {};
		const pending = {};
		const toLoadLanguages = {};
		const toLoadNamespaces = {};
		languages.forEach((lng) => {
			let hasAllNamespaces = true;
			namespaces.forEach((ns) => {
				const name = `${lng}|${ns}`;
				if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
				else if (this.state[name] < 0);
				else if (this.state[name] === 1) {
					if (pending[name] === void 0) pending[name] = true;
				} else {
					this.state[name] = 1;
					hasAllNamespaces = false;
					if (pending[name] === void 0) pending[name] = true;
					if (toLoad[name] === void 0) toLoad[name] = true;
					if (toLoadNamespaces[ns] === void 0) toLoadNamespaces[ns] = true;
				}
			});
			if (!hasAllNamespaces) toLoadLanguages[lng] = true;
		});
		if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
			pending,
			pendingCount: Object.keys(pending).length,
			loaded: {},
			errors: [],
			callback
		});
		return {
			toLoad: Object.keys(toLoad),
			pending: Object.keys(pending),
			toLoadLanguages: Object.keys(toLoadLanguages),
			toLoadNamespaces: Object.keys(toLoadNamespaces)
		};
	}
	loaded(name, err, data) {
		const s = name.split("|");
		const lng = s[0];
		const ns = s[1];
		if (err) this.emit("failedLoading", lng, ns, err);
		if (!err && data) this.store.addResourceBundle(lng, ns, data, void 0, void 0, { skipCopy: true });
		this.state[name] = err ? -1 : 2;
		if (err && data) this.state[name] = 0;
		const loaded = {};
		this.queue.forEach((q) => {
			pushPath(q.loaded, [lng], ns);
			removePending(q, name);
			if (err) q.errors.push(err);
			if (q.pendingCount === 0 && !q.done) {
				Object.keys(q.loaded).forEach((l) => {
					if (!loaded[l]) loaded[l] = {};
					const loadedKeys = q.loaded[l];
					if (loadedKeys.length) loadedKeys.forEach((n) => {
						if (loaded[l][n] === void 0) loaded[l][n] = true;
					});
				});
				q.done = true;
				if (q.errors.length) q.callback(q.errors);
				else q.callback();
			}
		});
		this.emit("loaded", loaded);
		this.queue = this.queue.filter((q) => !q.done);
	}
	read(lng, ns, fcName) {
		let tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
		let wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout;
		let callback = arguments.length > 5 ? arguments[5] : void 0;
		if (!lng.length) return callback(null, {});
		if (this.readingCalls >= this.maxParallelReads) {
			this.waitingReads.push({
				lng,
				ns,
				fcName,
				tried,
				wait,
				callback
			});
			return;
		}
		this.readingCalls++;
		const resolver = (err, data) => {
			this.readingCalls--;
			if (this.waitingReads.length > 0) {
				const next = this.waitingReads.shift();
				this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
			}
			if (err && data && tried < this.maxRetries) {
				setTimeout(() => {
					this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
				}, wait);
				return;
			}
			callback(err, data);
		};
		const fc = this.backend[fcName].bind(this.backend);
		if (fc.length === 2) {
			try {
				const r = fc(lng, ns);
				if (r && typeof r.then === "function") r.then((data) => resolver(null, data)).catch(resolver);
				else resolver(null, r);
			} catch (err) {
				resolver(err);
			}
			return;
		}
		return fc(lng, ns, resolver);
	}
	prepareLoading(languages, namespaces) {
		let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		let callback = arguments.length > 3 ? arguments[3] : void 0;
		if (!this.backend) {
			this.logger.warn("No backend was added via i18next.use. Will not load resources.");
			return callback && callback();
		}
		if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
		if (isString(namespaces)) namespaces = [namespaces];
		const toLoad = this.queueLoad(languages, namespaces, options, callback);
		if (!toLoad.toLoad.length) {
			if (!toLoad.pending.length) callback();
			return null;
		}
		toLoad.toLoad.forEach((name) => {
			this.loadOne(name);
		});
	}
	load(languages, namespaces, callback) {
		this.prepareLoading(languages, namespaces, {}, callback);
	}
	reload(languages, namespaces, callback) {
		this.prepareLoading(languages, namespaces, { reload: true }, callback);
	}
	loadOne(name) {
		let prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
		const s = name.split("|");
		const lng = s[0];
		const ns = s[1];
		this.read(lng, ns, "read", void 0, void 0, (err, data) => {
			if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
			if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
			this.loaded(name, err, data);
		});
	}
	saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
		var _this$services, _this$services2, _this$backend2;
		let options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
		let clb = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {};
		if (((_this$services = this.services) === null || _this$services === void 0 || (_this$services = _this$services.utils) === null || _this$services === void 0 ? void 0 : _this$services.hasLoadedNamespace) && !((_this$services2 = this.services) === null || _this$services2 === void 0 || (_this$services2 = _this$services2.utils) === null || _this$services2 === void 0 ? void 0 : _this$services2.hasLoadedNamespace(namespace))) {
			this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
			return;
		}
		if (key === void 0 || key === null || key === "") return;
		if ((_this$backend2 = this.backend) === null || _this$backend2 === void 0 ? void 0 : _this$backend2.create) {
			const opts = _objectSpread2(_objectSpread2({}, options), {}, { isUpdate });
			const fc = this.backend.create.bind(this.backend);
			if (fc.length < 6) try {
				let r;
				if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
				else r = fc(languages, namespace, key, fallbackValue);
				if (r && typeof r.then === "function") r.then((data) => clb(null, data)).catch(clb);
				else clb(null, r);
			} catch (err) {
				clb(err);
			}
			else fc(languages, namespace, key, fallbackValue, clb, opts);
		}
		if (!languages || !languages[0]) return;
		this.store.addResource(languages[0], namespace, key, fallbackValue);
	}
};
var get = () => ({
	debug: false,
	initAsync: true,
	ns: ["translation"],
	defaultNS: ["translation"],
	fallbackLng: ["dev"],
	fallbackNS: false,
	supportedLngs: false,
	nonExplicitSupportedLngs: false,
	load: "all",
	preload: false,
	simplifyPluralSuffix: true,
	keySeparator: ".",
	nsSeparator: ":",
	pluralSeparator: "_",
	contextSeparator: "_",
	partialBundledLanguages: false,
	saveMissing: false,
	updateMissing: false,
	saveMissingTo: "fallback",
	saveMissingPlurals: true,
	missingKeyHandler: false,
	missingInterpolationHandler: false,
	postProcess: false,
	postProcessPassResolved: false,
	returnNull: false,
	returnEmptyString: true,
	returnObjects: false,
	joinArrays: false,
	returnedObjectHandler: false,
	parseMissingKeyHandler: false,
	appendNamespaceToMissingKey: false,
	appendNamespaceToCIMode: false,
	overloadTranslationOptionHandler: (args) => {
		let ret = {};
		if (typeof args[1] === "object") ret = args[1];
		if (isString(args[1])) ret.defaultValue = args[1];
		if (isString(args[2])) ret.tDescription = args[2];
		if (typeof args[2] === "object" || typeof args[3] === "object") {
			const options = args[3] || args[2];
			Object.keys(options).forEach((key) => {
				ret[key] = options[key];
			});
		}
		return ret;
	},
	interpolation: {
		escapeValue: true,
		format: (value) => value,
		prefix: "{{",
		suffix: "}}",
		formatSeparator: ",",
		unescapePrefix: "-",
		nestingPrefix: "$t(",
		nestingSuffix: ")",
		nestingOptionsSeparator: ",",
		maxReplaces: 1e3,
		skipOnVariables: true
	}
});
var transformOptions = (options) => {
	var _options$supportedLng, _options$supportedLng2;
	if (isString(options.ns)) options.ns = [options.ns];
	if (isString(options.fallbackLng)) options.fallbackLng = [options.fallbackLng];
	if (isString(options.fallbackNS)) options.fallbackNS = [options.fallbackNS];
	if (((_options$supportedLng = options.supportedLngs) === null || _options$supportedLng === void 0 || (_options$supportedLng2 = _options$supportedLng.indexOf) === null || _options$supportedLng2 === void 0 ? void 0 : _options$supportedLng2.call(_options$supportedLng, "cimode")) < 0) options.supportedLngs = options.supportedLngs.concat(["cimode"]);
	if (typeof options.initImmediate === "boolean") options.initAsync = options.initImmediate;
	return options;
};
var noop = () => {};
var bindMemberFunctions = (inst) => {
	Object.getOwnPropertyNames(Object.getPrototypeOf(inst)).forEach((mem) => {
		if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
	});
};
var I18n = class I18n extends EventEmitter {
	constructor() {
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		let callback = arguments.length > 1 ? arguments[1] : void 0;
		super();
		this.options = transformOptions(options);
		this.services = {};
		this.logger = baseLogger;
		this.modules = { external: [] };
		bindMemberFunctions(this);
		if (callback && !this.isInitialized && !options.isClone) {
			if (!this.options.initAsync) {
				this.init(options, callback);
				return this;
			}
			setTimeout(() => {
				this.init(options, callback);
			}, 0);
		}
	}
	init() {
		var _this = this;
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		let callback = arguments.length > 1 ? arguments[1] : void 0;
		this.isInitializing = true;
		if (typeof options === "function") {
			callback = options;
			options = {};
		}
		if (options.defaultNS == null && options.ns) {
			if (isString(options.ns)) options.defaultNS = options.ns;
			else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
		}
		const defOpts = get();
		this.options = _objectSpread2(_objectSpread2(_objectSpread2({}, defOpts), this.options), transformOptions(options));
		this.options.interpolation = _objectSpread2(_objectSpread2({}, defOpts.interpolation), this.options.interpolation);
		if (options.keySeparator !== void 0) this.options.userDefinedKeySeparator = options.keySeparator;
		if (options.nsSeparator !== void 0) this.options.userDefinedNsSeparator = options.nsSeparator;
		const createClassOnDemand = (ClassOrObject) => {
			if (!ClassOrObject) return null;
			if (typeof ClassOrObject === "function") return new ClassOrObject();
			return ClassOrObject;
		};
		if (!this.options.isClone) {
			if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
			else baseLogger.init(null, this.options);
			let formatter;
			if (this.modules.formatter) formatter = this.modules.formatter;
			else formatter = Formatter;
			const lu = new LanguageUtil(this.options);
			this.store = new ResourceStore(this.options.resources, this.options);
			const s = this.services;
			s.logger = baseLogger;
			s.resourceStore = this.store;
			s.languageUtils = lu;
			s.pluralResolver = new PluralResolver(lu, {
				prepend: this.options.pluralSeparator,
				simplifyPluralSuffix: this.options.simplifyPluralSuffix
			});
			if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
				s.formatter = createClassOnDemand(formatter);
				s.formatter.init(s, this.options);
				this.options.interpolation.format = s.formatter.format.bind(s.formatter);
			}
			s.interpolator = new Interpolator(this.options);
			s.utils = { hasLoadedNamespace: this.hasLoadedNamespace.bind(this) };
			s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
			s.backendConnector.on("*", function(event) {
				for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
				_this.emit(event, ...args);
			});
			if (this.modules.languageDetector) {
				s.languageDetector = createClassOnDemand(this.modules.languageDetector);
				if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
			}
			if (this.modules.i18nFormat) {
				s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
				if (s.i18nFormat.init) s.i18nFormat.init(this);
			}
			this.translator = new Translator(this.services, this.options);
			this.translator.on("*", function(event) {
				for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args[_key2 - 1] = arguments[_key2];
				_this.emit(event, ...args);
			});
			this.modules.external.forEach((m) => {
				if (m.init) m.init(this);
			});
		}
		this.format = this.options.interpolation.format;
		if (!callback) callback = noop;
		if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
			const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
			if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
		}
		if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
		[
			"getResource",
			"hasResourceBundle",
			"getResourceBundle",
			"getDataByLanguage"
		].forEach((fcName) => {
			this[fcName] = function() {
				return _this.store[fcName](...arguments);
			};
		});
		[
			"addResource",
			"addResources",
			"addResourceBundle",
			"removeResourceBundle"
		].forEach((fcName) => {
			this[fcName] = function() {
				_this.store[fcName](...arguments);
				return _this;
			};
		});
		const deferred = defer();
		const load = () => {
			const finish = (err, t) => {
				this.isInitializing = false;
				if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
				this.isInitialized = true;
				if (!this.options.isClone) this.logger.log("initialized", this.options);
				this.emit("initialized", this.options);
				deferred.resolve(t);
				callback(err, t);
			};
			if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
			this.changeLanguage(this.options.lng, finish);
		};
		if (this.options.resources || !this.options.initAsync) load();
		else setTimeout(load, 0);
		return deferred;
	}
	loadResources(language) {
		let usedCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
		const usedLng = isString(language) ? language : this.language;
		if (typeof language === "function") usedCallback = language;
		if (!this.options.resources || this.options.partialBundledLanguages) {
			var _this$options$preload, _this$options$preload2;
			if ((usedLng === null || usedLng === void 0 ? void 0 : usedLng.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
			const toLoad = [];
			const append = (lng) => {
				if (!lng) return;
				if (lng === "cimode") return;
				this.services.languageUtils.toResolveHierarchy(lng).forEach((l) => {
					if (l === "cimode") return;
					if (toLoad.indexOf(l) < 0) toLoad.push(l);
				});
			};
			if (!usedLng) this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => append(l));
			else append(usedLng);
			(_this$options$preload = this.options.preload) === null || _this$options$preload === void 0 || (_this$options$preload2 = _this$options$preload.forEach) === null || _this$options$preload2 === void 0 || _this$options$preload2.call(_this$options$preload, (l) => append(l));
			this.services.backendConnector.load(toLoad, this.options.ns, (e) => {
				if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
				usedCallback(e);
			});
		} else usedCallback(null);
	}
	reloadResources(lngs, ns, callback) {
		const deferred = defer();
		if (typeof lngs === "function") {
			callback = lngs;
			lngs = void 0;
		}
		if (typeof ns === "function") {
			callback = ns;
			ns = void 0;
		}
		if (!lngs) lngs = this.languages;
		if (!ns) ns = this.options.ns;
		if (!callback) callback = noop;
		this.services.backendConnector.reload(lngs, ns, (err) => {
			deferred.resolve();
			callback(err);
		});
		return deferred;
	}
	use(module) {
		if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
		if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
		if (module.type === "backend") this.modules.backend = module;
		if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
		if (module.type === "languageDetector") this.modules.languageDetector = module;
		if (module.type === "i18nFormat") this.modules.i18nFormat = module;
		if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
		if (module.type === "formatter") this.modules.formatter = module;
		if (module.type === "3rdParty") this.modules.external.push(module);
		return this;
	}
	setResolvedLanguage(l) {
		if (!l || !this.languages) return;
		if (["cimode", "dev"].indexOf(l) > -1) return;
		for (let li = 0; li < this.languages.length; li++) {
			const lngInLngs = this.languages[li];
			if (["cimode", "dev"].indexOf(lngInLngs) > -1) continue;
			if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
				this.resolvedLanguage = lngInLngs;
				break;
			}
		}
	}
	changeLanguage(lng, callback) {
		var _this2 = this;
		this.isLanguageChangingTo = lng;
		const deferred = defer();
		this.emit("languageChanging", lng);
		const setLngProps = (l) => {
			this.language = l;
			this.languages = this.services.languageUtils.toResolveHierarchy(l);
			this.resolvedLanguage = void 0;
			this.setResolvedLanguage(l);
		};
		const done = (err, l) => {
			if (l) {
				setLngProps(l);
				this.translator.changeLanguage(l);
				this.isLanguageChangingTo = void 0;
				this.emit("languageChanged", l);
				this.logger.log("languageChanged", l);
			} else this.isLanguageChangingTo = void 0;
			deferred.resolve(function() {
				return _this2.t(...arguments);
			});
			if (callback) callback(err, function() {
				return _this2.t(...arguments);
			});
		};
		const setLng = (lngs) => {
			if (!lng && !lngs && this.services.languageDetector) lngs = [];
			const l = isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
			if (l) {
				var _this$services$langua, _this$services$langua2;
				if (!this.language) setLngProps(l);
				if (!this.translator.language) this.translator.changeLanguage(l);
				(_this$services$langua = this.services.languageDetector) === null || _this$services$langua === void 0 || (_this$services$langua2 = _this$services$langua.cacheUserLanguage) === null || _this$services$langua2 === void 0 || _this$services$langua2.call(_this$services$langua, l);
			}
			this.loadResources(l, (err) => {
				done(err, l);
			});
		};
		if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
		else if (!lng && this.services.languageDetector && this.services.languageDetector.async) if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
		else this.services.languageDetector.detect(setLng);
		else setLng(lng);
		return deferred;
	}
	getFixedT(lng, ns, keyPrefix) {
		var _this3 = this;
		const fixedT = function(key, opts) {
			let options;
			if (typeof opts !== "object") {
				for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) rest[_key3 - 2] = arguments[_key3];
				options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
			} else options = _objectSpread2({}, opts);
			options.lng = options.lng || fixedT.lng;
			options.lngs = options.lngs || fixedT.lngs;
			options.ns = options.ns || fixedT.ns;
			if (options.keyPrefix !== "") options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
			const keySeparator = _this3.options.keySeparator || ".";
			let resultKey;
			if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k) => `${options.keyPrefix}${keySeparator}${k}`);
			else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
			return _this3.t(resultKey, options);
		};
		if (isString(lng)) fixedT.lng = lng;
		else fixedT.lngs = lng;
		fixedT.ns = ns;
		fixedT.keyPrefix = keyPrefix;
		return fixedT;
	}
	t() {
		var _this$translator;
		for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
		return (_this$translator = this.translator) === null || _this$translator === void 0 ? void 0 : _this$translator.translate(...args);
	}
	exists() {
		var _this$translator2;
		for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) args[_key5] = arguments[_key5];
		return (_this$translator2 = this.translator) === null || _this$translator2 === void 0 ? void 0 : _this$translator2.exists(...args);
	}
	setDefaultNamespace(ns) {
		this.options.defaultNS = ns;
	}
	hasLoadedNamespace(ns) {
		let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		if (!this.isInitialized) {
			this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
			return false;
		}
		if (!this.languages || !this.languages.length) {
			this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
			return false;
		}
		const lng = options.lng || this.resolvedLanguage || this.languages[0];
		const fallbackLng = this.options ? this.options.fallbackLng : false;
		const lastLng = this.languages[this.languages.length - 1];
		if (lng.toLowerCase() === "cimode") return true;
		const loadNotPending = (l, n) => {
			const loadState = this.services.backendConnector.state[`${l}|${n}`];
			return loadState === -1 || loadState === 0 || loadState === 2;
		};
		if (options.precheck) {
			const preResult = options.precheck(this, loadNotPending);
			if (preResult !== void 0) return preResult;
		}
		if (this.hasResourceBundle(lng, ns)) return true;
		if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
		if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
		return false;
	}
	loadNamespaces(ns, callback) {
		const deferred = defer();
		if (!this.options.ns) {
			if (callback) callback();
			return Promise.resolve();
		}
		if (isString(ns)) ns = [ns];
		ns.forEach((n) => {
			if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
		});
		this.loadResources((err) => {
			deferred.resolve();
			if (callback) callback(err);
		});
		return deferred;
	}
	loadLanguages(lngs, callback) {
		const deferred = defer();
		if (isString(lngs)) lngs = [lngs];
		const preloaded = this.options.preload || [];
		const newLngs = lngs.filter((lng) => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
		if (!newLngs.length) {
			if (callback) callback();
			return Promise.resolve();
		}
		this.options.preload = preloaded.concat(newLngs);
		this.loadResources((err) => {
			deferred.resolve();
			if (callback) callback(err);
		});
		return deferred;
	}
	dir(lng) {
		var _this$languages, _this$services3;
		if (!lng) lng = this.resolvedLanguage || (((_this$languages = this.languages) === null || _this$languages === void 0 ? void 0 : _this$languages.length) > 0 ? this.languages[0] : this.language);
		if (!lng) return "rtl";
		const rtlLngs = [
			"ar",
			"shu",
			"sqr",
			"ssh",
			"xaa",
			"yhd",
			"yud",
			"aao",
			"abh",
			"abv",
			"acm",
			"acq",
			"acw",
			"acx",
			"acy",
			"adf",
			"ads",
			"aeb",
			"aec",
			"afb",
			"ajp",
			"apc",
			"apd",
			"arb",
			"arq",
			"ars",
			"ary",
			"arz",
			"auz",
			"avl",
			"ayh",
			"ayl",
			"ayn",
			"ayp",
			"bbz",
			"pga",
			"he",
			"iw",
			"ps",
			"pbt",
			"pbu",
			"pst",
			"prp",
			"prd",
			"ug",
			"ur",
			"ydd",
			"yds",
			"yih",
			"ji",
			"yi",
			"hbo",
			"men",
			"xmn",
			"fa",
			"jpr",
			"peo",
			"pes",
			"prs",
			"dv",
			"sam",
			"ckb"
		];
		const languageUtils = ((_this$services3 = this.services) === null || _this$services3 === void 0 ? void 0 : _this$services3.languageUtils) || new LanguageUtil(get());
		return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
	}
	static createInstance() {
		return new I18n(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, arguments.length > 1 ? arguments[1] : void 0);
	}
	cloneInstance() {
		let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		let callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
		const forkResourceStore = options.forkResourceStore;
		if (forkResourceStore) delete options.forkResourceStore;
		const mergedOptions = _objectSpread2(_objectSpread2(_objectSpread2({}, this.options), options), { isClone: true });
		const clone = new I18n(mergedOptions);
		if (options.debug !== void 0 || options.prefix !== void 0) clone.logger = clone.logger.clone(options);
		[
			"store",
			"services",
			"language"
		].forEach((m) => {
			clone[m] = this[m];
		});
		clone.services = _objectSpread2({}, this.services);
		clone.services.utils = { hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone) };
		if (forkResourceStore) {
			clone.store = new ResourceStore(Object.keys(this.store.data).reduce((prev, l) => {
				prev[l] = _objectSpread2({}, this.store.data[l]);
				return Object.keys(prev[l]).reduce((acc, n) => {
					acc[n] = _objectSpread2({}, prev[l][n]);
					return acc;
				}, {});
			}, {}), mergedOptions);
			clone.services.resourceStore = clone.store;
		}
		clone.translator = new Translator(clone.services, mergedOptions);
		clone.translator.on("*", function(event) {
			for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) args[_key6 - 1] = arguments[_key6];
			clone.emit(event, ...args);
		});
		clone.init(mergedOptions, callback);
		clone.translator.options = mergedOptions;
		clone.translator.backendConnector.services.utils = { hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone) };
		return clone;
	}
	toJSON() {
		return {
			options: this.options,
			store: this.store,
			language: this.language,
			languages: this.languages,
			resolvedLanguage: this.resolvedLanguage
		};
	}
};
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
var en_default = { aml_screening_modal: {
	"close_button": "Close",
	"loading": "Loading…",
	"processing": "Processing…",
	"list_label": "List:",
	"list_all_matches": "All matches",
	"matches_found_one": "{n} match is found",
	"matches_found_other": "{n} matches are found",
	"select_all": "Select all",
	"unselect_all": "Unselect all",
	"matches_selected_one": "{n} match selected",
	"matches_selected_other": "{n} matches selected",
	"set_them_as": "Set them as",
	"datasets_label": "Datasets",
	"country_label": "Country",
	"countries_label": "Countries",
	"gender_label": "Gender",
	"date_of_birth_label": "Date of birth",
	"match_score": "{score} Match",
	"action_open_match": "Open match",
	"action_false_positive": "False positive",
	"action_match_profile": "Match profile",
	"action_view_profile": "View profile",
	"badge_match": "Match",
	"badge_open": "Open",
	"badge_false_positive": "False positive",
	"empty_heading": "Nothing here!",
	"empty_description": "There are no matches.",
	"filtered_empty_heading": "Nothing here!",
	"filtered_empty_description": "No matches for this filter.",
	"tab_main": "Main",
	"tab_sanctions": "Sanctions",
	"tab_pep": "PEP",
	"tab_adverse_media": "Adverse Media",
	"tab_associations": "Associations",
	"tab_other_sources": "Other sources",
	"segment_current": "Current",
	"segment_former": "Former",
	"other_sources_regulatory_enforcement_label": "Regulatory enforcement list",
	"profile_description_label": "Description",
	"profile_business_types_label": "Business types",
	"profile_activities_label": "Activities",
	"profile_notes_heading": "Notes",
	"profile_additional_information_heading": "Additional Information",
	"profile_aliases_label": "Aliases",
	"profile_addresses_label": "Addresses",
	"profile_contacts_label": "Contacts",
	"profile_identifiers_label": "Identifiers",
	"profile_photo_previous": "Previous photo",
	"profile_photo_next": "Next photo",
	"profile_no_tab_content": "No data available for this section yet.",
	"pep_tier_label": "PEP tier",
	"pep_current_heading": "Current positions",
	"pep_former_heading": "Former positions",
	"pep_position_fallback": "Position",
	"pep_date_to_present": "Present",
	"adverse_media_category_fallback": "Adverse media",
	"regulatory_enforcement_category_fallback": "Regulatory enforcement",
	"period_years": "{n}y",
	"period_months": "{n}m",
	"period_days": "{n}d",
	"associations_individuals_heading": "Individuals",
	"associations_businesses_heading": "Business",
	"associations_business_fallback": "Company",
	"ownership_percentage_label": "{percentage}% ownership",
	"match_profile_title": "Match profile",
	"match_profile_subtitle": "Set the match result as matched profile.",
	"match_profile_comment_label": "Leave comment",
	"match_profile_comment_placeholder": "Comment",
	"match_profile_resolve_others": "Set all other open matches as “False positive”",
	"match_profile_false_positive_comment_label": "Leave comment for false positives",
	"subcategory_label": "Subcategory",
	"sanction_name_label": "Name",
	"sanction_body_label": "Body",
	"sanction_origin_label": "Origin",
	"sanction_measures_label": "Measures taken",
	"sanction_types_label": "Sanction types",
	"events_label": "Events",
	"evidence_label": "Evidence",
	"evidence_no_title": "(No title)",
	"evidence_read_more": "Read more",
	"evidence_read_less": "Show less",
	"evidence_sources_label": "Sources",
	"evidence_keywords_label": "Keywords",
	"evidence_credibility_label": "Credibility",
	"evidence_link_label": "Link",
	"evidence_date_created_label": "Date created",
	"evidence_download": "Download",
	"evidence_open_link": "Open link",
	"credibility_low": "Low",
	"credibility_medium": "Medium",
	"credibility_high": "High"
} };
var lt_default = { aml_screening_modal: {
	"close_button": "Uždaryti",
	"loading": "Kraunama…",
	"processing": "Apdorojama…",
	"list_label": "Sąrašas:",
	"list_all_matches": "Visi atitikmenys",
	"matches_found_one": "Rastas {n} atitikmuo",
	"matches_found_other": "Rasta {n} atitikmenų",
	"select_all": "Pažymėti visus",
	"unselect_all": "Atžymėti visus",
	"matches_selected_one": "Pasirinktas {n} atitikmuo",
	"matches_selected_other": "Pasirinkta {n} atitikmenų",
	"set_them_as": "Nustatyti kaip",
	"datasets_label": "Duomenų rinkiniai",
	"country_label": "Šalis",
	"countries_label": "Šalys",
	"gender_label": "Lytis",
	"date_of_birth_label": "Gimimo data",
	"match_score": "Atitiktis {score}",
	"action_open_match": "Atidaryti atitikmenį",
	"action_false_positive": "Klaidingas atitikmuo",
	"action_match_profile": "Patvirtinti profilį",
	"action_view_profile": "Peržiūrėti profilį",
	"badge_match": "Atitikmuo",
	"badge_open": "Atidarytas",
	"badge_false_positive": "Klaidingas atitikmuo",
	"empty_heading": "Čia nieko nėra!",
	"empty_description": "Atitikmenų nerasta.",
	"filtered_empty_heading": "Čia nieko nėra!",
	"filtered_empty_description": "Pagal šį filtrą atitikmenų nerasta.",
	"tab_main": "Pagrindinis",
	"tab_sanctions": "Sankcijos",
	"tab_pep": "PEP",
	"tab_adverse_media": "Neigiama žiniasklaida",
	"tab_associations": "Sąsajos",
	"tab_other_sources": "Kiti šaltiniai",
	"segment_current": "Dabartinės",
	"segment_former": "Ankstesnės",
	"other_sources_regulatory_enforcement_label": "Įstatymų pažeidimų sąrašas",
	"profile_description_label": "Aprašymas",
	"profile_business_types_label": "Verslo tipai",
	"profile_activities_label": "Veiklos",
	"profile_notes_heading": "Pastabos",
	"profile_additional_information_heading": "Papildoma informacija",
	"profile_aliases_label": "Pseudonimai",
	"profile_addresses_label": "Adresai",
	"profile_contacts_label": "Kontaktai",
	"profile_identifiers_label": "Identifikatoriai",
	"profile_photo_previous": "Ankstesnė nuotrauka",
	"profile_photo_next": "Kita nuotrauka",
	"profile_no_tab_content": "Šiam skirtukui duomenų kol kas nėra.",
	"pep_tier_label": "PEP lygis",
	"pep_current_heading": "Dabartinės pareigos",
	"pep_former_heading": "Ankstesnės pareigos",
	"pep_position_fallback": "Pareigos",
	"pep_date_to_present": "Iki dabar",
	"adverse_media_category_fallback": "Neigiama žiniasklaida",
	"regulatory_enforcement_category_fallback": "Reguliavimo institucijos veiksmai",
	"period_years": "{n} m.",
	"period_months": "{n} mėn.",
	"period_days": "{n} d.",
	"associations_individuals_heading": "Asmenys",
	"associations_businesses_heading": "Įmonės",
	"associations_business_fallback": "Įmonė",
	"ownership_percentage_label": "{percentage}% nuosavybės dalis",
	"match_profile_title": "Patvirtinti profilį",
	"match_profile_subtitle": "Nustatyti atitikmens rezultatą kaip patvirtintą profilį.",
	"match_profile_comment_label": "Palikite komentarą",
	"match_profile_comment_placeholder": "Komentaras",
	"match_profile_resolve_others": "Nustatyti visus kitus atidarytus atitikmenis kaip „Klaidingas atitikmuo“",
	"match_profile_false_positive_comment_label": "Palikite komentarą dėl klaidingų atitikmenų",
	"subcategory_label": "Subkategorija",
	"sanction_name_label": "Pavadinimas",
	"sanction_body_label": "Institucija",
	"sanction_origin_label": "Kilmė",
	"sanction_measures_label": "Priemonės",
	"sanction_types_label": "Sankcijų tipas",
	"events_label": "Įvykiai",
	"evidence_label": "Įrodymai",
	"evidence_no_title": "(Pavadinimo nėra)",
	"evidence_read_more": "Skaityti daugiau",
	"evidence_read_less": "Rodyti mažiau",
	"evidence_sources_label": "Šaltiniai",
	"evidence_keywords_label": "Raktažodžiai",
	"evidence_credibility_label": "Patikimumas",
	"evidence_link_label": "Adresas",
	"evidence_date_created_label": "Sukūrimo data",
	"evidence_download": "Atsisiųsti",
	"evidence_open_link": "Atidaryti nuorodą",
	"credibility_low": "Žemas",
	"credibility_medium": "Vidutinis",
	"credibility_high": "Aukštas"
} };
//#endregion
//#region src/i18n/index.ts
var i18n = instance.createInstance();
i18n.use(initReactI18next).init({
	resources: {
		en: { translation: en_default },
		lt: { translation: lt_default }
	},
	lng: "en",
	fallbackLng: "en",
	interpolation: {
		prefix: "{",
		suffix: "}",
		escapeValue: false
	},
	react: { useSuspense: false }
});
var tokens_module_default = { root: "_root_1lqrb_37" };
var AmlScreeningRoot_module_default = {
	root: "_root_471lr_4",
	header: "_header_471lr_15",
	headerIdentity: "_headerIdentity_471lr_25",
	avatarBadge: "_avatarBadge_471lr_31",
	personName: "_personName_471lr_44",
	personDob: "_personDob_471lr_49",
	closeButton: "_closeButton_471lr_55",
	toolbar: "_toolbar_471lr_69",
	toolbarListLabel: "_toolbarListLabel_471lr_78",
	toolbarSelectWrapper: "_toolbarSelectWrapper_471lr_84",
	toolbarSelect: "_toolbarSelect_471lr_84",
	toolbarSelectChevron: "_toolbarSelectChevron_471lr_103",
	selectAllButton: "_selectAllButton_471lr_112",
	bulkBar: "_bulkBar_471lr_129",
	bulkBarCount: "_bulkBarCount_471lr_138",
	bulkBarSetAs: "_bulkBarSetAs_471lr_144",
	bulkBarActions: "_bulkBarActions_471lr_149",
	criteriaBar: "_criteriaBar_471lr_155",
	criteriaItem: "_criteriaItem_471lr_166",
	criteriaLabel: "_criteriaLabel_471lr_173",
	criteriaValue: "_criteriaValue_471lr_179",
	divider: "_divider_471lr_184",
	matchList: "_matchList_471lr_191",
	card: "_card_471lr_200",
	cardCheckbox: "_cardCheckbox_471lr_210",
	cardBody: "_cardBody_471lr_217",
	badgeRow: "_badgeRow_471lr_225",
	badge: "_badge_471lr_225",
	"badge--success": "_badge--success_471lr_241",
	"badge--danger": "_badge--danger_471lr_246",
	"badge--neutral": "_badge--neutral_471lr_251",
	cardMain: "_cardMain_471lr_256",
	avatar: "_avatar_471lr_31",
	entityName: "_entityName_471lr_282",
	flagRow: "_flagRow_471lr_288",
	matchFlag: "_matchFlag_471lr_296",
	fieldGroup: "_fieldGroup_471lr_304",
	"fieldGroup--grow": "_fieldGroup--grow_471lr_311",
	fieldLabel: "_fieldLabel_471lr_316",
	fieldValue: "_fieldValue_471lr_322",
	cardActions: "_cardActions_471lr_328",
	secondaryActions: "_secondaryActions_471lr_338",
	secondaryButton: "_secondaryButton_471lr_344",
	primaryButton: "_primaryButton_471lr_363",
	emptyState: "_emptyState_471lr_379",
	emptyIcon: "_emptyIcon_471lr_390",
	emptyHeading: "_emptyHeading_471lr_402",
	emptyDescription: "_emptyDescription_471lr_409",
	loadingState: "_loadingState_471lr_415",
	busyOverlay: "_busyOverlay_471lr_428",
	spinner: "_spinner_471lr_438",
	"aml-spin": "_aml-spin_471lr_1",
	detailBackdrop: "_detailBackdrop_471lr_458",
	"detailBackdrop--visible": "_detailBackdrop--visible_471lr_470",
	detailModal: "_detailModal_471lr_474",
	"detailModal--visible": "_detailModal--visible_471lr_491",
	confirmModal: "_confirmModal_471lr_498",
	"confirmModal--visible": "_confirmModal--visible_471lr_517",
	confirmBody: "_confirmBody_471lr_522",
	confirmTitleRow: "_confirmTitleRow_471lr_528",
	confirmTitleGroup: "_confirmTitleGroup_471lr_534",
	confirmTitle: "_confirmTitle_471lr_528",
	confirmSubtitle: "_confirmSubtitle_471lr_548",
	field: "_field_471lr_304",
	confirmFieldLabel: "_confirmFieldLabel_471lr_560",
	textarea: "_textarea_471lr_566",
	confirmCheckbox: "_confirmCheckbox_471lr_581",
	confirmCheckboxInput: "_confirmCheckboxInput_471lr_590",
	confirmActions: "_confirmActions_471lr_598",
	dialogButton: "_dialogButton_471lr_604",
	dialogButtonSecondary: "_dialogButtonSecondary_471lr_616",
	dialogButtonPrimary: "_dialogButtonPrimary_471lr_626",
	detailTitle: "_detailTitle_471lr_647",
	tabs: "_tabs_471lr_652",
	tab: "_tab_471lr_652",
	"tab--active": "_tab--active_471lr_675",
	tabBadge: "_tabBadge_471lr_685",
	"tabBadge--active": "_tabBadge--active_471lr_697",
	segmentedControl: "_segmentedControl_471lr_706",
	segment: "_segment_471lr_706",
	"segment--active": "_segment--active_471lr_732",
	segmentCount: "_segmentCount_471lr_740",
	profileSections: "_profileSections_471lr_744",
	profileOverview: "_profileOverview_471lr_753",
	profilePhoto: "_profilePhoto_471lr_759",
	profilePhotoPager: "_profilePhotoPager_471lr_767",
	profilePhotoPagerButton: "_profilePhotoPagerButton_471lr_775",
	profileSectionHeading: "_profileSectionHeading_471lr_794",
	profileSection: "_profileSection_471lr_744",
	profileRow: "_profileRow_471lr_810",
	profileLabel: "_profileLabel_471lr_816",
	profileValue: "_profileValue_471lr_824",
	profileAddressLabel: "_profileAddressLabel_471lr_833",
	notesList: "_notesList_471lr_838",
	profileEmpty: "_profileEmpty_471lr_847",
	eventCategory: "_eventCategory_471lr_862",
	eventCategoryHeading: "_eventCategoryHeading_471lr_868",
	eventBlock: "_eventBlock_471lr_874",
	eventType: "_eventType_471lr_880",
	evidenceList: "_evidenceList_471lr_886",
	evidenceToggle: "_evidenceToggle_471lr_893",
	evidenceCountPill: "_evidenceCountPill_471lr_910",
	evidenceChevron: "_evidenceChevron_471lr_923",
	"evidenceChevron--open": "_evidenceChevron--open_471lr_927",
	evidenceCards: "_evidenceCards_471lr_931",
	evidenceCard: "_evidenceCard_471lr_931",
	evidenceCardTitle: "_evidenceCardTitle_471lr_948",
	evidenceSummaryBlock: "_evidenceSummaryBlock_471lr_954",
	evidenceSummary: "_evidenceSummary_471lr_954",
	"evidenceSummary--clamped": "_evidenceSummary--clamped_471lr_966",
	evidenceReadMore: "_evidenceReadMore_471lr_973",
	evidenceRow: "_evidenceRow_471lr_984",
	evidenceRowCenter: "_evidenceRowCenter_471lr_991",
	evidenceRowLabel: "_evidenceRowLabel_471lr_995",
	evidenceRowValue: "_evidenceRowValue_471lr_1001",
	evidenceLinkValue: "_evidenceLinkValue_471lr_1009",
	evidenceLinkText: "_evidenceLinkText_471lr_1017",
	evidenceIconButtons: "_evidenceIconButtons_471lr_1030",
	evidenceIconButton: "_evidenceIconButton_471lr_1030"
};
//#endregion
//#region src/aml-screening/components/icons.tsx
var CloseIcon = ({ size = 20, className }) => /* @__PURE__ */ jsx("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: /* @__PURE__ */ jsx("path", {
		d: "M5 5L15 15M15 5L5 15",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round"
	})
});
var PersonIcon = ({ size = 24, className }) => /* @__PURE__ */ jsxs("svg", {
	width: size,
	height: size,
	viewBox: "0 0 24 24",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: [/* @__PURE__ */ jsx("circle", {
		cx: "12",
		cy: "8",
		r: "3.5",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M4 20c0-4.4 3.6-7 8-7s8 2.6 8 7",
		stroke: "currentColor",
		strokeWidth: "1.75",
		strokeLinecap: "round",
		fill: "none"
	})]
});
var ChevronDownIcon = ({ size = 20, className }) => /* @__PURE__ */ jsx("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: /* @__PURE__ */ jsx("path", {
		d: "M5.5 8L10 12.5L14.5 8",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
var OpenMatchIcon = ({ size = 20, className }) => /* @__PURE__ */ jsx("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: /* @__PURE__ */ jsx("path", {
		d: "M6 6L14 14M14 6L6 14",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round"
	})
});
var FalsePositiveIcon = ({ size = 20, className }) => /* @__PURE__ */ jsxs("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: [/* @__PURE__ */ jsx("circle", {
		cx: "10",
		cy: "10",
		r: "6.5",
		stroke: "currentColor",
		strokeWidth: "1.5"
	}), /* @__PURE__ */ jsx("path", {
		d: "M5.5 14.5L14.5 5.5",
		stroke: "currentColor",
		strokeWidth: "1.5"
	})]
});
var MatchProfileIcon = ({ size = 20, className }) => /* @__PURE__ */ jsx("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: /* @__PURE__ */ jsx("path", {
		d: "M4.5 10.5L8 14L15.5 6",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
var ChevronLeftIcon = ({ size = 20, className }) => /* @__PURE__ */ jsx("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: /* @__PURE__ */ jsx("path", {
		d: "M12 5.5L7.5 10L12 14.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
var ChevronRightIcon = ({ size = 20, className }) => /* @__PURE__ */ jsx("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: /* @__PURE__ */ jsx("path", {
		d: "M8 5.5L12.5 10L8 14.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
var DownloadIcon = ({ size = 20, className }) => /* @__PURE__ */ jsxs("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: [/* @__PURE__ */ jsx("path", {
		d: "M10 3.5V12.5M10 12.5L6.5 9M10 12.5L13.5 9",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M4 14.5V15.5C4 15.9 4.3 16.5 5 16.5H15C15.7 16.5 16 15.9 16 15.5V14.5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
var ExternalLinkIcon = ({ size = 20, className }) => /* @__PURE__ */ jsxs("svg", {
	width: size,
	height: size,
	viewBox: "0 0 20 20",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M11 4.5H15.5V9",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M15.5 4.5L9 11",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.5 11.5V15C13.5 15.3 13.3 15.5 13 15.5H5C4.7 15.5 4.5 15.3 4.5 15V7C4.5 6.7 4.7 6.5 5 6.5H8.5",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
var SearchOffIcon = ({ size = 48, className }) => /* @__PURE__ */ jsxs("svg", {
	width: size,
	height: size,
	viewBox: "0 0 48 48",
	fill: "none",
	className,
	"aria-hidden": "true",
	children: [
		/* @__PURE__ */ jsx("circle", {
			cx: "21",
			cy: "21",
			r: "12",
			stroke: "currentColor",
			strokeWidth: "2"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M30 30L41 41",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M16 16L26 26M26 16L16 26",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})
	]
});
//#endregion
//#region src/aml-screening/components/AmlHeader.tsx
var AmlHeader = ({ personName, personDateOfBirth, onClose, closeLabel }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.header,
		children: [/* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.headerIdentity,
			children: [
				/* @__PURE__ */ jsx("div", {
					className: AmlScreeningRoot_module_default.avatarBadge,
					children: /* @__PURE__ */ jsx(PersonIcon, { size: 20 })
				}),
				/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.personName,
					children: personName
				}),
				/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.personDob,
					children: personDateOfBirth
				})
			]
		}), /* @__PURE__ */ jsx("button", {
			type: "button",
			className: AmlScreeningRoot_module_default.closeButton,
			onClick: onClose,
			"aria-label": closeLabel,
			children: /* @__PURE__ */ jsx(CloseIcon, {})
		})]
	});
};
//#endregion
//#region src/aml-screening/components/AmlToolbar.tsx
var AmlToolbar = ({ listLabel, matchesFoundLabel, selectAllLabel, onSelectAll, selectAllDisabled, filterValue, filterOptions, onFilterChange }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.toolbar,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.toolbarListLabel,
				children: [/* @__PURE__ */ jsx("span", { children: listLabel }), /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.toolbarSelectWrapper,
					children: [/* @__PURE__ */ jsx("select", {
						className: AmlScreeningRoot_module_default.toolbarSelect,
						value: filterValue,
						"aria-label": listLabel,
						onChange: (event) => onFilterChange(event.target.value),
						children: filterOptions.map((option) => /* @__PURE__ */ jsx("option", {
							value: option.value,
							children: option.label
						}, option.value))
					}), /* @__PURE__ */ jsx(ChevronDownIcon, {
						size: 20,
						className: AmlScreeningRoot_module_default.toolbarSelectChevron
					})]
				})]
			}),
			/* @__PURE__ */ jsx("span", { children: matchesFoundLabel }),
			/* @__PURE__ */ jsx("button", {
				type: "button",
				className: AmlScreeningRoot_module_default.selectAllButton,
				onClick: onSelectAll,
				disabled: selectAllDisabled,
				children: selectAllLabel
			})
		]
	});
};
//#endregion
//#region src/aml-screening/domain/states.ts
var AmlScreeningStatus = /* @__PURE__ */ function(AmlScreeningStatus) {
	AmlScreeningStatus["Success"] = "SUCCESS";
	AmlScreeningStatus["Fail"] = "FAIL";
	AmlScreeningStatus["Unavailable"] = "UNAVAILABLE";
	return AmlScreeningStatus;
}({});
var MatchResolution = /* @__PURE__ */ function(MatchResolution) {
	MatchResolution["FalsePositive"] = "FalsePositive";
	MatchResolution["TruePositive"] = "TruePositive";
	MatchResolution["Open"] = "Open";
	return MatchResolution;
}({});
//#endregion
//#region src/aml-screening/components/AmlBulkActionBar.tsx
var ACTION_ICONS = {
	[MatchResolution.Open]: OpenMatchIcon,
	[MatchResolution.FalsePositive]: FalsePositiveIcon,
	[MatchResolution.TruePositive]: MatchProfileIcon
};
var AmlBulkActionBar = ({ selectedCountLabel, setThemAsLabel, actions, onResolve }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.bulkBar,
		children: [
			/* @__PURE__ */ jsx("span", {
				className: AmlScreeningRoot_module_default.bulkBarCount,
				children: selectedCountLabel
			}),
			/* @__PURE__ */ jsx("span", {
				className: AmlScreeningRoot_module_default.bulkBarSetAs,
				children: setThemAsLabel
			}),
			/* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.bulkBarActions,
				children: actions.map((action) => {
					const Icon = ACTION_ICONS[action.resolution];
					return /* @__PURE__ */ jsxs("button", {
						type: "button",
						className: AmlScreeningRoot_module_default.secondaryButton,
						onClick: () => onResolve(action.resolution),
						children: [/* @__PURE__ */ jsx(Icon, { size: 20 }), action.label]
					}, action.resolution);
				})
			})
		]
	});
};
//#endregion
//#region src/aml-screening/components/AmlCriteriaBar.tsx
var AmlCriteriaBar = ({ criteria, datasetsLabel, countryLabel, genderLabel }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.criteriaBar,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.criteriaItem,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.criteriaLabel,
					children: datasetsLabel
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.criteriaValue,
					children: criteria.datasets.join(", ")
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.criteriaItem,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.criteriaLabel,
					children: countryLabel
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.criteriaValue,
					children: criteria.country
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.criteriaItem,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.criteriaLabel,
					children: genderLabel
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.criteriaValue,
					children: criteria.gender
				})]
			})
		]
	});
};
//#endregion
//#region src/aml-screening/components/Avatar.tsx
var Avatar = ({ photoUrl }) => /* @__PURE__ */ jsx("div", {
	className: AmlScreeningRoot_module_default.avatar,
	children: photoUrl ? /* @__PURE__ */ jsx("img", {
		src: photoUrl,
		alt: ""
	}) : /* @__PURE__ */ jsx(PersonIcon, { size: 32 })
});
//#endregion
//#region ../../node_modules/country-flag-icons/modules/countries.json.js
var countries_json_default = [
	"AC",
	"AD",
	"AE",
	"AF",
	"AG",
	"AI",
	"AL",
	"AM",
	"AO",
	"AQ",
	"AR",
	"AS",
	"AT",
	"AU",
	"AW",
	"AX",
	"AZ",
	"BA",
	"BB",
	"BD",
	"BE",
	"BF",
	"BG",
	"BH",
	"BI",
	"BJ",
	"BL",
	"BM",
	"BN",
	"BO",
	"BQ-BO",
	"BQ-SA",
	"BQ-SE",
	"BQ",
	"BR",
	"BS",
	"BT",
	"BV",
	"BW",
	"BY",
	"BZ",
	"CA",
	"CC",
	"CD",
	"CF",
	"CG",
	"CH",
	"CI",
	"CK",
	"CL",
	"CM",
	"CN",
	"CO",
	"CR",
	"CU",
	"CV",
	"CW",
	"CX",
	"CY",
	"CZ",
	"DE",
	"DJ",
	"DK",
	"DM",
	"DO",
	"DZ",
	"EC",
	"EE",
	"EG",
	"EH",
	"ER",
	"ES-CT",
	"ES",
	"ET",
	"EU",
	"FI",
	"FJ",
	"FK",
	"FM",
	"FO",
	"FR",
	"GA",
	"GB-ENG",
	"GB-NIR",
	"GB-SCT",
	"GB-WLS",
	"GB",
	"GD",
	"GE",
	"GF",
	"GG",
	"GH",
	"GI",
	"GL",
	"GM",
	"GN",
	"GP",
	"GQ",
	"GR",
	"GS",
	"GT",
	"GU",
	"GW",
	"GY",
	"HK",
	"HM",
	"HN",
	"HR",
	"HT",
	"HU",
	"IC",
	"ID",
	"IE",
	"IL",
	"IM",
	"IN",
	"IO",
	"IQ",
	"IR",
	"IS",
	"IT",
	"JE",
	"JM",
	"JO",
	"JP",
	"KE",
	"KG",
	"KH",
	"KI",
	"KM",
	"KN",
	"KP",
	"KR",
	"KW",
	"KY",
	"KZ",
	"LA",
	"LB",
	"LC",
	"LI",
	"LK",
	"LR",
	"LS",
	"LT",
	"LU",
	"LV",
	"LY",
	"MA",
	"MC",
	"MD",
	"ME",
	"MF",
	"MG",
	"MH",
	"MK",
	"ML",
	"MM",
	"MN",
	"MO",
	"MP",
	"MQ",
	"MR",
	"MS",
	"MT",
	"MU",
	"MV",
	"MW",
	"MX",
	"MY",
	"MZ",
	"NA",
	"NC",
	"NE",
	"NF",
	"NG",
	"NI",
	"NL",
	"NO",
	"NP",
	"NR",
	"NU",
	"NZ",
	"OM",
	"PA",
	"PE",
	"PF",
	"PG",
	"PH",
	"PK",
	"PL",
	"PM",
	"PN",
	"PR",
	"PS",
	"PT",
	"PW",
	"PY",
	"QA",
	"RE",
	"RO",
	"RS",
	"RU",
	"RW",
	"SA",
	"SB",
	"SC",
	"SD",
	"SE",
	"SG",
	"SH",
	"SI",
	"SJ",
	"SK",
	"SL",
	"SM",
	"SN",
	"SO",
	"SR",
	"SS",
	"ST",
	"SV",
	"SX",
	"SY",
	"SZ",
	"TA",
	"TC",
	"TD",
	"TF",
	"TG",
	"TH",
	"TJ",
	"TK",
	"TL",
	"TM",
	"TN",
	"TO",
	"TR",
	"TT",
	"TV",
	"TW",
	"TZ",
	"UA",
	"UG",
	"UM",
	"US",
	"UY",
	"UZ",
	"VA",
	"VC",
	"VE",
	"VG",
	"VI",
	"VN",
	"VU",
	"WF",
	"WS",
	"XA",
	"XC",
	"XK",
	"XO",
	"YE",
	"YT",
	"ZA",
	"ZM",
	"ZW"
];
//#endregion
//#region ../../node_modules/country-flag-icons/modules/hasFlag.js
function hasFlag(country) {
	return countries_json_default.indexOf(country) >= 0;
}
//#endregion
//#region ../../node_modules/country-flag-icons/modules/react/3x2/index.js
var _excluded$1 = ["title"], _excluded2 = ["title"], _excluded3 = ["title"], _excluded4 = ["title"], _excluded5 = ["title"], _excluded6 = ["title"], _excluded7 = ["title"], _excluded8 = ["title"], _excluded9 = ["title"], _excluded10 = ["title"], _excluded11 = ["title"], _excluded12 = ["title"], _excluded13 = ["title"], _excluded14 = ["title"], _excluded15 = ["title"], _excluded16 = ["title"], _excluded17 = ["title"], _excluded18 = ["title"], _excluded19 = ["title"], _excluded20 = ["title"], _excluded21 = ["title"], _excluded22 = ["title"], _excluded23 = ["title"], _excluded24 = ["title"], _excluded25 = ["title"], _excluded26 = ["title"], _excluded27 = ["title"], _excluded28 = ["title"], _excluded29 = ["title"], _excluded30 = ["title"], _excluded31 = ["title"], _excluded32 = ["title"], _excluded33 = ["title"], _excluded34 = ["title"], _excluded35 = ["title"], _excluded36 = ["title"], _excluded37 = ["title"], _excluded38 = ["title"], _excluded39 = ["title"], _excluded40 = ["title"], _excluded41 = ["title"], _excluded42 = ["title"], _excluded43 = ["title"], _excluded44 = ["title"], _excluded45 = ["title"], _excluded46 = ["title"], _excluded47 = ["title"], _excluded48 = ["title"], _excluded49 = ["title"], _excluded50 = ["title"], _excluded51 = ["title"], _excluded52 = ["title"], _excluded53 = ["title"], _excluded54 = ["title"], _excluded55 = ["title"], _excluded56 = ["title"], _excluded57 = ["title"], _excluded58 = ["title"], _excluded59 = ["title"], _excluded60 = ["title"], _excluded61 = ["title"], _excluded62 = ["title"], _excluded63 = ["title"], _excluded64 = ["title"], _excluded65 = ["title"], _excluded66 = ["title"], _excluded67 = ["title"], _excluded68 = ["title"], _excluded69 = ["title"], _excluded70 = ["title"], _excluded71 = ["title"], _excluded72 = ["title"], _excluded73 = ["title"], _excluded74 = ["title"], _excluded75 = ["title"], _excluded76 = ["title"], _excluded77 = ["title"], _excluded78 = ["title"], _excluded79 = ["title"], _excluded80 = ["title"], _excluded81 = ["title"], _excluded82 = ["title"], _excluded83 = ["title"], _excluded84 = ["title"], _excluded85 = ["title"], _excluded86 = ["title"], _excluded87 = ["title"], _excluded88 = ["title"], _excluded89 = ["title"], _excluded90 = ["title"], _excluded91 = ["title"], _excluded92 = ["title"], _excluded93 = ["title"], _excluded94 = ["title"], _excluded95 = ["title"], _excluded96 = ["title"], _excluded97 = ["title"], _excluded98 = ["title"], _excluded99 = ["title"], _excluded100 = ["title"], _excluded101 = ["title"], _excluded102 = ["title"], _excluded103 = ["title"], _excluded104 = ["title"], _excluded105 = ["title"], _excluded106 = ["title"], _excluded107 = ["title"], _excluded108 = ["title"], _excluded109 = ["title"], _excluded110 = ["title"], _excluded111 = ["title"], _excluded112 = ["title"], _excluded113 = ["title"], _excluded114 = ["title"], _excluded115 = ["title"], _excluded116 = ["title"], _excluded117 = ["title"], _excluded118 = ["title"], _excluded119 = ["title"], _excluded120 = ["title"], _excluded121 = ["title"], _excluded122 = ["title"], _excluded123 = ["title"], _excluded124 = ["title"], _excluded125 = ["title"], _excluded126 = ["title"], _excluded127 = ["title"], _excluded128 = ["title"], _excluded129 = ["title"], _excluded130 = ["title"], _excluded131 = ["title"], _excluded132 = ["title"], _excluded133 = ["title"], _excluded134 = ["title"], _excluded135 = ["title"], _excluded136 = ["title"], _excluded137 = ["title"], _excluded138 = ["title"], _excluded139 = ["title"], _excluded140 = ["title"], _excluded141 = ["title"], _excluded142 = ["title"], _excluded143 = ["title"], _excluded144 = ["title"], _excluded145 = ["title"], _excluded146 = ["title"], _excluded147 = ["title"], _excluded148 = ["title"], _excluded149 = ["title"], _excluded150 = ["title"], _excluded151 = ["title"], _excluded152 = ["title"], _excluded153 = ["title"], _excluded154 = ["title"], _excluded155 = ["title"], _excluded156 = ["title"], _excluded157 = ["title"], _excluded158 = ["title"], _excluded159 = ["title"], _excluded160 = ["title"], _excluded161 = ["title"], _excluded162 = ["title"], _excluded163 = ["title"], _excluded164 = ["title"], _excluded165 = ["title"], _excluded166 = ["title"], _excluded167 = ["title"], _excluded168 = ["title"], _excluded169 = ["title"], _excluded170 = ["title"], _excluded171 = ["title"], _excluded172 = ["title"], _excluded173 = ["title"], _excluded174 = ["title"], _excluded175 = ["title"], _excluded176 = ["title"], _excluded177 = ["title"], _excluded178 = ["title"], _excluded179 = ["title"], _excluded180 = ["title"], _excluded181 = ["title"], _excluded182 = ["title"], _excluded183 = ["title"], _excluded184 = ["title"], _excluded185 = ["title"], _excluded186 = ["title"], _excluded187 = ["title"], _excluded188 = ["title"], _excluded189 = ["title"], _excluded190 = ["title"], _excluded191 = ["title"], _excluded192 = ["title"], _excluded193 = ["title"], _excluded194 = ["title"], _excluded195 = ["title"], _excluded196 = ["title"], _excluded197 = ["title"], _excluded198 = ["title"], _excluded199 = ["title"], _excluded200 = ["title"], _excluded201 = ["title"], _excluded202 = ["title"], _excluded203 = ["title"], _excluded204 = ["title"], _excluded205 = ["title"], _excluded206 = ["title"], _excluded207 = ["title"], _excluded208 = ["title"], _excluded209 = ["title"], _excluded210 = ["title"], _excluded211 = ["title"], _excluded212 = ["title"], _excluded213 = ["title"], _excluded214 = ["title"], _excluded215 = ["title"], _excluded216 = ["title"], _excluded217 = ["title"], _excluded218 = ["title"], _excluded219 = ["title"], _excluded220 = ["title"], _excluded221 = ["title"], _excluded222 = ["title"], _excluded223 = ["title"], _excluded224 = ["title"], _excluded225 = ["title"], _excluded226 = ["title"], _excluded227 = ["title"], _excluded228 = ["title"], _excluded229 = ["title"], _excluded230 = ["title"], _excluded231 = ["title"], _excluded232 = ["title"], _excluded233 = ["title"], _excluded234 = ["title"], _excluded235 = ["title"], _excluded236 = ["title"], _excluded237 = ["title"], _excluded238 = ["title"], _excluded239 = ["title"], _excluded240 = ["title"], _excluded241 = ["title"], _excluded242 = ["title"], _excluded243 = ["title"], _excluded244 = ["title"], _excluded245 = ["title"], _excluded246 = ["title"], _excluded247 = ["title"], _excluded248 = ["title"], _excluded249 = ["title"], _excluded250 = ["title"], _excluded251 = ["title"], _excluded252 = ["title"], _excluded253 = ["title"], _excluded254 = ["title"], _excluded255 = ["title"], _excluded256 = ["title"], _excluded257 = ["title"], _excluded258 = ["title"], _excluded259 = ["title"], _excluded260 = ["title"], _excluded261 = ["title"], _excluded262 = ["title"], _excluded263 = ["title"], _excluded264 = ["title"], _excluded265 = ["title"];
function _extends() {
	_extends = Object.assign || function(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			for (var key in source) if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
		}
		return target;
	};
	return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
	if (source == null) return {};
	var target = _objectWithoutPropertiesLoose(source, excluded);
	var key, i;
	if (Object.getOwnPropertySymbols) {
		var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
		for (i = 0; i < sourceSymbolKeys.length; i++) {
			key = sourceSymbolKeys[i];
			if (excluded.indexOf(key) >= 0) continue;
			if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
			target[key] = source[key];
		}
	}
	return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
	if (source == null) return {};
	var target = {};
	var sourceKeys = Object.keys(source);
	var key, i;
	for (i = 0; i < sourceKeys.length; i++) {
		key = sourceKeys[i];
		if (excluded.indexOf(key) >= 0) continue;
		target[key] = source[key];
	}
	return target;
}
var AC = function AC(_ref) {
	var title = _ref.title, rest = _objectWithoutProperties(_ref, _excluded$1);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1B81B6",
		d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1B81B6",
		d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1B81B6",
		d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#288549",
		d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M275.9 223.6c3.6-26.7 13.5-47.3 22.1-46.2s12.6 23.7 9 50.4-13.5 47.3-22.1 46.2c-8.6-1.2-12.6-23.7-9-50.4zm191.2-45.9c8.6-1.2 18.5 19.5 22.1 46.2s-.4 49.2-9 50.4-18.5-19.6-22.2-46.3c-3.6-26.6.5-49.2 9.1-50.3z",
		fill: "#F0955D"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M296.4 162c2.4-6 7.4-9.7 11-8.2 3.7 1.5 4.7 7.5 2.3 13.5s-7.4 9.7-11 8.2c-3.6-1.5-4.7-7.5-2.3-13.5zm-8 109.2c.9-6.2 3.1-11.1 4.9-10.8s2.5 5.5 1.6 11.8c-.9 6.2-3.1 11.1-4.9 10.8s-2.5-5.5-1.6-11.8zm10.6-12.8c1.8-.1 3.6 4.7 3.9 10.8s-.9 11.1-2.7 11.2c-1.8.1-3.6-4.7-3.9-10.8-.3-6.1.9-11.1 2.7-11.2zm10.5-70c2.1-.8 6.1 4.2 8.8 11.2 2.8 7 3.3 13.4 1.2 14.2-2.1.8-6.1-4.2-8.8-11.2-2.8-7-3.3-13.4-1.2-14.2zm6.5-14.1c7-2.8 13.4-3.3 14.2-1.2.8 2.1-4.2 6.1-11.2 8.8-7 2.8-13.4 3.3-14.2 1.2-.9-2.1 4.2-6 11.2-8.8zm141.6-20.2c3.7-1.5 8.6 2.2 11 8.2 2.4 6 1.4 12.1-2.3 13.5-3.7 1.5-8.6-2.2-11-8.2-2.4-6-1.3-12.1 2.3-13.5zm14.2 106.5c1.8-.3 4 4.6 4.9 10.8.9 6.2.2 11.5-1.6 11.8-1.8.3-4-4.6-4.9-10.8-1-6.3-.2-11.5 1.6-11.8zm-9.6 8.8c.3-6.1 2.1-10.9 3.9-10.8 1.8.1 3 5.1 2.7 11.2-.3 6.1-2.1 10.9-3.9 10.8-1.8-.1-3-5.1-2.7-11.2zm-15.5-69.7c2.8-7 6.7-12.1 8.8-11.2 2.1.8 1.6 7.2-1.2 14.2-2.8 7-6.7 12.1-8.8 11.2s-1.6-7.2 1.2-14.2zm-11.8-26.5c.8-2.1 7.2-1.6 14.2 1.2 7 2.8 12.1 6.7 11.2 8.8-.8 2.1-7.2 1.6-14.2-1.2-7-2.7-12.1-6.7-11.2-8.8z",
		fill: "#EADFD5"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#B0C6CC",
		d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var AD = function AD(_ref2) {
	var title = _ref2.title, rest = _objectWithoutProperties(_ref2, _excluded2);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#fedd00",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#10069f",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d50032",
		d: "M342 0h171v342H342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M198.9 113.6H256v64.8h-57.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
		stroke: "#D80027",
		strokeWidth: 7
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
		stroke: "#D80027",
		strokeWidth: 5
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#BC8B00",
		d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
	}));
};
var AE = function AE(_ref3) {
	var title = _ref3.title, rest = _objectWithoutProperties(_ref3, _excluded3);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00843d",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 228h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#c8102e",
		d: "M0 0h171v342H0z"
	}));
};
var AF = function AF(_ref4) {
	var title = _ref4.title, rest = _objectWithoutProperties(_ref4, _excluded4);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D32011",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#007A36",
		d: "M342 0h171v342H342z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h171v342H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256.5 131.3c-17.5 0-31.8 14.3-31.8 31.8v47.7h63.6v-47.7c0-17.7-14.3-31.8-31.8-31.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256.5 93c-43.1 0-78 34.9-78 78s34.9 77.9 78 77.9 78-34.9 78-78-34.9-77.9-78-77.9zm0 142.4c-35.6 0-64.5-28.9-64.5-64.5s28.9-64.5 64.5-64.5 64.5 29 64.5 64.6c0 35.6-28.9 64.4-64.5 64.4z"
	}));
};
var AG = function AG(_ref5) {
	var title = _ref5.title, rest = _objectWithoutProperties(_ref5, _excluded5);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v342H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#0072c6",
		d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#ce1126" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 342 0 0v342z" }), /*#__PURE__*/ React.createElement("path", { d: "M513 342V0L256 342z" })));
};
var AI = function AI(_ref6) {
	var title = _ref6.title, rest = _objectWithoutProperties(_ref6, _excluded6);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#9cf",
		d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#f90" }, /*#__PURE__*/ React.createElement("path", { d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z" }), /*#__PURE__*/ React.createElement("path", { d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var AL = function AL(_ref7) {
	var title = _ref7.title, rest = _objectWithoutProperties(_ref7, _excluded7);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 90 60"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ED2024",
		d: "M0 0h90v60H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#212121",
		d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
		fill: "#212121"
	}));
};
var AM = function AM(_ref8) {
	var title = _ref8.title, rest = _objectWithoutProperties(_ref8, _excluded8);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF9811",
		d: "M0 228h513v114H0z"
	}));
};
var AO = function AO(_ref9) {
	var title = _ref9.title, rest = _objectWithoutProperties(_ref9, _excluded9);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 171h513v171H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFDA44" }, /*#__PURE__*/ React.createElement("path", { d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z" }), /*#__PURE__*/ React.createElement("path", { d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#000",
		d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z" })));
};
var AQ = function AQ(_ref10) {
	var title = _ref10.title, rest = _objectWithoutProperties(_ref10, _excluded10);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 744 496"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#3A7DCE",
		d: "M0 0h744v496H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
	}));
};
var AR = function AR(_ref11) {
	var title = _ref11.title, rest = _objectWithoutProperties(_ref11, _excluded11);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h512v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 0h512v114H0zm0 228h512v114H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFDA44",
		stroke: "#d6ab00",
		strokeWidth: 5,
		cx: 256.5,
		cy: 171,
		r: 40
	}));
};
var AS = function AS(_ref12) {
	var title = _ref12.title, rest = _objectWithoutProperties(_ref12, _excluded12);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#10338c",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 287.18v24.58L81.72 171 513 30v24.16"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A2001D",
		d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#EFC100",
		stroke: "#231F20",
		strokeMiterlimit: 10,
		d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
	}));
};
var AT = function AT(_ref13) {
	var title = _ref13.title, rest = _objectWithoutProperties(_ref13, _excluded13);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0zm0 228h513v114H0z"
	}));
};
var AU = function AU(_ref14) {
	var title = _ref14.title, rest = _objectWithoutProperties(_ref14, _excluded14);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#00008b",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m188 212.6 11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00008b",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "red" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var AW = function AW(_ref15) {
	var title = _ref15.title, rest = _objectWithoutProperties(_ref15, _excluded15);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 363 242"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 0h363v242H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f30028",
		d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
		fill: "#FFDA44"
	}));
};
var AX = function AX(_ref16) {
	var title = _ref16.title, rest = _objectWithoutProperties(_ref16, _excluded16);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
	}));
};
var AZ = function AZ(_ref17) {
	var title = _ref17.title, rest = _objectWithoutProperties(_ref17, _excluded17);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ef3340",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00b5e2",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#509e2f",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z" }), /*#__PURE__*/ React.createElement("path", { d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z" })));
};
var BA = function BA(_ref18) {
	var title = _ref18.title, rest = _objectWithoutProperties(_ref18, _excluded18);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#10338C",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F6C500",
		d: "M99.9 0h342v342"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z" }), /*#__PURE__*/ React.createElement("path", { d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z" }), /*#__PURE__*/ React.createElement("path", { d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z" }), /*#__PURE__*/ React.createElement("path", { d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z" }), /*#__PURE__*/ React.createElement("path", { d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z" }), /*#__PURE__*/ React.createElement("path", { d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z" }), /*#__PURE__*/ React.createElement("path", { d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z" }), /*#__PURE__*/ React.createElement("path", { d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z" }), /*#__PURE__*/ React.createElement("path", { d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z" })));
};
var BB = function BB(_ref19) {
	var title = _ref19.title, rest = _objectWithoutProperties(_ref19, _excluded19);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc726",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h171v342H0zm342 0h171v342H342z",
		fill: "#00267f"
	}), /*#__PURE__*/ React.createElement("path", { d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z" }));
};
var BD = function BD(_ref20) {
	var title = _ref20.title, rest = _objectWithoutProperties(_ref20, _excluded20);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#2d6e41",
		d: "M0 85.331h513v342H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#F40B32",
		cx: 218.902,
		cy: 256.5,
		r: 115
	}));
};
var BE = function BE(_ref21) {
	var title = _ref21.title, rest = _objectWithoutProperties(_ref21, _excluded21);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#fdda25",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h171v342H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#ef3340",
		d: "M342 0h171v342H342z"
	}));
};
var BF = function BF(_ref22) {
	var title = _ref22.title, rest = _objectWithoutProperties(_ref22, _excluded22);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#3d944f",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ef2b2d",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
	}));
};
var BG = function BG(_ref23) {
	var title = _ref23.title, rest = _objectWithoutProperties(_ref23, _excluded23);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#00966e",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d62612",
		d: "M0 228h513v114H0z"
	}));
};
var BH = function BH(_ref24) {
	var title = _ref24.title, rest = _objectWithoutProperties(_ref24, _excluded24);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
	}));
};
var BI = function BI(_ref25) {
	var title = _ref25.title, rest = _objectWithoutProperties(_ref25, _excluded25);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
		fill: "#47a644"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 251.6,
		cy: 170.7,
		r: 100.2
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
		fill: "#D80027",
		stroke: "#47a644",
		strokeWidth: 3
	}));
};
var BJ = function BJ(_ref26) {
	var title = _ref26.title, rest = _objectWithoutProperties(_ref26, _excluded26);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#008751",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fcd116",
		d: "M197 0h316v171H197z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#e8112d",
		d: "M197 171h316v171H197z"
	}));
};
var BL = function BL(_ref27) {
	var title = _ref27.title, rest = _objectWithoutProperties(_ref27, _excluded27);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M157.3 199.8s-9 43.9-19.3 40.4c-10.6-3.5-17.5-18.8-17.5-18.8L106 242.6s38.2 8.5 41 5.5c1.2-1.1 8.2-15.1 10.3-26.1v-22.2zm-56.1 60.5s-2.5 20.2-1.1 22.7c1.2 2.3 39.5 11.3 39.5 11.3s-25 16.5-29.7 20.5l-18.1-29.9-.7-24.6h10.1zm11.3-165.7s39.7 41.6 40.4 45.5c.7 3.7-4.2 3.2-4.2 3.2s-44.8-37.5-49.9-41.1c-5.4-3.5 13.7-7.6 13.7-7.6zm246.7 106.7s9 42.4 19.2 38.9c10.6-3.5 17.5-18.8 17.5-18.8l14.5 21.2s-37 8.5-39.8 5.5c-1.2-1.1-9.3-13.8-11.5-24.7l.1-22.1zm56 59s2.5 20.2 1.1 22.7c-1.2 2.3-39.5 11.3-39.5 11.3s25 16.5 29.7 20.5l18.1-29.9.7-24.6h-10.1zM403.9 94.6s-39.6 41.6-40.4 45.5c-.7 3.7 4.2 3.2 4.2 3.2s44.8-37.5 49.9-41.1c5.2-3.5-13.7-7.6-13.7-7.6z",
		fill: "#E6BC00"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M99.4 104.7s17-.7 16.6-11.5c-.4-10.6-11.2-14.9-19.1-12.4-8 2.3-23 13.4-13.6 35.1 9.4 21.4 23.4 29.4 26.2 47.8 0 0-5.5 9.9-19.1.4-16.9-11.8-6.2-38.2-10.4-45-4.2-7.1-41-38.9-41-38.9s-30.2 39.4-18 74.9c17 49.2 51.7 32 64.6 36.8 0 0-42.1 62-49.6 67.1 0 0 24.1 8.3 47.8-18.8 0 0 5.8 9.7 7.1 20.2h10.3c4.8-26.2 51.5-64.3 49.9-82.3-1.8-21.3-49.2-49.5-51.7-73.4zM365.1 178c-1.6 18.1 45.1 56.1 49.9 82.3h10.3c1.2-10.4 7.1-20.2 7.1-20.2 23.7 27.1 47.8 18.8 47.8 18.8-7.4-5.1-49.6-67.1-49.6-67.1 12.9-4.8 47.7 12.4 64.6-36.8 12.2-35.6-18-74.9-18-74.9s-36.7 31.8-41 38.9c-4.2 6.7 6.5 33.2-10.4 45-13.7 9.5-19.1-.4-19.1-.4 2.8-18.4 16.8-26.4 26.2-47.8 9.4-21.6-5.7-32.8-13.6-35.1-8-2.5-18.8 1.8-19.1 12.4-.4 10.8 16.6 11.5 16.6 11.5-2.5 24-49.9 52.2-51.7 73.4z",
		fill: "#ADADAD"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#125ECC",
		d: "M157.3 87.1h201.8v145.5c0 16.1-9.7 21.4-21.9 31.8l-45.9 39.4c-18.2 15.6-47.9 15.6-66.1 0l-46-39.4c-12.1-10.4-21.9-15.7-21.9-31.8V87.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFE600",
		d: "M200.6 147.7c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.4 14.4 14.4-6.5 14.4-14.4 14.4zm57.6-3c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.4 14.4 14.4-6.4 14.4-14.4 14.4zm57.7 3c-8 0-14.4-6.4-14.4-14.4s6.5-14.4 14.4-14.4 14.4 6.4 14.4 14.4-6.5 14.4-14.4 14.4zM215 274.4c-8 0-14.4-6.5-14.4-14.4 0-8 6.4-14.4 14.4-14.4s14.4 6.4 14.4 14.4-6.5 14.4-14.4 14.4zm43.2 14.5c-8 0-14.4-6.5-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.5 14.4 14.4-6.4 14.4-14.4 14.4zm43.2-14.5c-8 0-14.4-6.5-14.4-14.4 0-8 6.5-14.4 14.4-14.4s14.4 6.4 14.4 14.4c.1 8-6.4 14.4-14.4 14.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D60537",
		d: "M157.3 175.4h201.8V233H157.3v-57.6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#EACE00",
		d: "M142.9 43.8s57.6-14.4 115.3-14.4 115.3 14.4 115.3 14.4l-14.4 57.7s-50.5-14.4-100.9-14.4-100.9 14.4-100.9 14.4l-14.4-57.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#7A6920",
		d: "M258.2 72.7c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4 14.4 6.5 14.4 14.4-6.4 14.4-14.4 14.4zm57.7 5c-8 0-14.4-6.4-14.4-14.4s6.5-14.4 14.4-14.4 14.4 6.5 14.4 14.4-6.5 14.4-14.4 14.4zm-115.3 0c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4S215 55.3 215 63.2s-6.5 14.5-14.4 14.5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 258.2,
		cy: 204.2,
		r: 16.9
	}));
};
var BM = function BM(_ref28) {
	var title = _ref28.title, rest = _objectWithoutProperties(_ref28, _excluded28);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#c8102e",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		stroke: "#000",
		strokeWidth: 2,
		d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#2F8F22",
		d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#65B5D2",
		cx: 383.65,
		cy: 214.56,
		r: 39.88
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#c8102e",
		cx: 343.77,
		cy: 194.63,
		r: 19.94
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#c8102e",
		cx: 423.52,
		cy: 194.63,
		r: 19.94
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#c8102e",
		cx: 383.65,
		cy: 154.75,
		r: 19.94
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#c8102e" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var BN = function BN(_ref29) {
	var title = _ref29.title, rest = _objectWithoutProperties(_ref29, _excluded29);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "m0 193.74 513 127.19V214.26L0 97.08z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 234.26v-86.67L0 20.41v86.67"
	}), /*#__PURE__*/ React.createElement("g", {
		fill: "#D80027",
		stroke: "#231F20",
		strokeWidth: 3,
		strokeMiterlimit: 10
	}, /*#__PURE__*/ React.createElement("path", { d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z" }), /*#__PURE__*/ React.createElement("path", { d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z" })));
};
var BO = function BO(_ref30) {
	var title = _ref30.title, rest = _objectWithoutProperties(_ref30, _excluded30);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#d52b1e",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f9e300",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#007934",
		d: "M0 228h513v114H0z"
	}));
};
var BQ_BO = function BQ_BO(_ref31) {
	var title = _ref31.title, rest = _objectWithoutProperties(_ref31, _excluded31);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012a87",
		d: "M0 342h513V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f9d90f",
		d: "M250.4 0H0v166.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#dc171d",
		d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "none",
		stroke: "#000",
		strokeWidth: 9,
		strokeMiterlimit: 10,
		cx: 140.4,
		cy: 160.6,
		r: 57.7
	}));
};
var BQ_SA = function BQ_SA(_ref32) {
	var title = _ref32.title, rest = _objectWithoutProperties(_ref32, _excluded32);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#DC171D",
		d: "M512 342H0V.7h512V342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012A87",
		d: "M512 342H0V171.3h512V342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256 342 0 171.3 256 .7l256 170.7L256 342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F9D90F",
		d: "m199.2 249.5 21.7-66.8-56.8-41.2h70.5L256 74.7l21.7 66.8h70.2l-56.8 41.2 21.7 66.8-56.8-41.3z"
	}));
};
var BQ_SE = function BQ_SE(_ref33) {
	var title = _ref33.title, rest = _objectWithoutProperties(_ref33, _excluded33);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h900v600H0z",
		fill: "#dc171d"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M450 168.787 215.691 300 450 431.213 684.309 300z",
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M281.477 336.852V376h69.961l290.727-52.4V376h-93.668z",
		fill: "#dc171f"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M188 288H20V20h418v128zm524 0h168V20H462v128zm-524 24H20v268h418V452zm524 0h168v268H462V452z",
		fill: "#012a87"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m450 199.5 8.068 24.827h26.105l-21.12 15.346 8.067 24.827L450 249.157 428.88 264.5l8.066-24.827-21.119-15.345 26.105-.001z",
		fill: "#f9d90f"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M281.477 336.852c2.712-8.848 8.614-12.77 16.594-10.995 4.94-18.73 27.739-22.07 36.786-12.857l22.273 22.37c4.837 2.251 12.207 3.095 17.326 3.095 6.33.1 5.621 3.005 10.91 3.106 14.096.27 51.143.458 57.857 0 2.75-.187 64.134-67.857 64.134-67.857 5.12-6.31 18.453-8.333 25.714-3.214 6.786 6.429 13.929 7.143 18.929 2.857 4.405-6.547 14.392-7.309 20.714-3.571l69.45 53.815L548.497 376H351.438l-69.96-39.148z",
		fill: "#008830"
	}));
};
var BQ = function BQ(_ref34) {
	var title = _ref34.title, rest = _objectWithoutProperties(_ref34, _excluded34);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012a87",
		d: "M0 342h513V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f9d90f",
		d: "M250.4 0H0v166.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#dc171d",
		d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "none",
		stroke: "#000",
		strokeWidth: 9,
		strokeMiterlimit: 10,
		cx: 140.4,
		cy: 160.6,
		r: 57.7
	}));
};
var BR = function BR(_ref35) {
	var title = _ref35.title, rest = _objectWithoutProperties(_ref35, _excluded35);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#009b3a",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fedf00",
		d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 256.5,
		cy: 171,
		r: 80.4
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#002776",
		d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
	}));
};
var BS = function BS(_ref36) {
	var title = _ref36.title, rest = _objectWithoutProperties(_ref36, _excluded36);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc72c",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v114H0zm0 228h513v114H0z",
		fill: "#00778b"
	}), /*#__PURE__*/ React.createElement("path", { d: "M256 171 0 342V0z" }));
};
var BT = function BT(_ref37) {
	var title = _ref37.title, rest = _objectWithoutProperties(_ref37, _excluded37);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF7415",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M513 0H0v342"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "none",
		stroke: "#FFF",
		strokeWidth: 42,
		strokeMiterlimit: 10,
		d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
	}));
};
var BV = function BV(_ref38) {
	var title = _ref38.title, rest = _objectWithoutProperties(_ref38, _excluded38);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#EF2B2D",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		className: "prefix__st1",
		d: "M139.9 0h93.3v342h-93.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		className: "prefix__st1",
		d: "M0 119h513v104.1H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#002868",
		d: "M163.2 0h46.6v342h-46.6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#002868",
		d: "M0 145h513v52H0z"
	}));
};
var BW = function BW(_ref39) {
	var title = _ref39.title, rest = _objectWithoutProperties(_ref39, _excluded39);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 238h513v104H0zM0 0h513v104H0z",
		fill: "#6da9d2"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 125.5h513v89.656H0z" }));
};
var BY = function BY(_ref40) {
	var title = _ref40.title, rest = _objectWithoutProperties(_ref40, _excluded40);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#007C30",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#CE1720",
		d: "M0 230h513V0H0"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M100 230V0H0v342h513-413z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
		fill: "#CE1720"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
		fill: "none",
		stroke: "#CE1720",
		strokeWidth: 7
	}));
};
var BZ = function BZ(_ref41) {
	var title = _ref41.title, rest = _objectWithoutProperties(_ref41, _excluded41);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#003e87",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 260.9,
		cy: 170.9,
		r: 118.9
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "none",
		stroke: "#6DA544",
		strokeWidth: 18,
		strokeMiterlimit: 10,
		cx: 261.9,
		cy: 173.1,
		r: 94.5
	}), /*#__PURE__*/ React.createElement("g", { stroke: "#000" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#003e87",
		d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M211.3 128.1h101.3v46.7H211.3z"
	})), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v35H0zm0 306h513v35H0z",
		fill: "#ce1127"
	}));
};
var CA = function CA(_ref42) {
	var title = _ref42.title, rest = _objectWithoutProperties(_ref42, _excluded42);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
		fill: "red"
	}));
};
var CC = function CC(_ref43) {
	var title = _ref43.title, rest = _objectWithoutProperties(_ref43, _excluded43);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "green",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
		fill: "#FFDA44"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A2001D",
		d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
	}));
};
var CD = function CD(_ref44) {
	var title = _ref44.title, rest = _objectWithoutProperties(_ref44, _excluded44);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
	}));
};
var CF = function CF(_ref45) {
	var title = _ref45.title, rest = _objectWithoutProperties(_ref45, _excluded45);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#d21034",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
		fill: "#3a9927"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#003082",
		d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
		fill: "#ffce00"
	}));
};
var CG = function CG(_ref46) {
	var title = _ref46.title, rest = _objectWithoutProperties(_ref46, _excluded46);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#009739",
		d: "M0 0h900v600H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 600 600 0h300v600z",
		fill: "#ffd100"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M900 0v600H300z",
		fill: "#dc241f"
	}));
};
var CH = function CH(_ref47) {
	var title = _ref47.title, rest = _objectWithoutProperties(_ref47, _excluded47);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 768 512"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "red",
		d: "M0 0h768v512H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M336 96h96v112h112v96H432v112h-96V304H224v-96h112V96z"
	}));
};
var CI = function CI(_ref48) {
	var title = _ref48.title, rest = _objectWithoutProperties(_ref48, _excluded48);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#009e60",
		d: "M342 0h171v342H342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f77f00",
		d: "M0 0h171v342H0z"
	}));
};
var CK = function CK(_ref49) {
	var title = _ref49.title, rest = _objectWithoutProperties(_ref49, _excluded49);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m384 71.4 5.3 16.2h17.1l-13.9 10.1 5.3 16.2-13.8-10-13.8 10 5.3-16.2-13.9-10.1h17.1zm-70.2 29.1 15.2 7.7 12.1-12.1-2.7 16.9 15.3 7.8-16.9 2.6-2.7 16.9-7.8-15.2-16.8 2.7 12.1-12.1zm-29.1 70.2 16.3-5.3v-17.1l10 13.8 16.3-5.3-10.1 13.9 10.1 13.8-16.3-5.3-10 13.8v-17.1zm29.1 70.2 7.7-15.3-12-12 16.8 2.6 7.8-15.2 2.7 16.9 16.9 2.7-15.3 7.7 2.7 16.9-12.1-12.1zM384 270l-5.3-16.3h-17.1l13.9-10-5.3-16.3 13.8 10 13.8-10-5.3 16.3 13.9 10h-17.1zm70.2-29.1-15.2-7.8-12.1 12.1 2.7-16.9-15.3-7.7 16.9-2.7 2.7-16.9 7.8 15.2 16.8-2.6-12.1 12zm29.1-70.2-16.3 5.2V193l-10-13.8-16.3 5.3 10.1-13.8-10.1-13.9 16.3 5.3 10-13.8v17.1zm-29.1-70.2-7.7 15.2 12 12.1-16.8-2.7-7.8 15.2-2.7-16.9-16.9-2.6 15.3-7.8-2.7-16.9 12.1 12.1z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var CL = function CL(_ref50) {
	var title = _ref50.title, rest = _objectWithoutProperties(_ref50, _excluded50);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M196 0h317v171H196z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0037A1",
		d: "M0 0h196v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
	}));
};
var CM = function CM(_ref51) {
	var title = _ref51.title, rest = _objectWithoutProperties(_ref51, _excluded51);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ce1126",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#007a5e",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
		fill: "#fcd116"
	}));
};
var CN = function CN(_ref52) {
	var title = _ref52.title, rest = _objectWithoutProperties(_ref52, _excluded52);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
		fill: "#FFDA44"
	}));
};
var CO = function CO(_ref53) {
	var title = _ref53.title, rest = _objectWithoutProperties(_ref53, _excluded53);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 256.5h513V342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 171h513v85.5H0z"
	}));
};
var CR = function CR(_ref54) {
	var title = _ref54.title, rest = _objectWithoutProperties(_ref54, _excluded54);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 285h513v57H0zM0 0h513v57H0z"
	}));
};
var CU = function CU(_ref55) {
	var title = _ref55.title, rest = _objectWithoutProperties(_ref55, _excluded55);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF9811",
		d: "M0-40.8v422.9-211.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
		fill: "#0052B4"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M256 170.7 0 342V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
	}));
};
var CV = function CV(_ref56) {
	var title = _ref56.title, rest = _objectWithoutProperties(_ref56, _excluded56);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#003893",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#cf2027",
		d: "M0 182.2h513v41.4H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
		fill: "#f7d116",
		stroke: "#000"
	}));
};
var CW = function CW(_ref57) {
	var title = _ref57.title, rest = _objectWithoutProperties(_ref57, _excluded57);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#002b7f",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f9e814",
		d: "M0 233.5h513v51H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
		fill: "#FFF"
	}));
};
var CX = function CX(_ref58) {
	var title = _ref58.title, rest = _objectWithoutProperties(_ref58, _excluded58);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0021ad",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1c8a42",
		d: "M0 0h513v342"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#ffc639",
		cx: 267.1,
		cy: 170.7,
		r: 74.5
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1c8a42",
		d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc639",
		d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
	}));
};
var CY = function CY(_ref59) {
	var title = _ref59.title, rest = _objectWithoutProperties(_ref59, _excluded59);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#DB7D00",
		d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#006651" }, /*#__PURE__*/ React.createElement("path", { d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z" }), /*#__PURE__*/ React.createElement("path", { d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z" }), /*#__PURE__*/ React.createElement("path", { d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z" })));
};
var CZ = function CZ(_ref60) {
	var title = _ref60.title, rest = _objectWithoutProperties(_ref60, _excluded60);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#11457e",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d7141a",
		d: "M513 171v171H0l256.5-171z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 0v171H256.5L0 0z"
	}));
};
var DE = function DE(_ref61) {
	var title = _ref61.title, rest = _objectWithoutProperties(_ref61, _excluded61);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 228h513v114H0z"
	}));
};
var DJ = function DJ(_ref62) {
	var title = _ref62.title, rest = _objectWithoutProperties(_ref62, _excluded62);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#12ad2b",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6ab2e7",
		d: "M513 0v166.7L0 170.8V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256 170.7 0 342V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d7141a",
		d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
	}));
};
var DK = function DK(_ref63) {
	var title = _ref63.title, rest = _objectWithoutProperties(_ref63, _excluded63);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#c60c30",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
	}));
};
var DM = function DM(_ref64) {
	var title = _ref64.title, rest = _objectWithoutProperties(_ref64, _excluded64);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 110.7v120h513v-120z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 110.7h513v40H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 190.7h513v40H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M196 0h120v342H196z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M196 0h40v342h-40z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M274.7 0h40v342h-40z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#D80027",
		cx: 256,
		cy: 170.7,
		r: 123.1
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
		fill: "#496E2D"
	}));
};
var DO = function DO(_ref65) {
	var title = _ref65.title, rest = _objectWithoutProperties(_ref65, _excluded65);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 216h211v126H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h211v126H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M302 0h211v126H302z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M302 216h211v126H302z"
	}), /*#__PURE__*/ React.createElement("g", {
		stroke: "#FFF",
		strokeWidth: 5,
		strokeMiterlimit: 10
	}, /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
	})));
};
var DZ = function DZ(_ref66) {
	var title = _ref66.title, rest = _objectWithoutProperties(_ref66, _excluded66);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#41662E",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256.5 0H513v342H256.5z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z" }), /*#__PURE__*/ React.createElement("path", { d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z" })));
};
var EC = function EC(_ref67) {
	var title = _ref67.title, rest = _objectWithoutProperties(_ref67, _excluded67);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 170.7h513V256H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 256h513v85.3H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFDA44",
		cx: 256,
		cy: 171,
		r: 60
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#4C1F00",
		d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#57BA17",
		d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
	}));
};
var EE = function EE(_ref68) {
	var title = _ref68.title, rest = _objectWithoutProperties(_ref68, _excluded68);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#111",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#368FD8",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 228h513v114H0z"
	}));
};
var EG = function EG(_ref69) {
	var title = _ref69.title, rest = _objectWithoutProperties(_ref69, _excluded69);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 228h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#C09300",
		d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
	}));
};
var EH = function EH(_ref70) {
	var title = _ref70.title, rest = _objectWithoutProperties(_ref70, _excluded70);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#428823",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z" }), /*#__PURE__*/ React.createElement("path", { d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z" })));
};
var ER = function ER(_ref71) {
	var title = _ref71.title, rest = _objectWithoutProperties(_ref71, _excluded71);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#56AF35",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "m0 342 513-171L0 0v342z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#ffc945" }, /*#__PURE__*/ React.createElement("path", { d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 119.5,
		cy: 148.3,
		r: 17.5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 148.9,
		cy: 158.5,
		r: 17.5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 134.7,
		cy: 135.2,
		r: 17.5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 119.5,
		cy: 172.7,
		r: 17.5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 149.9,
		cy: 182.8,
		r: 17.5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 122.5,
		cy: 198,
		r: 17.5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 145.9,
		cy: 205.2,
		r: 17.5
	})));
};
var ES_CT = function ES_CT(_ref72) {
	var title = _ref72.title, rest = _objectWithoutProperties(_ref72, _excluded72);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 810 540"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FCDD09",
		d: "M0 0h810v540H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "#DA121A",
		strokeWidth: 60,
		d: "M0 90h810m0 120H0m0 120h810m0 120H0"
	}));
};
var ES = function ES(_ref73) {
	var title = _ref73.title, rest = _objectWithoutProperties(_ref73, _excluded73);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22.5 15"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h22.5v15H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D03433",
		d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FBCA46",
		d: "M0 4h22.5v7H0V4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M7.8 7h1v.5h-1V7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A41517",
		d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A41517",
		d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
	}));
};
var ET = function ET(_ref74) {
	var title = _ref74.title, rest = _objectWithoutProperties(_ref74, _excluded74);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22.5 15"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#20AA46",
		d: "M0 0h22.5v5H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#E92F3B",
		d: "M0 10h22.5v5H0v-5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FADF50",
		d: "M0 5h22.5v5H0V5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#205CCA",
		cx: 11.3,
		cy: 7.5,
		r: 5.2
	}), /*#__PURE__*/ React.createElement("g", {
		stroke: "#FFDB3D",
		fill: "none"
	}, /*#__PURE__*/ React.createElement("path", {
		d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
		strokeWidth: .5
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
		strokeWidth: .25
	})));
};
var EU = function EU(_ref75) {
	var title = _ref75.title, rest = _objectWithoutProperties(_ref75, _excluded75);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 810 540"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#039",
		d: "M0 0h810v540H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FC0",
		d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
	}));
};
var FI = function FI(_ref76) {
	var title = _ref76.title, rest = _objectWithoutProperties(_ref76, _excluded76);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#2E52B2",
		d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
	}));
};
var FJ = function FJ(_ref77) {
	var title = _ref77.title, rest = _objectWithoutProperties(_ref77, _excluded77);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#62B5E5",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F3F3F3",
		d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#c8102e",
		d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var FK = function FK(_ref78) {
	var title = _ref78.title, rest = _objectWithoutProperties(_ref78, _excluded78);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#2a7fff",
		d: "M311.2 190.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M311.2 190.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#3e6d1e",
		d: "M346.1 189.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8s-19.1 4.8-19.1 4.8c-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#e5e5e5",
		d: "M356.4 175.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1s-45.1 13.5-45.1 30.1c-.1 8.5 6.6 28.5 15 30.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M355 266.7c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM321.1 206c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
	}));
};
var FM = function FM(_ref79) {
	var title = _ref79.title, rest = _objectWithoutProperties(_ref79, _excluded79);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
		fill: "#FFF"
	}));
};
var FO = function FO(_ref80) {
	var title = _ref80.title, rest = _objectWithoutProperties(_ref80, _excluded80);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0F61A5",
		d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#E50E3D",
		d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
	}));
};
var FR = function FR(_ref81) {
	var title = _ref81.title, rest = _objectWithoutProperties(_ref81, _excluded81);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00318A",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M342 0h171v342H342z"
	}));
};
var GA = function GA(_ref82) {
	var title = _ref82.title, rest = _objectWithoutProperties(_ref82, _excluded82);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 228h513v114H0z"
	}));
};
var GB_ENG = function GB_ENG(_ref83) {
	var title = _ref83.title, rest = _objectWithoutProperties(_ref83, _excluded83);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 136h513v70H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M221.5 0h70v342h-70z"
	}));
};
var GB_NIR = function GB_NIR(_ref84) {
	var title = _ref84.title, rest = _objectWithoutProperties(_ref84, _excluded84);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 136h513v70H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M221.5 0h70v342h-70z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		stroke: "#231F20",
		strokeMiterlimit: 10,
		d: "m256.5 87.8-24 41.4h-48.8l24.7 42.1-24.7 42.1h48.8l24 42.1 24-42.1h48.8l-24.7-42.1 24.7-42.1h-48.8l-24-41.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M258.6 130.6c-3.3 0-3.3 3.3-3.3 3.3V160h-2v-22s0-4-3.3-4c-4 0-4 4-4 4v23.4l-2 .7v-16.7s0-4-3.3-4c-4 0-4 4-4 4V174c0 6.7 3.3 13.4 8 17.4v14h24V194c6-3.3 10.7-9.4 12-16.7 0-4 1.3-7.3 2.7-10.7l2.7-9.4s.7-3.3-2.7-4.7-4.7 2-4.7 2l-5.3 12.7h-2v-31.4s0-3.3-3.3-3.3c-4 0-4 3.3-4 3.3v24h-1.3v-26.1c-.2.2-.2-3.1-4.2-3.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		stroke: "#231F20",
		strokeMiterlimit: 10,
		d: "M249.2 25.7V33h-7.3v14.7h7.3v14c-4-4-9.4-6-14.7-6-12.2-.1-22.1 9.6-22.3 21.8-.1 6.1 2.4 12 6.9 16.3v13.4h74.8V93.8c4-4.7 6.7-10 6.7-16-.2-12.2-10.3-21.9-22.4-21.6-5.3.1-10.4 2.1-14.3 5.6v-14h7.3V33.1h-7.3v-7.3l-14.7-.1z"
	}));
};
var GB_SCT = function GB_SCT(_ref85) {
	var title = _ref85.title, rest = _objectWithoutProperties(_ref85, _excluded85);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#005EB8",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 302.1V342h59.9l196.6-131.1L453.1 342H513v-39.9L316.4 171 513 39.9V0h-59.9L256.5 131.1 59.9 0H0v39.9L196.7 171z"
	}));
};
var GB_WLS = function GB_WLS(_ref86) {
	var title = _ref86.title, rest = _objectWithoutProperties(_ref86, _excluded86);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#529E3C",
		d: "M0 171h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D11C1C",
		d: "m201 259.8 28.2-4.8-21.8-10.3 14.9-8.4s25.2 21.2 25.2 14.4c0-7.3 23.7-4.1 22.7-14.4-1.3-14.1-26.2-1-30.6-18.7-2.5-9.9-10.3-8.6-10.3-8.6l-25.1 8.6-12.5 18.7-6.2-18.7s-14.6 11.9-19.5 18.7c-5.2 7.3-10.7 23.5-10.7 23.5l25.6 10.7-37.3-6.6-27.2 6.6-16.7 4.6 7.3-7.7-15-7.6 15-9-7.3-6.1 32.3 6.1s11.8-1.2 16.3-6.1c5.6-6.2 10.1-27.1 10.1-27.1l-14.8-8.6-11.6 21s-8-19.9-15.6-31c-5.7-8.3-24.3-27.3-24.3-27.3l-24 12.6 13.4-26.7s10.6-9.3 3.9-18.8c-6.8-9.5-12.4-30.9-12.4-30.9s14.1 24.4 19.2 22.5c7.2-2.7-9-25 0-28.9 6.5-2.9 7.6 25.5 7.6 25.5l7.3-13.9v17.3s-4.3 20.7 3 33c7.2 12.3 28.7 20.9 28.7 20.9s-5.6-12.3 0-36c3.8-16 17.2-43.4 23.6-52.1 3.3-4.6-26.7 17-26.7 17v-17l-28.6-2.9-7.3 8.3-18.3-30L104 83.1h34.6l-6.7-8.3H104s5.9-12.1 34.6-12.1l13.6-9.2s18.6.5 29 .9c9.3.4 26.1-11.5 26.1-11.5l4.7 11.5-11 17.3 11.1 11.4-4.7 7 8.1 11.5H201l11.1 17.9-11.1-6.3 6.4 17.3-6.4 17.8 28.2-9.5s0-25.6 10.3-37.2C271.1 69.2 322.6 43 322.6 43s-2.7 23.5 4.9 25.4c11.1 2.7 59.4-19.4 59.4-19.4s-29 31.3-23.1 34.1c3.2 1.5 8.5 7 8.5 7s-25.1 20.5-29.3 29.3c-4.2 8.8 6.1 19.4 6.1 19.4s-21.7 0-32.5 9.5c32.5 0 59.1 15.4 74.8 4 10.5-7.6-37.7-2.9-31.4-21.9 2.4-7.1 8.5-15.2 22.6-17.3s19.1 6.3 19.1 6.3l7.6-11.5h-22.4l40.6-39.6 5.3 51.1-13.7-11.4-6.2 19.2c14.6 44.6-52.8 54.1-52.8 54.1l41.6 27.8-14.8 4.2-4.2 41.7 19.1 15.5-25-6.6-49.2 11.2 9.8-15.3-20.6 4.1 13.7-13.1-13.7-6.1 17.6-4.9 22.1 15.2s11-14.2 12.2-21.7c1.3-7.8-4.8-24.2-4.8-24.2s-32.6-.7-44.1-3.5-18.2-11.9-18.2-11.9l-13.1 15.4s45.5 17.1 34.1 24.2c-2.6 1.7-15.7-3.2-15.7-3.2s-22.4 26.2-36.8 29.7c-6.5 1.6 18.3 10.7 18.3 10.7s-21.2-3.4-32-6.6c-11.3-3.4-44.4 6.6-44.4 6.6l-11-10.7zM383.9 138c3.1 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7-5.7 2.6-5.7 5.7 2.5 5.7 5.7 5.7z"
	}));
};
var GB = function GB(_ref87) {
	var title = _ref87.title, rest = _objectWithoutProperties(_ref87, _excluded87);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v341.3H0V0z" }), /*#__PURE__*/ React.createElement("path", { d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z" })), /*#__PURE__*/ React.createElement("path", {
		d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
		fill: "#012169"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#c8102e" }, /*#__PURE__*/ React.createElement("path", { d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z" }), /*#__PURE__*/ React.createElement("path", { d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z" })));
};
var GD = function GD(_ref88) {
	var title = _ref88.title, rest = _objectWithoutProperties(_ref88, _excluded88);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#c60a0a",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#3E8446",
		d: "m256.5 170.7-212 126.1V44.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
		fill: "#FFDA44"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#3E8446",
		d: "M467.5 44.5v252.3l-211-126.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
		fill: "#FFDA44"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#c60a0a",
		cx: 244.5,
		cy: 170.7,
		r: 76.2
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#A2001D",
		cx: 99.1,
		cy: 182.1,
		r: 7.4
	}));
};
var GE = function GE(_ref89) {
	var title = _ref89.title, rest = _objectWithoutProperties(_ref89, _excluded89);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22.5 15"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h22.5v15H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#eb000e",
		d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#eb000e",
		d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
	}));
};
var GF = function GF(_ref90) {
	var title = _ref90.title, rest = _objectWithoutProperties(_ref90, _excluded90);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 90 60"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FDEB01",
		d: "m0 0 90 60H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#58A846",
		d: "M90 0v60L0 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ED3D24",
		d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
	}));
};
var GG = function GG(_ref91) {
	var title = _ref91.title, rest = _objectWithoutProperties(_ref91, _excluded91);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
	}));
};
var GH = function GH(_ref92) {
	var title = _ref92.title, rest = _objectWithoutProperties(_ref92, _excluded92);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z" }));
};
var GI = function GI(_ref93) {
	var title = _ref93.title, rest = _objectWithoutProperties(_ref93, _excluded93);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 230h513v112H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		stroke: "#000",
		strokeMiterlimit: 10,
		d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		stroke: "#000",
		strokeMiterlimit: 10,
		d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z" }), /*#__PURE__*/ React.createElement("path", { d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z" }));
};
var GL = function GL(_ref94) {
	var title = _ref94.title, rest = _objectWithoutProperties(_ref94, _excluded94);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 0v171H0V0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 185.8,
		cy: 171.2,
		r: 117.8
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
	}));
};
var GM = function GM(_ref95) {
	var title = _ref95.title, rest = _objectWithoutProperties(_ref95, _excluded95);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#cf0d19",
		d: "M0 0h513v100H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 121h513v100H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1a7e25",
		d: "M0 242h513v100H0z"
	}));
};
var GN = function GN(_ref96) {
	var title = _ref96.title, rest = _objectWithoutProperties(_ref96, _excluded96);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h512v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M342 0h171v342H342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h171v342H0z"
	}));
};
var GP = function GP(_ref97) {
	var title = _ref97.title, rest = _objectWithoutProperties(_ref97, _excluded97);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00318A",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M342 0h171v342H342z"
	}));
};
var GQ = function GQ(_ref98) {
	var title = _ref98.title, rest = _objectWithoutProperties(_ref98, _excluded98);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h513v113.8H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 227.6h513V342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0070C8",
		d: "M126 171 0 342V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "none",
		stroke: "#000",
		strokeMiterlimit: 10,
		d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#786145",
		d: "M264.5 179.8h9.8l4 25.8h-17.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
		fill: "#FFDA00",
		stroke: "#000",
		strokeMiterlimit: 10
	}));
};
var GR = function GR(_ref99) {
	var title = _ref99.title, rest = _objectWithoutProperties(_ref99, _excluded99);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#0d5eaf" }, /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z" }), /*#__PURE__*/ React.createElement("path", { d: "M0 0h190v190H0z" })), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M0 76h190v38H0z" }), /*#__PURE__*/ React.createElement("path", { d: "M76 0h38v190H76z" })));
};
var GS = function GS(_ref100) {
	var title = _ref100.title, rest = _objectWithoutProperties(_ref100, _excluded100);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#FFF",
		cx: 443.4,
		cy: 233.6,
		rx: 29,
		ry: 43.5
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#FFCE00",
		cx: 406.9,
		cy: 317.7,
		rx: 22,
		ry: 9.3
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#FFCE00",
		cx: 364,
		cy: 317.7,
		rx: 22,
		ry: 9.3
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#39B200",
		d: "m342 190.1 43.4 86.9 43.5-86.9z"
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#9B9B9B",
		cx: 327.5,
		cy: 233.6,
		rx: 29,
		ry: 43.5
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#757575",
		d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#C6B56F",
		cx: 385.4,
		cy: 67,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#923f00",
		cx: 386,
		cy: 88.7,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 443.4,
		cy: 117.7,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#0049FF",
		cx: 342.2,
		cy: 146.7,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#0041F9",
		cx: 429.8,
		cy: 146.7,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#F7D71E",
		cx: 386,
		cy: 233.6,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#CEC851",
		cx: 457.9,
		cy: 190.1,
		r: 29
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 385.4,
		cy: 289.5,
		r: 29
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#7C0B29",
		d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 327.5,
		cy: 117.4,
		r: 29
	}));
};
var GT = function GT(_ref101) {
	var title = _ref101.title, rest = _objectWithoutProperties(_ref101, _excluded101);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h171v342H0zm342 0h171v342H342z",
		fill: "#338AF3"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#DCC26D",
		cx: 256,
		cy: 155.8,
		r: 25.5
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#628A40",
		d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
	}));
};
var GU = function GU(_ref102) {
	var title = _ref102.title, rest = _objectWithoutProperties(_ref102, _excluded102);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M11.1 11.1h489.7v319.1H11.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#7DBEF1",
		d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1C8AE6",
		d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF042",
		d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#259C7B",
		d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#8E5715",
		d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "none",
		stroke: "#D80027",
		strokeWidth: 12,
		strokeMiterlimit: 10,
		d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
	}));
};
var GW = function GW(_ref103) {
	var title = _ref103.title, rest = _objectWithoutProperties(_ref103, _excluded103);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h512v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h512v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h182v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z" }));
};
var GY = function GY(_ref104) {
	var title = _ref104.title, rest = _objectWithoutProperties(_ref104, _excluded104);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#009E49",
		d: "M0 0h900v600H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m0 0 947 300L0 600V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFD00D",
		d: "M0 26.1 870 300 0 573.9V26.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#2D2D2D",
		d: "m0 0 450 300L0 600V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D3132F",
		d: "m0 35 397.5 265L0 565V35z"
	}));
};
var HK = function HK(_ref105) {
	var title = _ref105.title, rest = _objectWithoutProperties(_ref105, _excluded105);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 21 14"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h21v14H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#EE1C25",
		d: "M0 0h21v14H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M12 6.7c-.8-.5-1 .4-1 0 0-.8.9-1.5 2-1.5s2 .7 2 1.5c-.9 0-1 .5-1.5.5-.6 0-.7 0-1.5-.5zm1.2-.2c.1 0 .2-.1.2-.2s0-.3-.2-.3-.2.1-.2.2.1.3.2.3zm-1.8 2c.2-.9-.7-.8-.3-.9.8-.3 1.7.4 2 1.4.3 1.1 0 2.1-.8 2.4-.3-.9-.8-.8-.9-1.3-.1-.6-.2-.7 0-1.6zm.6 1.1c0 .1.2.2.3.2.1 0 .2-.2.2-.3s-.2-.2-.3-.2c-.2 0-.2.2-.2.3zM9.6 8.5c.9-.1.6-.9.8-.6.5.7.2 1.7-.7 2.4-.9.6-2 .6-2.5 0 .8-.6.6-1 .9-1.3.4-.4.5-.5 1.5-.5zm-.9.9c-.1 0-.2.2-.1.3s.3.2.4.1.1-.3 0-.4-.2-.1-.3 0zM9 6.7c.3.9 1 .3.8.6-.5.7-1.6.7-2.5 0-.9-.6-1.2-1.7-.7-2.4.8.6 1.1.2 1.5.5.4.4.5.4.9 1.3zm-1.1-.6c-.1-.1-.3 0-.4.1s-.1.3 0 .4c.1.1.3 0 .3-.1.2-.1.2-.3.1-.4zm2.6-.5c-.7.6.1 1.1-.3 1-.8-.3-1.2-1.4-.8-2.4.3-1 1.3-1.7 2-1.4-.3.9.2 1.1 0 1.6-.1.5-.2.6-.9 1.2zm.2-1.2c0-.1 0-.3-.1-.3s-.3 0-.3.1 0 .3.2.3c0 .1.1 0 .2-.1z"
	}));
};
var HM = function HM(_ref106) {
	var title = _ref106.title, rest = _objectWithoutProperties(_ref106, _excluded106);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })), /*#__PURE__*/ React.createElement("path", {
		d: "m189.2 212.6 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z",
		fill: "#FFF"
	}));
};
var HN = function HN(_ref107) {
	var title = _ref107.title, rest = _objectWithoutProperties(_ref107, _excluded107);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
		fill: "#338AF3"
	}));
};
var HR = function HR(_ref108) {
	var title = _ref108.title, rest = _objectWithoutProperties(_ref108, _excluded108);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
		fill: "#338AF3"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
		fill: "#0052B4"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "#D80027",
		fill: "#FFF",
		d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
		fill: "#D80027"
	}));
};
var HT = function HT(_ref109) {
	var title = _ref109.title, rest = _objectWithoutProperties(_ref109, _excluded109);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#00209f",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d21034",
		d: "M0 171h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#00209f",
		cx: 270.7,
		cy: 182.3,
		r: 55.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#d21034",
		cx: 270.7,
		cy: 182.3,
		r: 27.7
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#016a16",
		d: "M229.1 100h83.1l-41.5 54.6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f1b517",
		d: "M265.5 140.8h10v83h-10z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#016a16",
		d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
	}));
};
var HU = function HU(_ref110) {
	var title = _ref110.title, rest = _objectWithoutProperties(_ref110, _excluded110);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 228h513v114H0z"
	}));
};
var IC = function IC(_ref111) {
	var title = _ref111.title, rest = _objectWithoutProperties(_ref111, _excluded111);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 300 200"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#fc0",
		d: "M0 0h300v200H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0768a9",
		d: "M0 0h200v200H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		d: "M0 0h100v200H0z"
	}));
};
var ID = function ID(_ref112) {
	var title = _ref112.title, rest = _objectWithoutProperties(_ref112, _excluded112);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#E00",
		d: "M0 0h513v171H0z"
	}));
};
var IE = function IE(_ref113) {
	var title = _ref113.title, rest = _objectWithoutProperties(_ref113, _excluded113);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF9811",
		d: "M342 0h171v342H342z"
	}));
};
var IL = function IL(_ref114) {
	var title = _ref114.title, rest = _objectWithoutProperties(_ref114, _excluded114);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
		fill: "#2E52B2"
	}));
};
var IM = function IM(_ref115) {
	var title = _ref115.title, rest = _objectWithoutProperties(_ref115, _excluded115);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#E52D42",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F8DD4E",
		d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
	}));
};
var IN = function IN(_ref116) {
	var title = _ref116.title, rest = _objectWithoutProperties(_ref116, _excluded116);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ff6820",
		d: "M0 0h513v114H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 114h513v114H0V114z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#046a38",
		d: "M0 228h513v114H0V228z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "none",
		stroke: "#07038d",
		strokeWidth: 4,
		d: "M256.5 136.8c18.9 0 34.2 15.3 34.2 34.2s-15.3 34.2-34.2 34.2-34.2-15.3-34.2-34.2 15.3-34.2 34.2-34.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m265.3 138.2-17.6 65.7m17.6-65.7-17.6 65.7m25.8-62.3-34 58.9m41-53.5-48 48m53.4-41L227 188m62.3-25.8-65.7 17.6m66.9-8.8h-68m66.8 8.8-65.7-17.6m62.3 25.8L227 154m53.5 41-48-48m41 53.4-34-58.9m25.8 62.3-17.6-65.7m8.8 66.9v-68m-8.8 66.8 17.6-65.7m-25.8 62.3 34-58.9m-41 53.5 48.1-48.1M227.1 188l58.9-34m-62.3 25.8 65.7-17.6m-66.9 8.8h68m-66.8-8.8 65.7 17.6M227.1 154l58.9 34m-53.5-41 48.1 48.1m-41.1-53.5 34 58.9m-25.8-62.3 17.6 65.7",
		stroke: "#07038d",
		strokeWidth: 2
	}));
};
var IO = function IO(_ref117) {
	var title = _ref117.title, rest = _objectWithoutProperties(_ref117, _excluded117);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0-.3h513V342H0V-.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
	}), /*#__PURE__*/ React.createElement("g", {
		strokeWidth: 2,
		strokeMiterlimit: 10
	}, /*#__PURE__*/ React.createElement("path", {
		d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
		fill: "#a24300",
		stroke: "#000"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#006d00",
		stroke: "#004100",
		d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fed100",
		stroke: "#525625",
		d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
	})), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var IQ = function IQ(_ref118) {
	var title = _ref118.title, rest = _objectWithoutProperties(_ref118, _excluded118);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#CE1126",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 228h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
		fill: "#547C31"
	}));
};
var IR = function IR(_ref119) {
	var title = _ref119.title, rest = _objectWithoutProperties(_ref119, _excluded119);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h512v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
		fill: "#FFF",
		opacity: .5
	}));
};
var IS = function IS(_ref120) {
	var title = _ref120.title, rest = _objectWithoutProperties(_ref120, _excluded120);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
	}));
};
var IT = function IT(_ref121) {
	var title = _ref121.title, rest = _objectWithoutProperties(_ref121, _excluded121);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#F4F5F0",
		d: "M342 0H0v341.3h512V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#008C45",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#CD212A",
		d: "M342 0h171v342H342z"
	}));
};
var JE = function JE(_ref122) {
	var title = _ref122.title, rest = _objectWithoutProperties(_ref122, _excluded122);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
	}));
};
var JM = function JM(_ref123) {
	var title = _ref123.title, rest = _objectWithoutProperties(_ref123, _excluded123);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
	}));
};
var JO = function JO(_ref124) {
	var title = _ref124.title, rest = _objectWithoutProperties(_ref124, _excluded124);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M256.5 170.7 0 341.3V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
	}));
};
var JP = function JP(_ref125) {
	var title = _ref125.title, rest = _objectWithoutProperties(_ref125, _excluded125);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h512v342H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#D80027",
		cx: 256.5,
		cy: 171,
		r: 96
	}));
};
var KE = function KE(_ref126) {
	var title = _ref126.title, rest = _objectWithoutProperties(_ref126, _excluded126);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h512v90.579H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 251h513v91H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A2001D",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z" }), /*#__PURE__*/ React.createElement("path", { d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z" })), /*#__PURE__*/ React.createElement("path", {
		d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
		fill: "#A2001D"
	}), /*#__PURE__*/ React.createElement("path", { d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z" }));
};
var KG = function KG(_ref127) {
	var title = _ref127.title, rest = _objectWithoutProperties(_ref127, _excluded127);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v342H0z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 256,
		cy: 171,
		r: 171
	})), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#D80027",
		cx: 257.4,
		cy: 170.7,
		r: 71.6
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
		fill: "#FFDA44"
	}));
};
var KH = function KH(_ref128) {
	var title = _ref128.title, rest = _objectWithoutProperties(_ref128, _excluded128);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v114H0zm0 228h513v114H0z",
		fill: "#0052B4"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
	}));
};
var KI = function KI(_ref129) {
	var title = _ref129.title, rest = _objectWithoutProperties(_ref129, _excluded129);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 450 300"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#CE1126",
		d: "M0 0h450v300H0V0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FCD116" }, /*#__PURE__*/ React.createElement("circle", {
		cx: 227.6,
		cy: 161.2,
		r: 56.2
	}), /*#__PURE__*/ React.createElement("path", { d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#003F87",
		d: "M0 175h450v125H0V175z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
	}), /*#__PURE__*/ React.createElement("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#FCD116",
		d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
	}));
};
var KM = function KM(_ref130) {
	var title = _ref130.title, rest = _objectWithoutProperties(_ref130, _excluded130);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v85.5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.5h513V171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 171h513v85.5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M256.5 171 0 342V0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z" }), /*#__PURE__*/ React.createElement("path", { d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z" }), /*#__PURE__*/ React.createElement("path", { d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z" })));
};
var KN = function KN(_ref131) {
	var title = _ref131.title, rest = _objectWithoutProperties(_ref131, _excluded131);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M512 0H0v342"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z" }), /*#__PURE__*/ React.createElement("path", {
		d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
		fill: "#FFF"
	}));
};
var KP = function KP(_ref132) {
	var title = _ref132.title, rest = _objectWithoutProperties(_ref132, _excluded132);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#91DC5A",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
		fill: "#0052B4"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 79.9h513v181.582H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 190.33,
		cy: 171,
		r: 65.668
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
	}));
};
var KR = function KR(_ref133) {
	var title = _ref133.title, rest = _objectWithoutProperties(_ref133, _excluded133);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M84.6 107.8 132 36.6m-29.7 83 47.4-71.1m-29.6 83 47.4-71.1m177.9 221.3 47.4-71.1m-29.6 82.9 47.4-71.1m-29.6 83 47.4-71.1M132 305.4l-47.4-71.1m65.2 59.2-47.4-71.1m65.2 59.3-47.4-71.1m272.6-79.1-47.4-71.1m65.2 59.2-47.4-71.1m65.2 59.3L381 36.6",
		stroke: "#000",
		strokeWidth: 14.25
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m357.3 238.2 59.3 39.5m-299.4-13.8L135 252m222.3-148.2L378 90m17.8-11.9 17.8-11.9",
		stroke: "#FFF",
		strokeWidth: 12.5
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#CA163A",
		cx: 256.5,
		cy: 171,
		r: 85.5
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0E4896",
		d: "M185.3 123.6c-13.1 19.6-7.8 46.2 11.9 59.3s46.2 7.8 59.3-11.9 39.6-24.9 59.3-11.9c19.6 13.1 24.9 39.6 11.9 59.3-26.2 39.3-79.3 49.9-118.6 23.7s-49.9-79.3-23.8-118.5z"
	}));
};
var KW = function KW(_ref134) {
	var title = _ref134.title, rest = _objectWithoutProperties(_ref134, _excluded134);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M167 227.6 0 341.3V0l167 113.8z" }));
};
var KY = function KY(_ref135) {
	var title = _ref135.title, rest = _objectWithoutProperties(_ref135, _excluded135);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("g", { stroke: "#fff" }, /*#__PURE__*/ React.createElement("circle", {
		fill: "#059334",
		cx: 384,
		cy: 96.5,
		r: 29.7
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#c8102e",
		d: "M332.1 89H436v44.5H332.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fcea83",
		d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#004b9e",
		d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
		fill: "#F3F3F3"
	})), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var KZ = function KZ(_ref136) {
	var title = _ref136.title, rest = _objectWithoutProperties(_ref136, _excluded136);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#36B6CC",
		d: "M0 0h513v342H0V0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFD400",
		cx: 256.5,
		cy: 170.9,
		r: 68.4
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFD400",
		d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
	}));
};
var LA = function LA(_ref137) {
	var title = _ref137.title, rest = _objectWithoutProperties(_ref137, _excluded137);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 256.5,
		cy: 171,
		r: 65.9
	}));
};
var LB = function LB(_ref138) {
	var title = _ref138.title, rest = _objectWithoutProperties(_ref138, _excluded138);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#14AF5A",
		d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
	}));
};
var LC = function LC(_ref139) {
	var title = _ref139.title, rest = _objectWithoutProperties(_ref139, _excluded139);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#55B2FF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F3F3F3",
		d: "M148.5 298.1h216l-108-254.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#333",
		d: "m186 272.7 70.5-160.3L327 272.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M148.5 298.1h216l-108-101.7z"
	}));
};
var LI = function LI(_ref140) {
	var title = _ref140.title, rest = _objectWithoutProperties(_ref140, _excluded140);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
	}));
};
var LK = function LK(_ref141) {
	var title = _ref141.title, rest = _objectWithoutProperties(_ref141, _excluded141);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A2001D",
		d: "M222.6 22.3h267.1v296.8H222.6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M22.3 22.3h200.3v296.8H22.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M200.3 0h22.3v342h-22.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M22.3 22.3h89v296.8h-89z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF9811",
		d: "M111.3 22.3h89v296.8h-89z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "none",
		stroke: "#FFDA44",
		strokeWidth: 6,
		strokeMiterlimit: 10,
		d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
	}));
};
var LR = function LR(_ref142) {
	var title = _ref142.title, rest = _objectWithoutProperties(_ref142, _excluded142);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
		fill: "#bf0a30"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#002868",
		d: "M0 0h155.6v155.6H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
	}));
};
var LS = function LS(_ref143) {
	var title = _ref143.title, rest = _objectWithoutProperties(_ref143, _excluded143);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 227.6h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z" }), /*#__PURE__*/ React.createElement("path", { d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z" }));
};
var LT = function LT(_ref144) {
	var title = _ref144.title, rest = _objectWithoutProperties(_ref144, _excluded144);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 228h513v114H0z"
	}));
};
var LU = function LU(_ref145) {
	var title = _ref145.title, rest = _objectWithoutProperties(_ref145, _excluded145);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 228h513v114H0z"
	}));
};
var LV = function LV(_ref146) {
	var title = _ref146.title, rest = _objectWithoutProperties(_ref146, _excluded146);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		className: "prefix__st1",
		d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
		fill: "#A2001D"
	}));
};
var LY = function LY(_ref147) {
	var title = _ref147.title, rest = _objectWithoutProperties(_ref147, _excluded147);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v342H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z" }), /*#__PURE__*/ React.createElement("path", { d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z" })));
};
var MA = function MA(_ref148) {
	var title = _ref148.title, rest = _objectWithoutProperties(_ref148, _excluded148);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#d12a46",
		d: "M0 .3V342h513V.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#316525",
		d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
	}));
};
var MC = function MC(_ref149) {
	var title = _ref149.title, rest = _objectWithoutProperties(_ref149, _excluded149);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 171h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ce1126",
		d: "M0 0h513v171H0z"
	}));
};
var MD = function MD(_ref150) {
	var title = _ref150.title, rest = _objectWithoutProperties(_ref150, _excluded150);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M342 0h171v342H342z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#AF7F59",
		stroke: "#231F20",
		strokeWidth: 3,
		strokeMiterlimit: 10,
		d: "m240.4 105.7 9.7 11.6-7.5 17.4-26.1-24.3-12.7 13.2v106.1l24.6-36 20.6 12.4-18 27.8 25.2 15.8 26.5-15.8-19.7-27.8 22.3-12.4 23.9 33.8v-106l-12.4-12-26.8 24.7-6.5-16.5 3.5-12.3-11.7-7.5z"
	}));
};
var ME = function ME(_ref151) {
	var title = _ref151.title, rest = _objectWithoutProperties(_ref151, _excluded151);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc000",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#e30000",
		d: "M20 20h473v302H20z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc000",
		d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c3-1 6.9-7.5 10.8-7.5 3.9 0 7.8 6.5 10.8 7.5l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9l-6.8-6.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0371ba",
		d: "M275 201.3h-37c-4.9 0-8.8-3.9-8.8-8.8v-34.2c0-4.9 3.9-8.8 8.8-8.8h37c4.9 0 8.8 3.9 8.8 8.8v34.2c0 4.8-3.9 8.8-8.8 8.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#39B54A",
		d: "m230.8 212.8 24.4 17.9c.8.6 1.8.6 2.6 0l24.4-17.9c2.1-1.6 1.2-5.4-1.3-5.4h-48.8c-2.5 0-3.4 3.9-1.3 5.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc000",
		d: "M262.8 186.5h-12.5c-3.3 0-5.9-2.6-5.9-5.9V170c0-3.3 2.6-5.9 5.9-5.9h12.5c3.3 0 5.9 2.6 5.9 5.9v10.6c-.1 3.3-2.7 5.9-5.9 5.9z"
	}));
};
var MF = function MF(_ref152) {
	var title = _ref152.title, rest = _objectWithoutProperties(_ref152, _excluded152);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 108 72"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h108v72H0z",
		fill: "#003787"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h108L60 48v24H48V48z",
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 54,
		cy: 30,
		r: 8,
		fill: "#f9d90f"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M44 30h20L54 48z",
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M54 48 38 33h32z",
		fill: "#cf142b"
	}));
};
var MG = function MG(_ref153) {
	var title = _ref153.title, rest = _objectWithoutProperties(_ref153, _excluded153);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#f9423a",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00843d",
		d: "M0 171h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h171v342H0z"
	}));
};
var MH = function MH(_ref154) {
	var title = _ref154.title, rest = _objectWithoutProperties(_ref154, _excluded154);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#1E509C",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 176.1V81.3L0 342l513-165.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F18D36",
		d: "M513 0v81.3L0 342 513 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
	}));
};
var MK = function MK(_ref155) {
	var title = _ref155.title, rest = _objectWithoutProperties(_ref155, _excluded155);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M384.6 342 256.5 167.3 283.4 342zM133.8 0l122.7 167.3L230.8 0zm95.8 342 26.9-174.7L128.4 342zM0 0v127.8l256.5 39.5L28.4 0zm0 342h18.2l238.3-174.7L0 206.7zm256.5-174.7L513 127.8V0h-28.4zM282.2 0l-25.7 167.3L379.2 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M513 342V206.7l-256.5-39.4L494.8 342z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 256.5,
		cy: 171,
		r: 59.5
	})), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFDA44",
		cx: 256.5,
		cy: 171,
		r: 44.5
	}));
};
var ML = function ML(_ref156) {
	var title = _ref156.title, rest = _objectWithoutProperties(_ref156, _excluded156);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#14b53a",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fcd116",
		d: "M171 0h171v342H171z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ce1126",
		d: "M342 0h171v342H342z"
	}));
};
var MM = function MM(_ref157) {
	var title = _ref157.title, rest = _objectWithoutProperties(_ref157, _excluded157);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#fecb00",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#34b233",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ea2839",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M384.8 142.2h-98L256.5 49l-30.3 93.2h-98l79.3 57.6-30.3 93.2 79.3-56.9 79.3 56.9-30.3-93.2 79.3-57.6z"
	}));
};
var MN = function MN(_ref158) {
	var title = _ref158.title, rest = _objectWithoutProperties(_ref158, _excluded158);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0066b2",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M342 0h171v342H342zM0 0h171v342H0z",
		fill: "#da2031"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#ffd300" }, /*#__PURE__*/ React.createElement("path", { d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 86,
		cy: 203.4,
		r: 14.8
	}), /*#__PURE__*/ React.createElement("path", { d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 86,
		cy: 144,
		r: 14.8
	}), /*#__PURE__*/ React.createElement("path", { d: "M76.3 123.9h19.5L86 108.3z" })));
};
var MO = function MO(_ref159) {
	var title = _ref159.title, rest = _objectWithoutProperties(_ref159, _excluded159);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0F7562",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M286.2 168.5c-4.2 0-8.2.8-11.9 2.2 2-4.5 3.4-9.5 3.4-14.9 0-21.2-21.2-37.1-21.2-37.1s-21.2 15.9-21.2 37.1c0 5.4 1.4 10.4 3.4 14.9-3.7-1.3-7.7-2.2-11.9-2.2-25.6 0-37.1 11.2-37.1 11.2s15.9 31.2 37.1 31.2c12.4 0 23-7.3 29.7-13.3 6.6 6 17.3 13.3 29.7 13.3 21.2 0 37.1-31.2 37.1-31.2s-10.8-11.2-37.1-11.2zm-29.7-96.8 4.4 13.5h14.2l-11.5 8.3L268 107l-11.5-8.3L245 107l4.4-13.5-11.5-8.3h14.2zm-53.9 23.6 8.4 7.6 9.9-5.7-4.7 10.4 8.5 7.6-11.3-1.2-4.6 10.3-2.4-11.1-11.3-1.1 9.9-5.7zm-39.4 39.5 11.1 2.3 5.6-9.8 1.2 11.3 11.1 2.3-10.4 4.6 1.2 11.3-7.6-8.4-10.3 4.6 5.6-9.8zm147.2-39.5-8.4 7.6-9.9-5.7 4.7 10.4-8.5 7.6 11.3-1.2 4.6 10.3 2.4-11.1 11.3-1.1-9.9-5.7zm39.4 39.5-11.1 2.3-5.6-9.8-1.2 11.3-11.1 2.3 10.4 4.6-1.2 11.3 7.6-8.4 10.3 4.6-5.6-9.8z",
		fill: "#FFDA44"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M256.5 270.3c16.8 0 32.4-5.6 44.8-15.1h-89.6c12.4 9.4 28 15.1 44.8 15.1zm-68-44.6c2.4 5.4 5.3 10.4 8.9 15.1H238c13.9 0 18.5-7 18.5-7s5.3 7 18.6 7h40.6c3.5-4.6 6.5-9.7 8.9-15.1h-49.5c-15.5 0-18.6-10-18.6-10s-5.3 10-18.5 10h-49.5z",
		fill: "#FFF"
	}));
};
var MP = function MP(_ref160) {
	var title = _ref160.title, rest = _objectWithoutProperties(_ref160, _excluded160);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 750 500"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0071BC",
		d: "M0 0h750v500H0V0z"
	}), /*#__PURE__*/ React.createElement("g", {
		fill: "#FFF",
		stroke: "#000",
		strokeWidth: 1.9
	}, /*#__PURE__*/ React.createElement("circle", {
		cx: 375,
		cy: 245,
		r: 225,
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 375,
		cy: 245,
		r: 165,
		fill: "#0071BC"
	})), /*#__PURE__*/ React.createElement("g", { stroke: "#000" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#8C8A8C",
		strokeWidth: 1.9,
		d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		strokeWidth: 2,
		strokeLinejoin: "round",
		d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
	})));
};
var MQ = function MQ(_ref161) {
	var title = _ref161.title, rest = _objectWithoutProperties(_ref161, _excluded161);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		viewBox: "0 0 900 600",
		xmlns: "http://www.w3.org/2000/svg"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#231f1e",
		d: "M0 0h900v600H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00a650",
		d: "M0 0h900v300H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ef1923",
		d: "m0 0 450 300L0 600z"
	}));
};
var MR = function MR(_ref162) {
	var title = _ref162.title, rest = _objectWithoutProperties(_ref162, _excluded162);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#00a95c",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d01c1f",
		d: "M0 0h513v46H0zm0 296h513v46H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "gold",
		d: "M256 213.9c-46 0-84.3-32.3-93.8-75.4-1.4 6.6-2.2 13.5-2.2 20.6 0 53 43 96 96 96s96-43 96-96c0-7.1-.8-13.9-2.2-20.6-9.5 43.1-47.8 75.4-93.8 75.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "gold",
		d: "m256 87 8.9 27.5h29l-23.4 17 8.9 27.5-23.4-17-23.4 17 8.9-27.5-23.4-17h29z"
	}));
};
var MS = function MS(_ref163) {
	var title = _ref163.title, rest = _objectWithoutProperties(_ref163, _excluded163);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00A2B8",
		stroke: "#FFF",
		strokeWidth: 3,
		d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A35023",
		d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#510",
		d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var MT = function MT(_ref164) {
	var title = _ref164.title, rest = _objectWithoutProperties(_ref164, _excluded164);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#cf142b",
		d: "M256 0h256.5v342H256z"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "#cf142b",
		strokeWidth: 10,
		d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fff",
		stroke: "#acacac",
		strokeWidth: 5,
		d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 85,
		cy: 85,
		r: 26,
		fill: "none",
		stroke: "#acacac",
		strokeWidth: 5
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 85,
		cy: 85,
		r: 18,
		fill: "#dedede",
		stroke: "#acacac",
		strokeWidth: 5
	}));
};
var MU = function MU(_ref165) {
	var title = _ref165.title, rest = _objectWithoutProperties(_ref165, _excluded165);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#d01c1f",
		d: "M0 0h513v85.5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#2d3359",
		d: "M0 85.5h513V171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f7b718",
		d: "M0 171h513v85.5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#008658",
		d: "M0 256.5h513V342H0z"
	}));
};
var MV = function MV(_ref166) {
	var title = _ref166.title, rest = _objectWithoutProperties(_ref166, _excluded166);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 720 480"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#007E3A",
		stroke: "#D21034",
		strokeWidth: 120,
		d: "M60 60h600v360H60z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 390,
		cy: 240,
		r: 80
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#007E3A",
		cx: 420,
		cy: 240,
		r: 80
	}));
};
var MW = function MW(_ref167) {
	var title = _ref167.title, rest = _objectWithoutProperties(_ref167, _excluded167);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#ce1126",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#339e35",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#ce1126",
		cx: 256.5,
		cy: 125,
		r: 95
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 100h513v14H0z" }));
};
var MX = function MX(_ref168) {
	var title = _ref168.title, rest = _objectWithoutProperties(_ref168, _excluded168);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#dc2339",
		d: "M342 0H0v341.3h513V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#11865d",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M171 0h171v342H171z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#8C9157",
		d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#C59262",
		cx: 256.5,
		cy: 159.1,
		rx: 24.3,
		ry: 36.4
	}));
};
var MY = function MY(_ref169) {
	var title = _ref169.title, rest = _objectWithoutProperties(_ref169, _excluded169);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
		fill: "#c00"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#006",
		d: "M0 0h256.5v195.4H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
		fill: "#fc0"
	}));
};
var MZ = function MZ(_ref170) {
	var title = _ref170.title, rest = _objectWithoutProperties(_ref170, _excluded170);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#006d66",
		d: "M0 0h513v104H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 119h513v104H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#f4d900",
		d: "M0 238h513v104H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#cb0f31",
		d: "M256 171 0 342V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f4d900",
		d: "m83.5 109.8 15.1 46.5h48.9L107.9 185l15.1 46.5-39.5-28.7-39.6 28.7L59 185l-39.5-28.7h48.9z"
	}));
};
var NA = function NA(_ref171) {
	var title = _ref171.title, rest = _objectWithoutProperties(_ref171, _excluded171);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#009a44",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#002f6c",
		d: "M0 342V0h513"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 67V0H412.5L0 275v67h100.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#c8102e",
		d: "M513 0v40.2L60.3 342H0v-40.2L452.7 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffcd00",
		d: "m188.1 104.1-22.8 10.7 12.2 22.1-24.8-4.8-3.1 25-17.3-18.4-17.2 18.4-3.1-25-24.8 4.8 12.2-22.1-22.8-10.7 22.8-10.7-12.2-22.1L112 76l3.1-25 17.2 18.4L149.6 51l3.1 25 24.8-4.7-12.2 22.1z"
	}));
};
var NC = function NC(_ref172) {
	var title = _ref172.title, rest = _objectWithoutProperties(_ref172, _excluded172);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#009543",
		d: "M0 234.8h513V342H0V234.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ED4135",
		d: "M0 105.8h513v129.3H0V105.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0035AD",
		d: "M0 0h513v106.8H0V0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FAE600",
		stroke: "#000",
		strokeWidth: 5.3,
		cx: 192.4,
		cy: 171,
		r: 126.1
	}), /*#__PURE__*/ React.createElement("path", { d: "m246.8 284.1-25.5 9.6-28.9 3.4-30.3-1.9-28.8-12.4s22.9-23.5 32.6-26.9c6.9-2.4 18-3 18-3V97.8l-.2-52.9h13.5l-.4 54.1v153.7s12.3 1 17.7 3.3c9 3.8 32.3 28.1 32.3 28.1z" }), /*#__PURE__*/ React.createElement("path", { d: "m168.3 80.8 39.5-19.7 5.1 10.3-39.5 19.7-5.1-10.3z" }), /*#__PURE__*/ React.createElement("ellipse", {
		cx: 190.6,
		cy: 224.8,
		rx: 13.5,
		ry: 21.2
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 190.3,
		cy: 114.9,
		r: 16.8
	}), /*#__PURE__*/ React.createElement("ellipse", {
		cx: 191.1,
		cy: 169.2,
		rx: 16,
		ry: 9.7
	}), /*#__PURE__*/ React.createElement("path", { d: "M171.4 146.7h37.7v8h-37.7zm0 36h37.7v8h-37.7z" }), /*#__PURE__*/ React.createElement("g", {
		fill: "none",
		stroke: "#000",
		strokeWidth: 10,
		strokeMiterlimit: 10
	}, /*#__PURE__*/ React.createElement("path", { d: "M163.4 112.2s.8 26.8 27.3 26.8 26.5-26.8 26.5-26.8" }), /*#__PURE__*/ React.createElement("path", {
		className: "prefix__st4",
		d: "M163.4 224.8s1.9-26.6 27.3-26.6 26.5 26.6 26.5 26.6"
	})));
};
var NE = function NE(_ref173) {
	var title = _ref173.title, rest = _objectWithoutProperties(_ref173, _excluded173);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#e05206",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0db02b",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#e05206",
		cx: 256.5,
		cy: 171,
		r: 32
	}));
};
var NF = function NF(_ref174) {
	var title = _ref174.title, rest = _objectWithoutProperties(_ref174, _excluded174);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h171v342H0zm342 0h171v342H342zm-38 227L256 75l-48 152h41v40h14v-40z",
		fill: "#007934"
	}));
};
var NG = function NG(_ref175) {
	var title = _ref175.title, rest = _objectWithoutProperties(_ref175, _excluded175);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h171v342H0zm342 0h171v342H342z",
		fill: "#008751"
	}));
};
var NI = function NI(_ref176) {
	var title = _ref176.title, rest = _objectWithoutProperties(_ref176, _excluded176);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v114H0zm0 228h513v114H0z",
		fill: "#0067c6"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "none",
		stroke: "#FFDA44",
		strokeWidth: 5,
		cx: 256.5,
		cy: 171,
		r: 50
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0a47a5",
		d: "M285.7 176.7h-58.4l-9.8 16.9h78z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6fd8f3",
		d: "m256.5 126.1-29.2 50.6h58.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#97c924",
		d: "M221.7 186.4h69.6l-8-13.9h-53.6z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "red",
		cx: 256.5,
		cy: 161,
		r: 5
	}));
};
var NL = function NL(_ref177) {
	var title = _ref177.title, rest = _objectWithoutProperties(_ref177, _excluded177);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#cd1f2a",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1d4185",
		d: "M0 228h513v114H0z"
	}));
};
var NO = function NO(_ref178) {
	var title = _ref178.title, rest = _objectWithoutProperties(_ref178, _excluded178);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ba0c2f",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 211H202.6v131h-79.9V211H0v-80h122.7V0h79.9v131H513v61.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00205b",
		d: "M513 149.6v42.8H184V342h-42.7V192.4H0v-42.8h141.3V0H184v149.6z"
	}));
};
var NP = function NP(_ref179) {
	var title = _ref179.title, rest = _objectWithoutProperties(_ref179, _excluded179);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 342V-.2L281.1 175H87.8l184 167z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M243.4 164.8 9.2 19.3v313.5h235.2l-184.1-168z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m62.4 204.1 7.9 16.2 14.9-10.1-1.3 18 18-1.3-10.1 14.9 16.2 7.9-16.2 7.8 10.1 15-18-1.3 1.3 17.9L70.3 279l-7.9 16.2-7.8-16.2-14.9 10.1 1.3-17.9-18 1.3 10.1-15-16.2-7.8 16.2-7.9L23 226.9l18 1.3-1.3-18 14.9 10.1zm-5.3-103.7 5.3 7.7 5.4-7.7 2 9.1 7.9-5-1.7 9.2 9.3-1.7-5.1 7.9 9.2 2-7.8 5.4 7.8 5.3-9.2 2 5.1 7.9-9.3-1.7 1.7 9.3-7.9-5.1-2 9.2-5.4-7.7-5.3 7.7-2-9.2-7.9 5.1 1.7-9.3-9.3 1.7 5.1-7.9-9.2-2 7.7-5.3-7.7-5.4 9.2-2-5.1-7.9 9.3 1.7-1.7-9.2 7.9 5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M18.5 108.7s4.8 27.7 44 27.7 44-27.7 44-27.7c0 9.4-6 46.5-44 46.5s-44-38.2-44-46.5z"
	}));
};
var NR = function NR(_ref180) {
	var title = _ref180.title, rest = _objectWithoutProperties(_ref180, _excluded180);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc72c",
		d: "M0 155h513v32H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m164.2 189 7.9 27.7 20.7-20-7 27.9 28-7-20.1 20.7 27.8 7.9-27.8 7.9 20.1 20.7-28-7 7 28-20.7-20.1-7.9 27.8-7.9-27.8-20.7 20.1 7-28-27.9 7 20-20.7-27.7-7.9 27.7-7.9-20-20.7 27.9 7-7-27.9 20.7 20z"
	}));
};
var NU = function NU(_ref181) {
	var title = _ref181.title, rest = _objectWithoutProperties(_ref181, _excluded181);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#fedd00",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })), /*#__PURE__*/ React.createElement("circle", {
		fill: "#012169",
		cx: 126.8,
		cy: 85.7,
		r: 29.9
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m128.3 128.6 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm-.1-115.4 3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm76.4 58.1 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7H201zm-151.8.1 3.6 10.9h11.4l-9.3 6.8 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.8-9.3-6.8h11.5zm74-15.6 6.7 20.7h21.8l-17.7 12.8 6.8 20.6-17.6-12.7-17.7 12.7 6.8-20.6-17.6-12.8H120z",
		fill: "#fedd00"
	}));
};
var NZ = function NZ(_ref182) {
	var title = _ref182.title, rest = _objectWithoutProperties(_ref182, _excluded182);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m448.9 107.7 4.2 13.1h13.8l-11.1 8.1L460 142l-11.1-8.1-11.1 8.1 4.2-13.1-11.1-8.1h13.7zm-64.2 145.9 5.1 15.6h16.4l-13.2 9.7 5 15.6-13.3-9.7-13.2 9.7 5-15.6-13.3-9.7h16.5zm.1-210.2 4.7 14.6h15.3l-12.4 8.9 4.7 14.6-12.3-9-12.4 9 4.7-14.6-12.3-8.9H380zm-64.2 86 4.7 14.5h15.3l-12.3 9 4.7 14.5-12.4-8.9-12.3 8.9 4.7-14.5-12.4-9h15.3z",
		fill: "#D80027",
		stroke: "#FFF",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var OM = function OM(_ref183) {
	var title = _ref183.title, rest = _objectWithoutProperties(_ref183, _excluded183);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M138 0h377v114H138z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#4A7C3A",
		d: "M138 230h377v114H138z"
	}), /*#__PURE__*/ React.createElement("g", {
		fill: "none",
		stroke: "#FFF",
		strokeWidth: 10,
		strokeMiterlimit: 2
	}, /*#__PURE__*/ React.createElement("path", { d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7" }), /*#__PURE__*/ React.createElement("path", { d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1" })));
};
var PA = function PA(_ref184) {
	var title = _ref184.title, rest = _objectWithoutProperties(_ref184, _excluded184);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#da121a",
		d: "M256.5 0H513v171H256.5z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#072357",
		d: "M0 171h256.5v171H0zM128 37.9l11.8 36.4h38.3l-31 22.4 11.9 36.4-31-22.5-31 22.5 11.9-36.4-31-22.4h38.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#da121a",
		d: "m384 208.9 11.8 36.4h38.3l-31 22.4 11.9 36.4-31-22.5-31 22.5 11.9-36.4-31-22.4h38.3z"
	}));
};
var PE = function PE(_ref185) {
	var title = _ref185.title, rest = _objectWithoutProperties(_ref185, _excluded185);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h171v342H0zm342 0h171v342H342z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00A854",
		d: "M224.3 119c4.3 7.6-17.1 71.9-6.5 87.8s21.9 22.4 38.2 22.4c16.3 0 30.7-6.8 39.6-24.7s-14.2-76.3-6.8-85.4c7.4-9.1 29.3 8.5 35.5 35.2 6.2 26.7-8.4 60.2-20.7 70-12.3 9.7-20.3 9.7-47.6 9.7s-32.4-1.4-45-10.7c-12.5-9.4-28.9-35.8-22.7-67.3 6.2-31.7 31.7-44.6 36-37z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D91023",
		stroke: "#E7CA00",
		strokeWidth: 2,
		d: "M272.6 218.9H240c-7.5 0-13.6-6.1-13.6-13.6v-45c0-7.5 6.1-13.6 13.6-13.6h32.6c7.5 0 13.6 6.1 13.6 13.6v45c.1 7.5-6 13.6-13.6 13.6z"
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#E7CA00",
		cx: 256.4,
		cy: 200.9,
		rx: 25,
		ry: 13.2
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256.4 147.6v35.1h28.9c0-38.3 3.9-35.1-28.9-35.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#007EA8",
		d: "M256.4 147.6v35.1h-28.9c0-37.9-3.7-35.1 28.9-35.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#947245",
		d: "M270.1 158.1h1.6v21.5h-1.6z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#D18219",
		stroke: "#FFF",
		cx: 241.8,
		cy: 165.2,
		r: 8.1
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "none",
		stroke: "#00A854",
		strokeWidth: 6,
		cx: 256.4,
		cy: 122.2,
		rx: 20.5,
		ry: 16.5
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "none",
		stroke: "#E7CA00",
		strokeWidth: 3,
		cx: 256.4,
		cy: 122.2,
		rx: 20.5,
		ry: 16.5
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#E7CA00",
		cx: 270.9,
		cy: 163.1,
		r: 8.9
	}));
};
var PF = function PF(_ref186) {
	var title = _ref186.title, rest = _objectWithoutProperties(_ref186, _excluded186);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v85H0zm0 257h513v85H0z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1481DB",
		d: "M329.5 171c0 40.3-32.7 73-73 73s-73-32.7-73-73"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFAB50",
		d: "M256.5 98c-40.3 0-73 32.7-73 73h146c0-40.3-32.7-73-73-73z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M181.9 169.3h150.5v4.5H181.9z" }), /*#__PURE__*/ React.createElement("path", { d: "M222.4 162.9h66.5v10.9h-66.5z" })), /*#__PURE__*/ React.createElement("path", {
		d: "M212.8 131.1H223s-1.6 55.5.1 57.4c11.9 13.5 25.3 0 25.3 0s-2.7 18.9-17.8 18.9-17.8-18.7-17.8-18.7v-57.6zm85.6 0h-10.2s1.6 55.5-.1 57.4c-11.9 13.5-25.3 0-25.3 0s2.7 18.9 17.8 18.9c15.1 0 17.8-18.7 17.8-18.7v-57.6zM242.6 156l25.9 6.9v-36.4s-14-3.8-14-16.8 14-9.6 14-9.6-25.9-4.6-25.9 8.1V156z",
		fill: "#D80027",
		stroke: "#630810",
		strokeWidth: 2
	}));
};
var PG = function PG(_ref187) {
	var title = _ref187.title, rest = _objectWithoutProperties(_ref187, _excluded187);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v342H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#C8102E",
		d: "M0 0h513v342"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m153.7 225 2.7 8.5h9l-7.2 5.2 2.7 8.6-7.2-5.3-7.3 5.3 2.8-8.6-7.3-5.2h9zm-25.3-120 5.2 16h16.8l-13.6 9.9 5.2 16-13.6-9.9-13.6 9.9 5.2-16-13.6-9.9h16.8zm0 160.3 5.2 16h16.8l-13.6 9.9 5.2 16-13.6-9.9-13.6 9.9 5.2-16-13.6-9.9h16.8zm50.7-96.1 5.2 16h16.8l-13.6 9.9 5.2 16-13.6-9.9-13.6 9.9 5.2-16-13.6-9.9h16.8zm-107.3 4.1 5.2 16h16.8l-13.6 9.9 5.2 15.9-13.6-9.8-13.6 9.8 5.2-15.9-13.6-9.9h16.8z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFCD00" }, /*#__PURE__*/ React.createElement("path", { d: "M288 79.9s33 13.8 30 19.7c-2.9 5.9-17.4-7.1-30-3.5-12.7 3.5-28.6 32.4-28.6 32.4s18.6 2.7 34.2 1.5c15.6-1.2 19.7-7.4 19.7-7.4s.7 15.3 12.7 24.3c18.2 13.6 56.2 22.3 56.2 22.3s.6-6.5-2.7-20.7-8-21.4-8-21.4 55.7 38.3 51.2 59.3-30.1 19.6-30.1 19.6 28.4 12.5 37.4-13.5c12.4-35.6-42.4-65.2-42.4-65.2s6.5 3.1 17.1 4.6 20.3-.3 20.3-.3-13.8-43.6-29.2-52.1c-15.3-8.5-37.1-.9-37.1-.9s9.1-5.9 10-15.9c.9-10-3.5-24.1-3.5-24.1-50.1 21.2-21.2 41.2-33 49.2-2 1.4-9.5-9.9-18.8-8.2-11.5 1.8-25.4.3-25.4.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M404.7 131.8s15.3 17.7 8.2 35.9c-7.1 18.3-37.7 13.5-37.7 13.5s24.7 13.9 40.6-5.3-2.4-43.6-2.4-43.6l-8.7-.5z" })));
};
var PH = function PH(_ref188) {
	var title = _ref188.title, rest = _objectWithoutProperties(_ref188, _excluded188);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0038A8",
		d: "M513 0v171H256.5L0 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#CE1126",
		d: "M513 171v171H0l256.5-171z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FCD116" }, /*#__PURE__*/ React.createElement("path", { d: "m22.1 33.8 8.5 11.9 13.8-4.5-8.6 11.7 8.5 11.8-13.8-4.6-8.6 11.7V57.2L8.2 52.7 22 48.4zm0 236.4 8.5 11.8 13.8-4.4-8.6 11.7 8.5 11.8-13.8-4.6-8.6 11.7v-14.6l-13.7-4.5 13.8-4.3zM210.5 152l-8.5 11.8-13.8-4.4 8.6 11.7-8.4 11.8 13.7-4.6 8.6 11.7v-14.6l13.7-4.5-13.8-4.3z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 95,
		cy: 171,
		r: 32
	}), /*#__PURE__*/ React.createElement("path", { d: "m95 171 11.2 56.5-3.4 3.4-3.7 3.5-4.2 4.2-4.2-4.2-3.7-3.5-3.4-3.4L95 171zm0 0-11.2-56.5 3.4-3.4 3.7-3.5 4.2-4.2 4.2 4.2 3.7 3.5 3.4 3.4L95 171zm0 0 56.5-11.2 3.4 3.4 3.5 3.7 4.2 4.2-4.2 4.2-3.5 3.7-3.4 3.4L95 171zm0 0-56.5 11.2-3.4-3.4-3.5-3.7-4.2-4.2 4.2-4.2 3.5-3.7 3.4-3.4L95 171zm0 0 32-47.9h4.8l5.1.2h5.9v5.9l.2 5.1v4.8L95 171zm0 0-32 47.9h-4.8l-5.1-.2h-5.9v-5.9l-.2-5.1v-4.8L95 171zm0 0 47.9 32v4.8l-.2 5.1v5.9h-5.9l-5.1.2h-4.8L95 171zm0 0-47.9-32v-4.8l.2-5.1v-5.9h5.9l5.1-.2h4.8L95 171z" })));
};
var PK = function PK(_ref189) {
	var title = _ref189.title, rest = _objectWithoutProperties(_ref189, _excluded189);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h900v600H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#01411C",
		d: "M225 0h675v600H225z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M562.5 120c99.4 0 180 80.6 180 180s-80.6 180-180 180-180-80.6-180-180 80.6-180 180-180z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#01411C",
		d: "M498.9 135.8c68.1-60.5 172.4-54.4 232.9 13.7s54.4 172.4-13.7 232.9-172.4 54.4-232.9-13.7-54.4-172.4 13.7-232.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m628.1 165.3 75.8 85.3-111.5-24.4L697 180.4l-57.7 98.5-11.2-113.6z"
	}));
};
var PL = function PL(_ref190) {
	var title = _ref190.title, rest = _objectWithoutProperties(_ref190, _excluded190);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#dc143c",
		d: "M0 171h513v171H0z"
	}));
};
var PM = function PM(_ref191) {
	var title = _ref191.title, rest = _objectWithoutProperties(_ref191, _excluded191);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00318A",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M342 0h171v342H342z"
	}));
};
var PN = function PN(_ref192) {
	var title = _ref192.title, rest = _objectWithoutProperties(_ref192, _excluded192);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("g", { stroke: "#000" }, /*#__PURE__*/ React.createElement("path", {
		fill: "#96877d",
		d: "m400.7 134.5-16.7 5.6-16.7-5.6-5.6-13.9 5.6-13.9h33.4l-5.6 13.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#006ec7",
		d: "M345 134.5v61.2c0 29.8 39 39 39 39s39-9.1 39-39v-61.2h-78z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#337321",
		d: "M348.6 210.2c9.6 18.4 35.4 24.5 35.4 24.5s25.9-6.1 35.4-24.5l-35.4-59-35.4 59z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f7e017",
		d: "m423 195.1-39-60.6-39 60.6v.6c0 5.5 1.3 10.3 3.5 14.5l35.4-55.1 35.4 55.1c2.2-4.2 3.5-9 3.5-14.5v-.6z"
	})), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#f7e017",
		d: "M375 189.5h18.3l.1 5.5h-5.8v25.2l12.3-6.1 3 5-18.9 9.7-18.4-9.8 2.9-5.1 12.6 6.3V195H375z"
	}));
};
var PR = function PR(_ref193) {
	var title = _ref193.title, rest = _objectWithoutProperties(_ref193, _excluded193);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v68.4H0zm0 136.8h513v68.4H0zm0 136.8h513V342H0z",
		fill: "#E00"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#04F",
		d: "M256.5 171 0 342V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m84 110.1 15.1 46.5H148l-39.6 28.8 15.1 46.5L84 203.1l-39.6 28.8 15.1-46.5L20 156.6h48.9z"
	}));
};
var PS = function PS(_ref194) {
	var title = _ref194.title, rest = _objectWithoutProperties(_ref194, _excluded194);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 0h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#007A3D",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#CE1126",
		d: "M256.5 171 0 342V0z"
	}));
};
var PT = function PT(_ref195) {
	var title = _ref195.title, rest = _objectWithoutProperties(_ref195, _excluded195);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "red",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#060",
		d: "M197 0v342H0V0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FF0",
		cx: 197.1,
		cy: 171,
		r: 64
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "red",
		d: "M161.1 139v40c0 19.9 16.1 36 36 36s36-16.1 36-36v-40h-72z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M197.1 191c-6.6 0-12-5.4-12-12v-16h24v16c0 6.6-5.3 12-12 12z"
	}));
};
var PW = function PW(_ref196) {
	var title = _ref196.title, rest = _objectWithoutProperties(_ref196, _excluded196);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#09f",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#ff0",
		cx: 220,
		cy: 171,
		r: 74
	}));
};
var PY = function PY(_ref197) {
	var title = _ref197.title, rest = _objectWithoutProperties(_ref197, _excluded197);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D52B1E",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0038A8",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#009B3A",
		d: "m279.7 148-8.7 8.7c3.7 3.7 6 8.8 6 14.5 0 11.3-9.2 20.5-20.5 20.5s-20.5-9.2-20.5-20.5c0-5.7 2.3-10.8 6-14.5l-8.7-8.7c-5.9 5.9-9.6 14.1-9.6 23.2 0 18.1 14.7 32.8 32.8 32.8s32.8-14.7 32.8-32.8c0-9.1-3.7-17.3-9.6-23.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FEDF00",
		stroke: "#000",
		d: "m256.5 157.2 3.2 9.9h10.5l-8.5 6.2 3.2 9.9-8.4-6.2-8.4 6.2 3.2-9.9-8.5-6.2h10.5z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "none",
		stroke: "#000",
		strokeWidth: 2,
		cx: 256.5,
		cy: 171,
		r: 45
	}));
};
var QA = function QA(_ref198) {
	var title = _ref198.title, rest = _objectWithoutProperties(_ref198, _excluded198);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#8a1538",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
	}));
};
var RE = function RE(_ref199) {
	var title = _ref199.title, rest = _objectWithoutProperties(_ref199, _excluded199);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00318A",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M342 0h171v342H342z"
	}));
};
var RO = function RO(_ref200) {
	var title = _ref200.title, rest = _objectWithoutProperties(_ref200, _excluded200);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#002b7f",
		d: "M0 0h171v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fcd116",
		d: "M171 0h171v342H171z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ce1126",
		d: "M342 0h171v342H342z"
	}));
};
var RS = function RS(_ref201) {
	var title = _ref201.title, rest = _objectWithoutProperties(_ref201, _excluded201);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#c6363c",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0c4076",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 228h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#c6363c",
		d: "M120 96.8v85.1c0 48.4 63.3 63.3 63.3 63.3s63.3-14.8 63.3-63.3V96.8H120z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M146.1 111.6h74.2V82l-14.8 7.4-22.3-22.3L161 89.4 146.1 82zm85.6 82.2-48.3-48.2-48.2 48.2 15.7 15.7 32.5-32.5 32.5 32.5z",
		fill: "#edb92e"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M231.7 148.7h-22.5c1.3-2.2 2-4.7 2-7.4 0-8.2-6.6-14.8-14.8-14.8-5.7 0-10.6 3.2-13.1 7.8-2.5-4.7-7.4-7.8-13.1-7.8-8.2 0-14.8 6.6-14.8 14.8 0 2.7.7 5.2 2 7.4h-22.1c0 8.2 7.1 14.8 15.3 14.8h-.6c0 8.2 6.6 14.8 14.8 14.8 0 7.3 5.2 13.3 12.1 14.6l-11.7 26.4c5.6 2.3 11.7 3.5 18.1 3.5s12.5-1.3 18.1-3.5L189.9 193c6.9-1.3 12.1-7.3 12.1-14.6 8.2 0 14.8-6.6 14.8-14.8h-.5c8.2 0 15.4-6.7 15.4-14.9z"
	}));
};
var RU = function RU(_ref202) {
	var title = _ref202.title, rest = _objectWithoutProperties(_ref202, _excluded202);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0039a6",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#d52b1e",
		d: "M0 228h513v114H0z"
	}));
};
var RW = function RW(_ref203) {
	var title = _ref203.title, rest = _objectWithoutProperties(_ref203, _excluded203);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#00A5E0",
		d: "M0 0h513v171H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F9D202",
		d: "M0 171h513v85.5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1E5F3D",
		d: "M0 256.5h513V342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F9D202",
		d: "m420.6 36.1 2.3 35.9 11.6-34.1-7 35.3 19.9-29.9-15.8 32.2 27-23.7-23.7 27L467.1 63l-29.9 19.9 35.3-7-34.1 11.6 35.9 2.3-35.9 2.3 34.1 11.6-35.3-7 29.9 19.9-32.2-15.8 23.7 27-27-23.7 15.8 32.2-19.9-29.9 7 35.3-11.6-34.1-2.3 35.9-2.3-35.9-11.6 34.1 7-35.3-19.9 29.9 15.8-32.2-27 23.7 23.7-27-32.2 15.8L404 96.7l-35.3 7 34.1-11.6-35.9-2.3 35.9-2.3-34.1-11.6 35.3 7L374.1 63l32.2 15.8-23.7-27 27 23.7-15.8-32.2 19.9 29.9-7-35.3L418.3 72z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#F9D202",
		stroke: "#00A5E0",
		strokeWidth: 2,
		cx: 420.6,
		cy: 89.8,
		r: 15.9
	}));
};
var SA = function SA(_ref204) {
	var title = _ref204.title, rest = _objectWithoutProperties(_ref204, _excluded204);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v342H0z",
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#00512e" }, /*#__PURE__*/ React.createElement("path", { d: "M0 0v342h513V0zm218 76q1 2-2 5-3 2-1 4 3 4 0 6-2 1-5-1-6-6 0-14 6-4 8 0m-102 2 1 6q0 4-2 4-5 1-5-6l2-4zm39 1 1 2q-1 4-5 4-5 0-6-4c0-4 7-6 10-2m47 2q3 4 2 9c-1 2-22 19-24 19q-3 0-4-4l6-6 6-5v-3c-5-10 7-18 14-10m35-3q3 1 0 7-2 8-6 6c-3-1-3 14 0 19q2 4 7-1c2-3 2-5 2-15 0-12 0-13 2-13q5-2 5 13 1 11 3 13 3 6 6 3 3-2-1-12-3-12 1-16h9q2-2 9 1l6 2 1-2q4-4 6-1l3 17c3 16 3 16 7 24l15 30q1 6-4 5l-8-14-6-12 1 20c1 21 1 23-4 23q-4 2-4-15l-1-27-1-16-9-13c-8-12-8-13-11-13q-6-1-2 6l2 7q0 4 3 2 6-2 6 3-1 4-8 5l-5 2-5 2q-6 0-10-3-2-3-5 1-5 5-12 2-5-1-7-10l-1-3-1 3q-3 7-9 8-7 0-9-11-3-10 2-10 4-1 5 7l2 6q1 0 4-7 6-17 13-12h1c-1-1 2-10 4-11zm-97 10 2 16 1 9h4q5 2 6-1c2-1 2-2-1-11l-3-12 3-1 11 5V82q4-2 6 1l3 23 1 20h2q5 0 5 5 1 6 3 0 3-9 8-2 1 3 2 0 3-7 4-6c5 0 6 7 1 13q-3 3-7 3l-6 1q-5 4-10 0l-2-2v5c0 21-16 42-33 42q-21-1-23-21 0-5 2-6 4-1 6 6 1 12 12 13 14 2 24-15 6-11 1-5-12 18-28 11-7-5-9-17-2-6 1-7 5-3 6 6 1 12 10 12 7 0 13-8 5-8-1-7-11-1-8-12 8-11 17-5l3 2-1-12-4-22q-3 1 0 7c2 6 2 6 0 10l-5 5q-3 3-7 1h-5l-1 16c-1 19-1 20-4 21-4 1-4-2-4-19l1-15-3 1q-3 1-6-2c-2-2-2-2-3-14l-1-12q-2-1-2 10l-1 13q-3 6-8 4c-3-2-4-4-7-15q-4-15 2-14 4-1 5 8l1 5 1-6q0-13 9-12l6 2c2 3 2 4 2 14l1 11 2-1 1-8-2-16q-3-12 2-11 3-1 5 7m163-3q4 10 1 13-4 3-7-7-3-11 2-10zm12-3 3 7q2 6 1 8v16l2 27c2 22 2 21 6 21h3l-1-5-2-23-3-33c-2-16-1-19 3-19 3 0 8 14 6 16v24c5 47 5 48 0 47q-3-2-1 4l2 6q2 1 5-9 7-18 10-16 3 0 7 5 4 7 7 7 4-1 1-33l-1-21-10-12-9-15q0-5 8-1 5 2 6 6l2 6q3 4 1-4 0-10 3-10c4 0 9 10 7 13l-1 8q1 8 4 12l3 3-2-15c-2-16-2-19 1-20q3 0 5 4l4 5h2q6-4 8 9 0 8-4 8-3 0-4-6 1-8-3-5c-1 2-1 3 1 19l2 17 5 7c6 10 12 21 11 22q-2 3-5 2l-5-8-5-8 1 8c0 11 0 11-3 11q-5 3-5-7l-1-16c0-8-1-10-4-15l-4-5v19c1 21 0 25-5 28q-6 5-13-3l-4-5-4 9q-6 14-11 15-9-1-11-16-1-8-5-1c-3 5-12 13-19 17q-8 4-8-2-1-2 6-6c9-5 17-14 17-18l-5-78q2-4 5-1m89 5 4 6q1 1-2 3l-2 2 4 24q4 25 4 35c0 10 0 11-3 17q-7 13-19 14-8 0-7-2-2-4 7-6 15-2 14-23a708 708 0 0 0-8-75c3-2 3-1 8 5m-211 19 1 4q0 3 2 2 5 0 5 4c0 4-9 6-13 2-4-5 0-17 5-12m108 1h2l4-1q4 2 0 7-7 6-11-1v-5q3-2 5 0m55 2q3 4-1 6-2 0-1 5t-1 6q-1 2-10-6-8-7-6-9 3-4 7 0l2 2 2-3q5-3 8-1m-131 13c3 2 6 14 6 17q-1 6 6 1l10-4q5-1 7-4 4-9 10-12 10 0 11 9 0 7-16 13l-2 1 13 1c16 0 16 0 13 9q-2 7-4 7l-10 2q-19 3-17 9 1 2 4 3 6 3 3 7l-7 1q-13-2-21-10l-3-3-2 3q-7 10-19 13-10 2-15-10l-5 2q-18 10-19 8l-2-3c0-2 1-2 15-11l9-6q1-3 5-4c3 1 10-5 12-9q3-6-1-15l-2-8q1-5 6-6c3 0 8 5 8 7q-1 4-4 3v1l1 10c1 9-1 13-10 21l-7 6 2 3q5 9 15-2 10-8 10-23 0-10-6-24v-4q3-4 6 1m17 2q2 3 4 0 11-3 5 5c-4 5-12 5-15-1v-4zm118 5 1 2q1 2-7 8c-8 6-9 7-11 5q-5-4 6-10c8-6 8-6 11-5m-229 3q3 2-10 10-12 8-13 3-5-3 9-10 13-8 14-3m229 10c3 2 4 9 3 11q-3 3-6 1c-2-2-3-11-1-13q1-2 4 1m-172 7q3 3 2 7 1 5-3 5-3 1-3-3l-2-4q-3-3-1-6 4-2 7 1m-79 9 1 8q0 9 3 6 4-1 4 3-1 7-7 7-7-1-7-14-1-9 2-10zm168 12q0 4 3 2t4 3q-2 6-8 8l-4-2q-3-3-4-2-4 0-5-4l5-6q7-6 7-4 3 1 2 5m102 3q4 4 1 9-7 7-7-4t6-5m-42 73c0 2 1 2 12 2q24-1 22 11 0 7-6 10c-4 1-31 2-34 0q-2-1-2-6v-4h-82l-74-1c-16 0-28-10-28-10h92c91 0 92-1 92-2q-1-3 4-5c5-2 4 4 4 5" }), /*#__PURE__*/ React.createElement("path", { d: "m195 86 1 1 1-1-1-1q-2 0-1 1m84 5q-2 2 1 5l3 3-1-4-1-5zm-125 45q-3 3-1 4 5-1 6-4zm110-7q-4 5 0 3 6-4 2-4zm-31 30q0 6 4 8l5 4q3 2 2-3 0-3 4-7 4-3 2-4l-13-3h-5zm104 101q-1 3 13 2c11 0 13 0 14-2l-13-1z" })));
};
var SB = function SB(_ref205) {
	var title = _ref205.title, rest = _objectWithoutProperties(_ref205, _excluded205);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#205831",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#004EB4",
		d: "M0 342V0h513"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F4CA15",
		d: "M0 328v14h28L513 14V0h-28z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M47.2 11.5 54 32.6h22.3l-18 13.2 6.9 21.1-18-13.1-18 13.1L36 45.8 18 32.6h22.3zm113.6 0 6.9 21.1H190l-18 13.2 6.8 21.1-18-13.1-18 13.1 6.9-21.1-18-13.2H154zM47.2 122.3l6.8 21.1h22.3l-18 13.2 6.9 21.1-18-13-18 13 6.8-21.1-18-13.2h22.3zm113.6 0 6.9 21.1H190l-18 13.2 6.8 21.1-18-13-18 13 6.9-21.1-18-13.2H154zM104 66.9l6.8 21.2h22.3l-18 13 6.9 21.2-18-13.1-18 13.1 6.8-21.2-18-13h22.3z",
		fill: "#FFF"
	}));
};
var SC = function SC(_ref206) {
	var title = _ref206.title, rest = _objectWithoutProperties(_ref206, _excluded206);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F6CA3F",
		d: "M185.9 0 0 342 368.2 0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#007631",
		d: "M513 224.5 0 342h513z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#CB262E",
		d: "M513 0H358.2L0 342l513-224.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#002E69",
		d: "M0 0v342L185.9 0z"
	}));
};
var SD = function SD(_ref207) {
	var title = _ref207.title, rest = _objectWithoutProperties(_ref207, _excluded207);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#cb0f32",
		d: "M0 0h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 114h513v114H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 228h513v114H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#006e28",
		d: "m0 0 200 171L0 342z"
	}));
};
var SE = function SE(_ref208) {
	var title = _ref208.title, rest = _objectWithoutProperties(_ref208, _excluded208);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#004F8E",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F6C500",
		d: "M192.4.3h-64.2v138.8H0v64.1h128.2V342h64.2V203.2H513v-64.1H192.4z"
	}));
};
var SG = function SG(_ref209) {
	var title = _ref209.title, rest = _objectWithoutProperties(_ref209, _excluded209);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h900v600H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ED2939",
		d: "M0 0h900v300H0V0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M129.7 150c0-48.8 29-90.9 70.6-109.9-3.4-.3-6.8-.5-10.2-.5-61 0-110.4 49.4-110.4 110.4s49.4 110.4 110.4 110.4c3.4 0 6.9-.2 10.2-.5-41.7-19-70.6-61.1-70.6-109.9zm131.2-59.9 16.9-12.3H257l-6.5-19.9-6.5 19.9h-20.8l16.9 12.3-6.5 19.8 16.9-12.3 16.9 12.3zm37.3 114.5 16.9-12.2h-20.9l-6.5-19.9-6.4 19.9h-20.9l16.9 12.2-6.5 19.9 16.9-12.3 16.9 12.3z" }), /*#__PURE__*/ React.createElement("path", { d: "m200.7 133.8 16.9-12.3h-20.9l-6.4-19.8-6.5 19.8h-20.9l16.9 12.3-6.4 19.9 16.9-12.3 16.9 12.3zm137.4-12.3h-20.9l-6.5-19.8-6.4 19.8h-20.9l16.9 12.3-6.5 19.9 16.9-12.3 16.9 12.3-6.4-19.9zm-114.4 83.1 16.9-12.2h-20.9l-6.4-19.9-6.5 19.9h-20.9l16.9 12.2-6.4 19.9 16.9-12.3 16.9 12.3z" })));
};
var SH = function SH(_ref210) {
	var title = _ref210.title, rest = _objectWithoutProperties(_ref210, _excluded210);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#5f7dbd",
		d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#f2d049",
		d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#b38c79",
		d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#5c5568",
		d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var SI = function SI(_ref211) {
	var title = _ref211.title, rest = _objectWithoutProperties(_ref211, _excluded211);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 240 160"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF0D0B",
		d: "M0 0h240v160H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0E55BD",
		d: "M0 0h240v106.7H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h240v53.3H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0E55BD",
		d: "M99.5 30.8c-12.4-5.5-26.4-5.5-38.8 0-2.2 28.7 4.4 44.8 19.3 48.7 14.9-3.9 21.5-20 19.5-48.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m82 37.1-1.5.1-.5-1.3-.5 1.3-1.5-.1.8 1.2-.8 1.2 1.5-.2.5 1.2.5-1.2 1.5.2-.8-1.2zm-5.5-7.4-1.4.2-.6-1.4-.6 1.4-1.4-.2.8 1.2-.8 1.2 1.4-.1.6 1.3.6-1.3 1.4.1-.8-1.2zm11 0-1.4.2-.6-1.4-.6 1.4-1.4-.2.8 1.2-.8 1.2 1.4-.1.6 1.3.6-1.3 1.4.1-.8-1.2z",
		fill: "#FF0"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m87.9 48.7-3.1 4.1-4.7-9.3-4.7 9.3-3.1-4.1-7.9 10.4c0 .5.1.9.3 1.5 2.1 7.6 8 13.7 15.5 16.3 7.5-2.5 13.3-8.7 15.5-16.3.1-.4.3-.9.3-1.5l-8.1-10.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0E55BD",
		d: "M64.5 60.5c.8 2.8 3.7 4.4 6.4 3.6.4-.1.8-.3 1.2-.5 1.6-.9 3.6-.9 5.2 0s3.6.9 5.2 0 3.6-.9 5.2 0c2.5 1.5 5.7.5 7.1-1.9.3-.4.4-.8.5-1.2l.3.1v3.9c-.9 0-1.9.3-2.7.7-1.6.9-3.6.9-5.2 0s-3.6-.9-5.2 0-3.6.9-5.2 0-3.6-.9-5.2 0-3.6.9-5.2 0c-.8-.4-1.7-.7-2.7-.7v-3.9"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0E55BD",
		d: "M64.5 63.6c.8 2.8 3.7 4.4 6.4 3.6.4-.1.8-.3 1.2-.5 1.6-.9 3.6-.9 5.2 0s3.6.9 5.2 0 3.6-.9 5.2 0c2.5 1.5 5.7.5 7.1-1.9.3-.4.4-.8.5-1.2l.3.1v3.9c-.9 0-1.9.3-2.7.7-1.6.9-3.6.9-5.2 0s-3.6-.9-5.2 0-3.6.9-5.2 0-3.6-.9-5.2 0-3.6.9-5.2 0c-.8-.4-1.7-.7-2.7-.7v-3.9"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF0D0B",
		d: "m99.5 30.8-1.6 24.8c-.7 10.5-7.8 19.7-17.9 22.9-10.1-3.2-17.2-12.3-17.9-22.9l-1.6-24.8c-.5.3-.9.4-1.5.7l1.5 24.1C61.3 66.9 69.1 76.7 80 80c10.9-3.3 18.7-13.1 19.3-24.4l1.5-24.1c-.4-.3-.9-.6-1.3-.7z"
	}));
};
var SJ = function SJ(_ref212) {
	var title = _ref212.title, rest = _objectWithoutProperties(_ref212, _excluded212);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#ba0c2f",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M513 211H202.6v131h-79.9V211H0v-80h122.7V0h79.9v131H513v61.4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00205b",
		d: "M513 149.6v42.8H184V342h-42.7V192.4H0v-42.8h141.3V0H184v149.6z"
	}));
};
var SK = function SK(_ref213) {
	var title = _ref213.title, rest = _objectWithoutProperties(_ref213, _excluded213);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 196.641h512v118.717H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 315.359h512v111.304H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
	}));
};
var SL = function SL(_ref214) {
	var title = _ref214.title, rest = _objectWithoutProperties(_ref214, _excluded214);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 85.337h512v113.775H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 312.888h512v113.775H0z"
	}));
};
var SM = function SM(_ref215) {
	var title = _ref215.title, rest = _objectWithoutProperties(_ref215, _excluded215);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 85.34h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M512 85.334v166.69L0 256.175V85.334z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
	}));
};
var SN = function SN(_ref216) {
	var title = _ref216.title, rest = _objectWithoutProperties(_ref216, _excluded216);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.331h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M330.207 85.331H512v341.337H330.207z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
		fill: "#496E2D"
	}));
};
var SO = function SO(_ref217) {
	var title = _ref217.title, rest = _objectWithoutProperties(_ref217, _excluded217);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
	}));
};
var SR = function SR(_ref218) {
	var title = _ref218.title, rest = _objectWithoutProperties(_ref218, _excluded218);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#A2001D",
		d: "M0 196.636h512v118.728H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
		fill: "#6DA544"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
	}));
};
var SS = function SS(_ref219) {
	var title = _ref219.title, rest = _objectWithoutProperties(_ref219, _excluded219);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 322.783h512v103.88H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 85.337h512v104.515H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#A2001D",
		d: "M0 210.877h512v89.656H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M256 256.006 0 426.668V85.331z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
	}));
};
var ST = function ST(_ref220) {
	var title = _ref220.title, rest = _objectWithoutProperties(_ref220, _excluded220);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
		fill: "#6DA544"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M256 256.006 0 426.668V85.331z"
	}), /*#__PURE__*/ React.createElement("path", { d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z" }));
};
var SV = function SV(_ref221) {
	var title = _ref221.title, rest = _objectWithoutProperties(_ref221, _excluded221);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
		fill: "#0052B4"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M228.582 261.936 256 214.447l27.418 47.489z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
	}));
};
var SX = function SX(_ref222) {
	var title = _ref222.title, rest = _objectWithoutProperties(_ref222, _excluded222);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M512 85.331v166.69L0 256.173V85.331z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256 256.006 0 426.668V85.331z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFDA44" }, /*#__PURE__*/ React.createElement("path", { d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 118.862,
		cy: 210.287,
		r: 18.286
	})), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#F3F3F3",
		d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
	}));
};
var SY = function SY(_ref223) {
	var title = _ref223.title, rest = _objectWithoutProperties(_ref223, _excluded223);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h900v600H0z",
		fill: "#0f0f0f"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h900v400H0z",
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h900v200H0z",
		fill: "#047a3f"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m176.26 375 48.738-150 48.738 150-127.6-92.705h157.72M626.256 375l48.738-150 48.738 150-127.6-92.705h157.72M401.252 375l48.738-150 48.738 150-127.6-92.705h157.72",
		fill: "#ce1126"
	}));
};
var SZ = function SZ(_ref224) {
	var title = _ref224.title, rest = _objectWithoutProperties(_ref224, _excluded224);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#2B5DEA",
		d: "M0 0h900v600H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDF29",
		d: "M0 100h900v400H0V100z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D70000",
		d: "M0 150h900v300H0V150z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z" }));
};
var TA = function TA(_ref225) {
	var title = _ref225.title, rest = _objectWithoutProperties(_ref225, _excluded225);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#1799f8",
		d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1799f8",
		d: "m385.4 251.7-22.9-43h45.8z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m385.4 165.8-22.9 42.9h45.8z"
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#dcb072",
		cx: 474.8,
		cy: 236.8,
		rx: 16.8,
		ry: 43.3
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#dcb072",
		cx: 295.3,
		cy: 236.8,
		rx: 16.8,
		ry: 43.3
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
	}), /*#__PURE__*/ React.createElement("ellipse", {
		fill: "#A5A5A5",
		cx: 386.3,
		cy: 104.3,
		rx: 34.3,
		ry: 23.3
	}));
};
var TC = function TC(_ref226) {
	var title = _ref226.title, rest = _objectWithoutProperties(_ref226, _excluded226);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		stroke: "#fff",
		strokeWidth: 4,
		d: "M332.1 106.7v78.2c0 38.1 51.9 49.8 51.9 49.8s51.9-11.7 51.9-49.8v-78.2H332.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#fcad56",
		d: "M376.6 135.1c0 7.9-6.6 28.4-14.8 28.4S347 142.9 347 135.1c0-7.9 14.8-14.2 14.8-14.2s14.8 6.4 14.8 14.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#9e540a",
		d: "M416 150.6c2.4-5.6 4.3-13.8 4.3-17.9 0-6.5-8.9-11.9-8.9-11.9s-8.9 5.3-8.9 11.9c0 4.1 1.9 12.3 4.3 17.9l-5.1 11.1c3 1.2 6.3 1.8 9.8 1.8 3.5 0 6.8-.7 9.8-1.8l-5.3-11.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#009e49",
		d: "M372.9 184.9s-7.4 14.2-7.4 28.4h37.1c0-14.2-7.4-28.4-7.4-28.4l-11.1-7.1-11.2 7.1z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ce1126",
		d: "M395.1 184.9v-3.6c0-5.9-5-10.7-11.1-10.7s-11.1 4.8-11.1 10.7v3.6h22.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var TD = function TD(_ref227) {
	var title = _ref227.title, rest = _objectWithoutProperties(_ref227, _excluded227);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 85.331h170.663v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M341.337 85.331H512v341.337H341.337z"
	}));
};
var TF = function TF(_ref228) {
	var title = _ref228.title, rest = _objectWithoutProperties(_ref228, _excluded228);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22.5 15"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h21v15H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0A388A",
		d: "M0 0h22.5v15H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h11.3v7.5H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M7.1 0h3.6v7H7.1V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0A388A",
		d: "M0 0h3.6v7H0V0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
	}));
};
var TG = function TG(_ref229) {
	var title = _ref229.title, rest = _objectWithoutProperties(_ref229, _excluded229);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
		fill: "#496E2D"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.337h204.054v204.054H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
	}));
};
var TH = function TH(_ref230) {
	var title = _ref230.title, rest = _objectWithoutProperties(_ref230, _excluded230);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.334h512V426.66H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 194.056h512v123.882H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
		fill: "#D80027"
	}));
};
var TJ = function TJ(_ref231) {
	var title = _ref231.title, rest = _objectWithoutProperties(_ref231, _excluded231);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.337h512v113.775H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 312.888h512v113.775H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
		fill: "#FFDA44"
	}));
};
var TK = function TK(_ref232) {
	var title = _ref232.title, rest = _objectWithoutProperties(_ref232, _excluded232);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
		fill: "#FFDA44"
	}));
};
var TL = function TL(_ref233) {
	var title = _ref233.title, rest = _objectWithoutProperties(_ref233, _excluded233);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 90.691v330.618L189.217 256z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
	}));
};
var TM = function TM(_ref234) {
	var title = _ref234.title, rest = _objectWithoutProperties(_ref234, _excluded234);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z" }), /*#__PURE__*/ React.createElement("path", { d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M83.478 85.337h89.043v341.326H83.478z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
		fill: "#FF9811"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
		fill: "#FF9811"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
		fill: "#496E2D"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M120.576 248.576h14.84v14.84h-14.84z" }), /*#__PURE__*/ React.createElement("circle", {
		cx: 128,
		cy: 206.113,
		r: 7.421
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 128,
		cy: 305.887,
		r: 7.421
	})));
};
var TN = function TN(_ref235) {
	var title = _ref235.title, rest = _objectWithoutProperties(_ref235, _excluded235);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 256,
		cy: 255.994,
		r: 96
	}), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z" }), /*#__PURE__*/ React.createElement("path", { d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z" })));
};
var TO = function TO(_ref236) {
	var title = _ref236.title, rest = _objectWithoutProperties(_ref236, _excluded236);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.331h256v170.663H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
	}));
};
var TR = function TR(_ref237) {
	var title = _ref237.title, rest = _objectWithoutProperties(_ref237, _excluded237);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#E30A17",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
	}));
};
var TT = function TT(_ref238) {
	var title = _ref238.title, rest = _objectWithoutProperties(_ref238, _excluded238);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z" }));
};
var TV = function TV(_ref239) {
	var title = _ref239.title, rest = _objectWithoutProperties(_ref239, _excluded239);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#00B2EE",
		d: "M0 171h256.5V0H513v342H0V171z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m196.8 274.1 16.8 51.6-43.9-31.9H224l-43.9 31.9 16.7-51.6zm205.8-80.3 16.8 51.6-43.9-31.9h54.3l-43.9 31.9 16.7-51.6zm60.7-44.7 16.8 51.6-43.9-31.9h54.3l-43.9 31.9 16.7-51.6zm0-127.8L480.1 73l-44-32h54.3l-43.9 32 16.8-51.7zm-53 53.7 16.8 51.6-43.9-31.9h54.3l-43.9 31.9L410.3 75zm-77.4 32 16.8 51.6-43.9-31.9H360l-43.9 31.9 16.8-51.6zM350 245.4l16.8 51.6-43.9-31.9h54.3L333.3 297l16.7-51.6zm-71.8-56.2 16.8 51.6-44-31.8h54.3l-43.9 31.9 16.8-51.7zm0 75.3 16.8 51.6-44-31.9h54.3l-43.9 31.9 16.8-51.6z",
		fill: "#FFDA44"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var TW = function TW(_ref240) {
	var title = _ref240.title, rest = _objectWithoutProperties(_ref240, _excluded240);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 85.337h256V256H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#0052B4",
		cx: 128,
		cy: 170.674,
		r: 29.006
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
	}));
};
var TZ = function TZ(_ref241) {
	var title = _ref241.title, rest = _objectWithoutProperties(_ref241, _excluded241);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M0 426.663V85.337h512"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z" }));
};
var UA = function UA(_ref242) {
	var title = _ref242.title, rest = _objectWithoutProperties(_ref242, _excluded242);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 85.337h512V256H0z"
	}));
};
var UG = function UG(_ref243) {
	var title = _ref243.title, rest = _objectWithoutProperties(_ref243, _excluded243);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 341.3"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#232323",
		d: "M0 0h512v341.3H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 56.9h512v56.9H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D32300",
		d: "M0 113.8h512v56.9H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 227.6h512v56.9H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D32300",
		d: "M0 284.4h512v56.9H0z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 256,
		cy: 170.7,
		r: 80.7
	}), /*#__PURE__*/ React.createElement("path", { d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z" }));
};
var UM = function UM(_ref244) {
	var title = _ref244.title, rest = _objectWithoutProperties(_ref244, _excluded244);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#2E52B2",
		d: "M0 0h256.5v184.1H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
		fill: "#FFF"
	}));
};
var US = function US(_ref245) {
	var title = _ref245.title, rest = _objectWithoutProperties(_ref245, _excluded245);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#2E52B2",
		d: "M0 0h256.5v184.1H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
		fill: "#FFF"
	}));
};
var UY = function UY(_ref246) {
	var title = _ref246.title, rest = _objectWithoutProperties(_ref246, _excluded246);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
		fill: "#0038a8"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h256.5v190H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FED443",
		d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
	}));
};
var UZ = function UZ(_ref247) {
	var title = _ref247.title, rest = _objectWithoutProperties(_ref247, _excluded247);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#3081f7",
		d: "M0 0h513v108H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ee162e",
		d: "M0 108h513v9H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 117h513v108H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ee162e",
		d: "M0 225h513v9H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#308738",
		d: "M0 233h513v108H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M53.5 54c0-23.1 16.4-35 34.3-38.9-2.7-.6-5.6-.9-8.5-.9-22 0-39.8 17.8-39.8 39.8s17.8 39.8 39.8 39.8c2.9 0 5.8-.3 8.5-.9C69.9 89 53.5 77.1 53.5 54zm57.9 21.3 1.8 5.9h6.2l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.9h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.9h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm27.9 0 1.9 5.9h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.9h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm-83.5-28.9 1.9 5.8h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.8h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm27.9 0 1.9 5.8h6.1l-5 3.6 1.9 5.8-4.9-3.6-5 3.6 1.9-5.8-4.9-3.6h6.1zm27.8 0 1.9 5.8h6.1l-4.9 3.6 1.9 5.8-5-3.6-4.9 3.6 1.9-5.8-5-3.6h6.1zm-55.7-29 1.9 5.8h6.1l-4.9 3.6 1.9 5.9-5-3.6-4.9 3.6 1.9-5.9-5-3.6h6.1zm27.9 0 1.9 5.8h6.1l-5 3.6 1.9 5.9-4.9-3.6-5 3.6 1.9-5.9-4.9-3.6h6.1zm27.8 0 1.9 5.8h6.1l-4.9 3.6 1.9 5.9-5-3.6-4.9 3.6 1.9-5.9-5-3.6h6.1z",
		fill: "#FFF"
	}));
};
var VA = function VA(_ref248) {
	var title = _ref248.title, rest = _objectWithoutProperties(_ref248, _excluded248);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.331h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M256 85.331h256v341.337H256z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ACABB1",
		d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
	}));
};
var VC = function VC(_ref249) {
	var title = _ref249.title, rest = _objectWithoutProperties(_ref249, _excluded249);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#338AF3",
		d: "M0 85.331h170.663v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
		fill: "#6DA544"
	}));
};
var VE = function VE(_ref250) {
	var title = _ref250.title, rest = _objectWithoutProperties(_ref250, _excluded250);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 22.5 15"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFCE00",
		d: "M0 0h22.5v5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#203899",
		d: "M0 5h22.5v5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D82B2B",
		d: "M0 10h22.5v5H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
	}));
};
var VG = function VG(_ref251) {
	var title = _ref251.title, rest = _objectWithoutProperties(_ref251, _excluded251);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffc72c",
		d: "m384.8 174.7-46.2 46.2c8.7 16.7 26.1 28.1 46.2 28.1s37.6-11.4 46.2-28.1l-46.2-46.2z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#006129",
		stroke: "#fff",
		strokeWidth: 3,
		d: "M332.7 93v81.8c0 39.8 52 52 52 52s52-12.2 52-52V93h-104z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M373.6 130.1h22.3v59.5h-22.3z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#9c4c00",
		cx: 384.8,
		cy: 130.1,
		r: 11.2
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M347.6 107.8h14.9v14.9h-14.9zm0 33.5h14.9v14.9h-14.9zm0 33.4h14.9v14.9h-14.9zm59.5-66.9H422v14.9h-14.9zm0 33.5H422v14.9h-14.9zm0 33.4H422v14.9h-14.9z",
		fill: "#ffc72c"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#012169",
		d: "M0 0h256.5v171H0z"
	}), /*#__PURE__*/ React.createElement("g", { fill: "#FFF" }, /*#__PURE__*/ React.createElement("path", { d: "M256.5 0v30.6l-45.3 25.2h45.3v59.4h-59.2l59.2 32.9V171h-26.7l-73.7-40.9V171h-55.7v-48.7L12.8 171H0v-30.6l45.3-25.2H0V55.8h59.2L0 22.9V0h26.7l73.7 40.9V0h55.7v48.7L243.7 0z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-55.7-59.4L0 0v15.8l72 40z" })), /*#__PURE__*/ React.createElement("g", { fill: "#D80027" }, /*#__PURE__*/ React.createElement("path", { d: "M144.3 0h-32.1v69.5H0v32h112.2V171h32.1v-69.5h112.2v-32H144.3z" }), /*#__PURE__*/ React.createElement("path", { d: "M156.1 115.2 256.5 171v-15.8l-72-40zm-84.1 0-72 40V171l100.4-55.8zm28.4-59.4L0 0v15.8l72 40zm84.1 0 72-40V0L156.1 55.8z" })));
};
var VI = function VI(_ref252) {
	var title = _ref252.title, rest = _objectWithoutProperties(_ref252, _excluded252);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 341.3"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h512v341.3H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1583C4",
		d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1583C4",
		d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1583C4",
		d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#409347",
		d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
	}), /*#__PURE__*/ React.createElement("g", {
		fill: "#FFD836",
		stroke: "#231F20",
		strokeMiterlimit: 10
	}, /*#__PURE__*/ React.createElement("path", { d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z" }), /*#__PURE__*/ React.createElement("path", { d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z" })), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		stroke: "#231F20",
		strokeMiterlimit: 10,
		d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M201.3 111.8h119.4v37.9H201.3z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#1583C4",
		d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
	}));
};
var VN = function VN(_ref253) {
	var title = _ref253.title, rest = _objectWithoutProperties(_ref253, _excluded253);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M196.641 85.337H0v341.326h512V85.337z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
	}));
};
var VU = function VU(_ref254) {
	var title = _ref254.title, rest = _objectWithoutProperties(_ref254, _excluded254);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 85.337h512v341.326H0z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#6DA544",
		d: "M512 256v170.663H0L215.185 256z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M512 85.337V256H215.185L0 85.337z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z" }), /*#__PURE__*/ React.createElement("g", { fill: "#FFDA44" }, /*#__PURE__*/ React.createElement("path", { d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z" }), /*#__PURE__*/ React.createElement("path", { d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z" })));
};
var WF = function WF(_ref255) {
	var title = _ref255.title, rest = _objectWithoutProperties(_ref255, _excluded255);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 150 100"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80B30",
		d: "M0 0h150v100H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#00318A",
		d: "M0 0h20v44.33H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M20 0h20v44.33H20z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "none",
		stroke: "#FFF",
		strokeWidth: 3,
		d: "M0 44.33h62.75V0"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
	}));
};
var WS = function WS(_ref256) {
	var title = _ref256.title, rest = _objectWithoutProperties(_ref256, _excluded256);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 85.331h256v170.663H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
		fill: "#FFF"
	}));
};
var XA = function XA(_ref257) {
	var title = _ref257.title, rest = _objectWithoutProperties(_ref257, _excluded257);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 513 342"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h513v342H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h513v48.8H0zm0 97.5h513v48.8H0zM0 195h513v48.8H0zm0 97.6h513v48.8H0z",
		fill: "#6DA544"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 0h256.5v146.3H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "m116.9 114.4-7.5-14.8V69.9L128 59l18.6 10.9v22.3l7.4-7.4 4.2 3-4.2 11.8-14.9 14.8z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 82,
		cy: 82.8,
		r: 5.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 90.8,
		cy: 61.7,
		r: 5.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 106.6,
		cy: 46.2,
		r: 5.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 128,
		cy: 40.8,
		r: 5.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 149.4,
		cy: 46.2,
		r: 5.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 165.2,
		cy: 61.7,
		r: 5.4
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FFF",
		cx: 174,
		cy: 82.8,
		r: 5.4
	}));
};
var XC = function XC(_ref258) {
	var title = _ref258.title, rest = _objectWithoutProperties(_ref258, _excluded258);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 900 600"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		d: "M0 0h900v600H0z",
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#e30a17",
		cx: 300,
		cy: 300,
		r: 150
	}), /*#__PURE__*/ React.createElement("circle", {
		cx: 337.5,
		cy: 300,
		r: 120,
		fill: "#fff"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#e30a17",
		d: "M0 60h900v60H0zm0 420h900v60H0zm417.5-180 135.676-44.084-83.852 115.413V228.671l83.852 115.413z"
	}));
};
var XK = function XK(_ref259) {
	var title = _ref259.title, rest = _objectWithoutProperties(_ref259, _excluded259);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 341.33"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#0052B4",
		d: "M0 0h512v341.34H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
		fill: "#FFF"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
	}));
};
var XO = function XO(_ref260) {
	var title = _ref260.title, rest = _objectWithoutProperties(_ref260, _excluded260);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 450 300"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h450v300H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "red",
		d: "M0 100h450v200H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDF00",
		d: "M0 200h450v100H0z"
	}));
};
var YE = function YE(_ref261) {
	var title = _ref261.title, rest = _objectWithoutProperties(_ref261, _excluded261);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M0 85.337h512v113.775H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M0 312.888h512v113.775H0z" }));
};
var YT = function YT(_ref262) {
	var title = _ref262.title, rest = _objectWithoutProperties(_ref262, _excluded262);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 90 60"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 0h90v60H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		stroke: "#7f7f7f",
		strokeWidth: .25,
		fill: "#ABABAB",
		d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#DE393A",
		d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#3951A3",
		d: "M31 13.1h28v15.7H31z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FEE05F",
		cx: 39.1,
		cy: 36.5,
		r: 3
	}), /*#__PURE__*/ React.createElement("circle", {
		fill: "#FEE05F",
		cx: 50.9,
		cy: 36.5,
		r: 3
	}));
};
var ZA = function ZA(_ref263) {
	var title = _ref263.title, rest = _objectWithoutProperties(_ref263, _excluded263);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M0 85.337h512v341.326H0z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M114.024 256.001 0 141.926v228.17z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#ffb915",
		d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#007847",
		d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#000c8a",
		d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#e1392d",
		d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
	}));
};
var ZM = function ZM(_ref264) {
	var title = _ref264.title, rest = _objectWithoutProperties(_ref264, _excluded264);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", {
		fill: "#496E2D",
		d: "M0 85.331h512v341.337H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF9811",
		d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "M341.337 255.994h56.888v170.663h-56.888z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FF9811",
		d: "M455.112 255.994H512v170.663h-56.888z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M398.225 255.994h56.888v170.663h-56.888z" }));
};
var ZW = function ZW(_ref265) {
	var title = _ref265.title, rest = _objectWithoutProperties(_ref265, _excluded265);
	return /*#__PURE__*/ React.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 85.333 512 341.333"
	}, rest), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("path", { d: "M0 85.333h512V426.67H0z" }), /*#__PURE__*/ React.createElement("path", {
		d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
		fill: "#FFDA44"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#057f44",
		d: "M0 85.333h512v48.868H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
		fill: "#D80027"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#057f44",
		d: "M0 378.542h512v48.128H0z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFF",
		d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
	}), /*#__PURE__*/ React.createElement("path", { d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z" }), /*#__PURE__*/ React.createElement("path", {
		fill: "#D80027",
		d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
	}), /*#__PURE__*/ React.createElement("path", {
		fill: "#FFDA44",
		d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
	}));
};
var _3x2_default = {
	AC,
	AD,
	AE,
	AF,
	AG,
	AI,
	AL,
	AM,
	AO,
	AQ,
	AR,
	AS,
	AT,
	AU,
	AW,
	AX,
	AZ,
	BA,
	BB,
	BD,
	BE,
	BF,
	BG,
	BH,
	BI,
	BJ,
	BL,
	BM,
	BN,
	BO,
	BQ_BO,
	BQ_SA,
	BQ_SE,
	BQ,
	BR,
	BS,
	BT,
	BV,
	BW,
	BY,
	BZ,
	CA,
	CC,
	CD,
	CF,
	CG,
	CH,
	CI,
	CK,
	CL,
	CM,
	CN,
	CO,
	CR,
	CU,
	CV,
	CW,
	CX,
	CY,
	CZ,
	DE,
	DJ,
	DK,
	DM,
	DO,
	DZ,
	EC,
	EE,
	EG,
	EH,
	ER,
	ES_CT,
	ES,
	ET,
	EU,
	FI,
	FJ,
	FK,
	FM,
	FO,
	FR,
	GA,
	GB_ENG,
	GB_NIR,
	GB_SCT,
	GB_WLS,
	GB,
	GD,
	GE,
	GF,
	GG,
	GH,
	GI,
	GL,
	GM,
	GN,
	GP,
	GQ,
	GR,
	GS,
	GT,
	GU,
	GW,
	GY,
	HK,
	HM,
	HN,
	HR,
	HT,
	HU,
	IC,
	ID,
	IE,
	IL,
	IM,
	IN,
	IO,
	IQ,
	IR,
	IS,
	IT,
	JE,
	JM,
	JO,
	JP,
	KE,
	KG,
	KH,
	KI,
	KM,
	KN,
	KP,
	KR,
	KW,
	KY,
	KZ,
	LA,
	LB,
	LC,
	LI,
	LK,
	LR,
	LS,
	LT,
	LU,
	LV,
	LY,
	MA,
	MC,
	MD,
	ME,
	MF,
	MG,
	MH,
	MK,
	ML,
	MM,
	MN,
	MO,
	MP,
	MQ,
	MR,
	MS,
	MT,
	MU,
	MV,
	MW,
	MX,
	MY,
	MZ,
	NA,
	NC,
	NE,
	NF,
	NG,
	NI,
	NL,
	NO,
	NP,
	NR,
	NU,
	NZ,
	OM,
	PA,
	PE,
	PF,
	PG,
	PH,
	PK,
	PL,
	PM,
	PN,
	PR,
	PS,
	PT,
	PW,
	PY,
	QA,
	RE,
	RO,
	RS,
	RU,
	RW,
	SA,
	SB,
	SC,
	SD,
	SE,
	SG,
	SH,
	SI,
	SJ,
	SK,
	SL,
	SM,
	SN,
	SO,
	SR,
	SS,
	ST,
	SV,
	SX,
	SY,
	SZ,
	TA,
	TC,
	TD,
	TF,
	TG,
	TH,
	TJ,
	TK,
	TL,
	TM,
	TN,
	TO,
	TR,
	TT,
	TV,
	TW,
	TZ,
	UA,
	UG,
	UM,
	US,
	UY,
	UZ,
	VA,
	VC,
	VE,
	VG,
	VI,
	VN,
	VU,
	WF,
	WS,
	XA,
	XC,
	XK,
	XO,
	YE,
	YT,
	ZA,
	ZM,
	ZW
};
//#endregion
//#region src/aml-screening/components/CountryFlags.tsx
var flagComponents = /* @__PURE__ */ __exportAll({
	AC: () => AC,
	AD: () => AD,
	AE: () => AE,
	AF: () => AF,
	AG: () => AG,
	AI: () => AI,
	AL: () => AL,
	AM: () => AM,
	AO: () => AO,
	AQ: () => AQ,
	AR: () => AR,
	AS: () => AS,
	AT: () => AT,
	AU: () => AU,
	AW: () => AW,
	AX: () => AX,
	AZ: () => AZ,
	BA: () => BA,
	BB: () => BB,
	BD: () => BD,
	BE: () => BE,
	BF: () => BF,
	BG: () => BG,
	BH: () => BH,
	BI: () => BI,
	BJ: () => BJ,
	BL: () => BL,
	BM: () => BM,
	BN: () => BN,
	BO: () => BO,
	BQ: () => BQ,
	BQ_BO: () => BQ_BO,
	BQ_SA: () => BQ_SA,
	BQ_SE: () => BQ_SE,
	BR: () => BR,
	BS: () => BS,
	BT: () => BT,
	BV: () => BV,
	BW: () => BW,
	BY: () => BY,
	BZ: () => BZ,
	CA: () => CA,
	CC: () => CC,
	CD: () => CD,
	CF: () => CF,
	CG: () => CG,
	CH: () => CH,
	CI: () => CI,
	CK: () => CK,
	CL: () => CL,
	CM: () => CM,
	CN: () => CN,
	CO: () => CO,
	CR: () => CR,
	CU: () => CU,
	CV: () => CV,
	CW: () => CW,
	CX: () => CX,
	CY: () => CY,
	CZ: () => CZ,
	DE: () => DE,
	DJ: () => DJ,
	DK: () => DK,
	DM: () => DM,
	DO: () => DO,
	DZ: () => DZ,
	EC: () => EC,
	EE: () => EE,
	EG: () => EG,
	EH: () => EH,
	ER: () => ER,
	ES: () => ES,
	ES_CT: () => ES_CT,
	ET: () => ET,
	EU: () => EU,
	FI: () => FI,
	FJ: () => FJ,
	FK: () => FK,
	FM: () => FM,
	FO: () => FO,
	FR: () => FR,
	GA: () => GA,
	GB: () => GB,
	GB_ENG: () => GB_ENG,
	GB_NIR: () => GB_NIR,
	GB_SCT: () => GB_SCT,
	GB_WLS: () => GB_WLS,
	GD: () => GD,
	GE: () => GE,
	GF: () => GF,
	GG: () => GG,
	GH: () => GH,
	GI: () => GI,
	GL: () => GL,
	GM: () => GM,
	GN: () => GN,
	GP: () => GP,
	GQ: () => GQ,
	GR: () => GR,
	GS: () => GS,
	GT: () => GT,
	GU: () => GU,
	GW: () => GW,
	GY: () => GY,
	HK: () => HK,
	HM: () => HM,
	HN: () => HN,
	HR: () => HR,
	HT: () => HT,
	HU: () => HU,
	IC: () => IC,
	ID: () => ID,
	IE: () => IE,
	IL: () => IL,
	IM: () => IM,
	IN: () => IN,
	IO: () => IO,
	IQ: () => IQ,
	IR: () => IR,
	IS: () => IS,
	IT: () => IT,
	JE: () => JE,
	JM: () => JM,
	JO: () => JO,
	JP: () => JP,
	KE: () => KE,
	KG: () => KG,
	KH: () => KH,
	KI: () => KI,
	KM: () => KM,
	KN: () => KN,
	KP: () => KP,
	KR: () => KR,
	KW: () => KW,
	KY: () => KY,
	KZ: () => KZ,
	LA: () => LA,
	LB: () => LB,
	LC: () => LC,
	LI: () => LI,
	LK: () => LK,
	LR: () => LR,
	LS: () => LS,
	LT: () => LT,
	LU: () => LU,
	LV: () => LV,
	LY: () => LY,
	MA: () => MA,
	MC: () => MC,
	MD: () => MD,
	ME: () => ME,
	MF: () => MF,
	MG: () => MG,
	MH: () => MH,
	MK: () => MK,
	ML: () => ML,
	MM: () => MM,
	MN: () => MN,
	MO: () => MO,
	MP: () => MP,
	MQ: () => MQ,
	MR: () => MR,
	MS: () => MS,
	MT: () => MT,
	MU: () => MU,
	MV: () => MV,
	MW: () => MW,
	MX: () => MX,
	MY: () => MY,
	MZ: () => MZ,
	NA: () => NA,
	NC: () => NC,
	NE: () => NE,
	NF: () => NF,
	NG: () => NG,
	NI: () => NI,
	NL: () => NL,
	NO: () => NO,
	NP: () => NP,
	NR: () => NR,
	NU: () => NU,
	NZ: () => NZ,
	OM: () => OM,
	PA: () => PA,
	PE: () => PE,
	PF: () => PF,
	PG: () => PG,
	PH: () => PH,
	PK: () => PK,
	PL: () => PL,
	PM: () => PM,
	PN: () => PN,
	PR: () => PR,
	PS: () => PS,
	PT: () => PT,
	PW: () => PW,
	PY: () => PY,
	QA: () => QA,
	RE: () => RE,
	RO: () => RO,
	RS: () => RS,
	RU: () => RU,
	RW: () => RW,
	SA: () => SA,
	SB: () => SB,
	SC: () => SC,
	SD: () => SD,
	SE: () => SE,
	SG: () => SG,
	SH: () => SH,
	SI: () => SI,
	SJ: () => SJ,
	SK: () => SK,
	SL: () => SL,
	SM: () => SM,
	SN: () => SN,
	SO: () => SO,
	SR: () => SR,
	SS: () => SS,
	ST: () => ST,
	SV: () => SV,
	SX: () => SX,
	SY: () => SY,
	SZ: () => SZ,
	TA: () => TA,
	TC: () => TC,
	TD: () => TD,
	TF: () => TF,
	TG: () => TG,
	TH: () => TH,
	TJ: () => TJ,
	TK: () => TK,
	TL: () => TL,
	TM: () => TM,
	TN: () => TN,
	TO: () => TO,
	TR: () => TR,
	TT: () => TT,
	TV: () => TV,
	TW: () => TW,
	TZ: () => TZ,
	UA: () => UA,
	UG: () => UG,
	UM: () => UM,
	US: () => US,
	UY: () => UY,
	UZ: () => UZ,
	VA: () => VA,
	VC: () => VC,
	VE: () => VE,
	VG: () => VG,
	VI: () => VI,
	VN: () => VN,
	VU: () => VU,
	WF: () => WF,
	WS: () => WS,
	XA: () => XA,
	XC: () => XC,
	XK: () => XK,
	XO: () => XO,
	YE: () => YE,
	YT: () => YT,
	ZA: () => ZA,
	ZM: () => ZM,
	ZW: () => ZW,
	default: () => _3x2_default
});
var CountryFlags = ({ countries }) => {
	const { t } = useTranslation();
	const codes = countries.map((code) => code.trim().toUpperCase()).filter((code) => hasFlag(code));
	if (codes.length === 0) return null;
	return /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.flagRow,
		"aria-label": t("aml_screening_modal.countries_label"),
		children: codes.map((code, index) => {
			const Flag = flagComponents[code];
			return /* @__PURE__ */ jsx(Flag, {
				className: AmlScreeningRoot_module_default.matchFlag,
				title: code
			}, `${code}-${index}`);
		})
	});
};
//#endregion
//#region src/aml-screening/components/AmlMatchCard.tsx
var RESOLUTION_BADGE_VARIANT = {
	[MatchResolution.TruePositive]: "success",
	[MatchResolution.Open]: "danger",
	[MatchResolution.FalsePositive]: "neutral"
};
var RESOLUTION_ACTIONS = [
	{
		resolution: MatchResolution.Open,
		labelKey: "aml_screening_modal.action_open_match",
		icon: OpenMatchIcon
	},
	{
		resolution: MatchResolution.FalsePositive,
		labelKey: "aml_screening_modal.action_false_positive",
		icon: FalsePositiveIcon
	},
	{
		resolution: MatchResolution.TruePositive,
		labelKey: "aml_screening_modal.action_match_profile",
		icon: MatchProfileIcon
	}
];
var RESOLUTION_BADGE_KEY = {
	[MatchResolution.TruePositive]: "aml_screening_modal.badge_match",
	[MatchResolution.Open]: "aml_screening_modal.badge_open",
	[MatchResolution.FalsePositive]: "aml_screening_modal.badge_false_positive"
};
var AmlMatchCard = ({ match, selected, onToggleSelected, onResolve, onViewProfile }) => {
	var _match$gender, _match$dateOfBirth;
	const { t } = useTranslation();
	const badgeVariant = RESOLUTION_BADGE_VARIANT[match.resolution];
	const actions = RESOLUTION_ACTIONS.filter((action) => action.resolution !== match.resolution);
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.card,
		children: [/* @__PURE__ */ jsx("input", {
			type: "checkbox",
			className: AmlScreeningRoot_module_default.cardCheckbox,
			checked: selected,
			onChange: onToggleSelected,
			"aria-label": match.entityName
		}), /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.cardBody,
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.badgeRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: `${AmlScreeningRoot_module_default.badge} ${AmlScreeningRoot_module_default[`badge--${badgeVariant}`]}`,
						children: t(RESOLUTION_BADGE_KEY[match.resolution])
					}), /* @__PURE__ */ jsx("span", {
						className: `${AmlScreeningRoot_module_default.badge} ${AmlScreeningRoot_module_default["badge--success"]}`,
						children: t("aml_screening_modal.match_score", { score: match.matchScore })
					})]
				}),
				/* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.cardMain,
					children: [
						/* @__PURE__ */ jsx(Avatar, { photoUrl: match.photoUrls[0] }),
						/* @__PURE__ */ jsxs("div", {
							className: `${AmlScreeningRoot_module_default.fieldGroup} ${AmlScreeningRoot_module_default["fieldGroup--grow"]}`,
							children: [/* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.entityName,
								children: match.entityName
							}), /* @__PURE__ */ jsx(CountryFlags, { countries: match.countries })]
						}),
						/* @__PURE__ */ jsxs("div", {
							className: AmlScreeningRoot_module_default.fieldGroup,
							children: [/* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.fieldLabel,
								children: t("aml_screening_modal.gender_label")
							}), /* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.fieldValue,
								children: (_match$gender = match.gender) !== null && _match$gender !== void 0 ? _match$gender : "-"
							})]
						}),
						/* @__PURE__ */ jsxs("div", {
							className: AmlScreeningRoot_module_default.fieldGroup,
							children: [/* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.fieldLabel,
								children: t("aml_screening_modal.date_of_birth_label")
							}), /* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.fieldValue,
								children: (_match$dateOfBirth = match.dateOfBirth) !== null && _match$dateOfBirth !== void 0 ? _match$dateOfBirth : "-"
							})]
						}),
						/* @__PURE__ */ jsxs("div", {
							className: `${AmlScreeningRoot_module_default.fieldGroup} ${AmlScreeningRoot_module_default["fieldGroup--grow"]}`,
							children: [/* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.fieldLabel,
								children: t("aml_screening_modal.datasets_label")
							}), match.sanctionTypes.length > 0 ? /* @__PURE__ */ jsx("div", {
								className: AmlScreeningRoot_module_default.badgeRow,
								children: match.sanctionTypes.map((sanctionType, index) => /* @__PURE__ */ jsx("span", {
									className: `${AmlScreeningRoot_module_default.badge} ${AmlScreeningRoot_module_default["badge--danger"]}`,
									children: sanctionType
								}, `${sanctionType}-${index}`))
							}) : /* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.fieldValue,
								children: "-"
							})]
						})
					]
				}),
				/* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.cardActions,
					children: [/* @__PURE__ */ jsx("div", {
						className: AmlScreeningRoot_module_default.secondaryActions,
						children: actions.map((action) => {
							const Icon = action.icon;
							return /* @__PURE__ */ jsxs("button", {
								type: "button",
								className: AmlScreeningRoot_module_default.secondaryButton,
								onClick: () => onResolve(action.resolution),
								children: [/* @__PURE__ */ jsx(Icon, { size: 20 }), t(action.labelKey)]
							}, action.resolution);
						})
					}), /* @__PURE__ */ jsx("button", {
						type: "button",
						className: AmlScreeningRoot_module_default.primaryButton,
						onClick: onViewProfile,
						children: t("aml_screening_modal.action_view_profile")
					})]
				})
			]
		})]
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/AmlEvidenceCard.tsx
var CREDIBILITY_KEYS = new Map([
	["Low", "aml_screening_modal.credibility_low"],
	["Medium", "aml_screening_modal.credibility_medium"],
	["High", "aml_screening_modal.credibility_high"]
]);
var EMPTY = "-";
var AmlEvidenceCard = ({ evidence }) => {
	var _evidence$credibility;
	const { t } = useTranslation();
	const [summaryExpanded, setSummaryExpanded] = useState(false);
	const credibilityKey = evidence.credibility ? CREDIBILITY_KEYS.get(evidence.credibility) : void 0;
	const credibilityText = credibilityKey ? t(credibilityKey) : (_evidence$credibility = evidence.credibility) !== null && _evidence$credibility !== void 0 ? _evidence$credibility : EMPTY;
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.evidenceCard,
		children: [
			/* @__PURE__ */ jsx("span", {
				className: AmlScreeningRoot_module_default.evidenceCardTitle,
				children: evidence.title || t("aml_screening_modal.evidence_no_title")
			}),
			evidence.summary && /* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.evidenceSummaryBlock,
				children: [/* @__PURE__ */ jsx("p", {
					className: `${AmlScreeningRoot_module_default.evidenceSummary} ${summaryExpanded ? "" : AmlScreeningRoot_module_default["evidenceSummary--clamped"]}`,
					children: evidence.summary
				}), /* @__PURE__ */ jsx("button", {
					type: "button",
					className: AmlScreeningRoot_module_default.evidenceReadMore,
					onClick: () => setSummaryExpanded((expanded) => !expanded),
					children: summaryExpanded ? t("aml_screening_modal.evidence_read_less") : t("aml_screening_modal.evidence_read_more")
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.evidenceRow,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowLabel,
					children: t("aml_screening_modal.evidence_sources_label")
				}), /* @__PURE__ */ jsx("div", {
					className: AmlScreeningRoot_module_default.evidenceRowValue,
					children: evidence.sources.length > 0 ? /* @__PURE__ */ jsx("div", {
						className: AmlScreeningRoot_module_default.badgeRow,
						children: evidence.sources.map((source, index) => /* @__PURE__ */ jsx("span", {
							className: `${AmlScreeningRoot_module_default.badge} ${AmlScreeningRoot_module_default["badge--danger"]}`,
							children: source
						}, `${source}-${index}`))
					}) : EMPTY
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.evidenceRow,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowLabel,
					children: t("aml_screening_modal.evidence_keywords_label")
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowValue,
					children: evidence.keywords || EMPTY
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.evidenceRow,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowLabel,
					children: t("aml_screening_modal.evidence_credibility_label")
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowValue,
					children: credibilityText
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: `${AmlScreeningRoot_module_default.evidenceRow} ${AmlScreeningRoot_module_default.evidenceRowCenter}`,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowLabel,
					children: t("aml_screening_modal.evidence_link_label")
				}), /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.evidenceLinkValue,
					children: [evidence.originalUrl ? /* @__PURE__ */ jsx("a", {
						className: AmlScreeningRoot_module_default.evidenceLinkText,
						href: evidence.originalUrl,
						target: "_blank",
						rel: "noopener noreferrer",
						children: evidence.originalUrl
					}) : /* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.evidenceRowValue,
						children: EMPTY
					}), /* @__PURE__ */ jsxs("span", {
						className: AmlScreeningRoot_module_default.evidenceIconButtons,
						children: [evidence.assetUrl && /* @__PURE__ */ jsx("a", {
							className: AmlScreeningRoot_module_default.evidenceIconButton,
							href: evidence.assetUrl,
							target: "_blank",
							rel: "noopener noreferrer",
							"aria-label": t("aml_screening_modal.evidence_download"),
							children: /* @__PURE__ */ jsx(DownloadIcon, {})
						}), evidence.originalUrl && /* @__PURE__ */ jsx("a", {
							className: AmlScreeningRoot_module_default.evidenceIconButton,
							href: evidence.originalUrl,
							target: "_blank",
							rel: "noopener noreferrer",
							"aria-label": t("aml_screening_modal.evidence_open_link"),
							children: /* @__PURE__ */ jsx(ExternalLinkIcon, {})
						})]
					})]
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.evidenceRow,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowLabel,
					children: t("aml_screening_modal.evidence_date_created_label")
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.evidenceRowValue,
					children: evidence.publicationDate || EMPTY
				})]
			})
		]
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/AmlEvidenceList.tsx
var AmlEvidenceList = ({ evidence }) => {
	const { t } = useTranslation();
	const [expanded, setExpanded] = useState(false);
	if (evidence.length === 0) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.evidenceList,
		children: [/* @__PURE__ */ jsxs("button", {
			type: "button",
			className: AmlScreeningRoot_module_default.evidenceToggle,
			onClick: () => setExpanded((open) => !open),
			"aria-expanded": expanded,
			children: [/* @__PURE__ */ jsx("span", { children: t("aml_screening_modal.evidence_label") }), /* @__PURE__ */ jsxs("span", {
				className: AmlScreeningRoot_module_default.evidenceCountPill,
				children: [evidence.length, /* @__PURE__ */ jsx(ChevronDownIcon, {
					size: 12,
					className: `${AmlScreeningRoot_module_default.evidenceChevron} ${expanded ? AmlScreeningRoot_module_default["evidenceChevron--open"] : ""}`
				})]
			})]
		}), expanded && /* @__PURE__ */ jsx("div", {
			className: AmlScreeningRoot_module_default.evidenceCards,
			children: evidence.map((item) => /* @__PURE__ */ jsx(AmlEvidenceCard, { evidence: item }, item.id))
		})]
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/detail-formatters.ts
var isNonEmptyValue = (value) => Boolean(value);
var formatRegulatoryEnforcementPeriod = (event, t) => {
	const period = event.period;
	if (!period) return;
	const parts = [
		period.years && t("aml_screening_modal.period_years", { n: period.years }),
		period.months && t("aml_screening_modal.period_months", { n: period.months }),
		period.days && t("aml_screening_modal.period_days", { n: period.days })
	].filter(isNonEmptyValue);
	return parts.length > 0 ? parts.join(" ") : void 0;
};
var formatRegulatoryEnforcementAmount = (event) => {
	if (event.amount == null) return;
	return event.currencyCode ? `${event.amount} ${event.currencyCode}` : `${event.amount}`;
};
//#endregion
//#region src/aml-screening/components/detail-tabs/AmlEventsRow.tsx
var AmlEventsRow = ({ events }) => {
	const { t } = useTranslation();
	if (events.length === 0) return null;
	const translate = (key, params) => t(key, params !== null && params !== void 0 ? params : {});
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.profileRow,
		children: [/* @__PURE__ */ jsx("span", {
			className: AmlScreeningRoot_module_default.profileLabel,
			children: t("aml_screening_modal.events_label")
		}), /* @__PURE__ */ jsx("div", {
			className: AmlScreeningRoot_module_default.profileValue,
			children: events.map((event, index) => {
				const header = [
					event.type,
					formatRegulatoryEnforcementAmount(event),
					formatRegulatoryEnforcementPeriod(event, translate)
				].filter(isNonEmptyValue).join(" · ");
				return /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.eventBlock,
					children: [header && /* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.eventType,
						children: header
					}), /* @__PURE__ */ jsx(AmlEvidenceList, { evidence: event.evidence })]
				}, index);
			})
		})]
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/EmptyTab.tsx
var EmptyTab = () => {
	const { t } = useTranslation();
	return /* @__PURE__ */ jsx("p", {
		className: AmlScreeningRoot_module_default.profileEmpty,
		children: t("aml_screening_modal.profile_no_tab_content")
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/AdverseMediaTabContent.tsx
var AdverseMediaTabContent = ({ match }) => {
	var _match$adverseMediaEn;
	const { t } = useTranslation();
	const entries = (_match$adverseMediaEn = match.adverseMediaEntries) !== null && _match$adverseMediaEn !== void 0 ? _match$adverseMediaEn : [];
	if (entries.length === 0) return /* @__PURE__ */ jsx(EmptyTab, {});
	return /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.profileSections,
		children: entries.map((entry, index) => /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.eventCategory,
			children: [/* @__PURE__ */ jsx("span", {
				className: AmlScreeningRoot_module_default.eventCategoryHeading,
				children: entry.category || t("aml_screening_modal.adverse_media_category_fallback")
			}), /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.card,
				children: /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileSection,
					children: [entry.subCategory && /* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.profileRow,
						children: [/* @__PURE__ */ jsx("span", {
							className: AmlScreeningRoot_module_default.profileLabel,
							children: t("aml_screening_modal.subcategory_label")
						}), /* @__PURE__ */ jsx("span", {
							className: AmlScreeningRoot_module_default.profileValue,
							children: entry.subCategory
						})]
					}), /* @__PURE__ */ jsx(AmlEventsRow, { events: entry.events })]
				})
			})]
		}, index))
	});
};
//#endregion
//#region src/aml-screening/components/AmlSegmentedControl.tsx
var AmlSegmentedControl = ({ segments, activeId, onChange, ariaLabel }) => /* @__PURE__ */ jsx("div", {
	className: AmlScreeningRoot_module_default.segmentedControl,
	role: "group",
	"aria-label": ariaLabel,
	children: segments.map((segment) => {
		const isActive = segment.id === activeId;
		return /* @__PURE__ */ jsxs("button", {
			type: "button",
			"aria-pressed": isActive,
			className: `${AmlScreeningRoot_module_default.segment} ${isActive ? AmlScreeningRoot_module_default["segment--active"] : ""}`,
			onClick: () => onChange(segment.id),
			children: [/* @__PURE__ */ jsx("span", { children: segment.label }), segment.count != null && /* @__PURE__ */ jsxs("span", {
				className: AmlScreeningRoot_module_default.segmentCount,
				children: [
					"(",
					segment.count,
					")"
				]
			})]
		}, segment.id);
	})
});
//#endregion
//#region src/aml-screening/components/detail-tabs/AssociationsTabContent.tsx
var AssociationsTabContent = ({ match }) => {
	var _match$associations$i, _match$associations, _match$associations$b, _match$associations2;
	const { t } = useTranslation();
	const individuals = (_match$associations$i = (_match$associations = match.associations) === null || _match$associations === void 0 ? void 0 : _match$associations.individuals) !== null && _match$associations$i !== void 0 ? _match$associations$i : [];
	const businesses = (_match$associations$b = (_match$associations2 = match.associations) === null || _match$associations2 === void 0 ? void 0 : _match$associations2.businesses) !== null && _match$associations$b !== void 0 ? _match$associations$b : [];
	const [segment, setSegment] = useState(() => individuals.length > 0 ? "individuals" : "businesses");
	if (individuals.length === 0 && businesses.length === 0) return /* @__PURE__ */ jsx(EmptyTab, {});
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(AmlSegmentedControl, {
		ariaLabel: t("aml_screening_modal.tab_associations"),
		activeId: segment,
		onChange: (id) => setSegment(id),
		segments: [{
			id: "individuals",
			label: t("aml_screening_modal.associations_individuals_heading"),
			count: individuals.length
		}, {
			id: "businesses",
			label: t("aml_screening_modal.associations_businesses_heading"),
			count: businesses.length
		}]
	}), segment === "individuals" ? /* @__PURE__ */ jsx(AssociationList, { rows: individuals.map((person) => ({
		name: person.name,
		relationship: person.relationship,
		ownershipPercentage: person.ownershipPercentage
	})) }) : /* @__PURE__ */ jsx(AssociationList, { rows: businesses.map((business) => ({
		name: business.name || t("aml_screening_modal.associations_business_fallback"),
		relationship: business.relationship,
		ownershipPercentage: business.ownershipPercentage
	})) })] });
};
var AssociationList = ({ rows }) => {
	const { t } = useTranslation();
	if (rows.length === 0) return /* @__PURE__ */ jsx(EmptyTab, {});
	return /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.profileSections,
		children: /* @__PURE__ */ jsx("div", {
			className: AmlScreeningRoot_module_default.card,
			children: /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.profileSection,
				children: rows.map((row, index) => /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileLabel,
						children: row.name
					}), /* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.profileValue,
						children: [row.relationship && /* @__PURE__ */ jsx("span", { children: row.relationship }), row.ownershipPercentage != null && /* @__PURE__ */ jsx("span", { children: t("aml_screening_modal.ownership_percentage_label", { percentage: row.ownershipPercentage }) })]
					})]
				}, index))
			})
		})
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/MainTabContent.tsx
var MainTabContent = ({ match }) => {
	const { t } = useTranslation();
	const profile = match.profile;
	if (!profile) return /* @__PURE__ */ jsx(EmptyTab, {});
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.profileSections,
		children: [
			/* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.card,
				children: /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileOverview,
					children: [/* @__PURE__ */ jsx(ProfilePhoto, { photoUrls: match.photoUrls }), /* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.profileSection,
						children: [
							profile.description && /* @__PURE__ */ jsxs("div", {
								className: AmlScreeningRoot_module_default.profileRow,
								children: [/* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileLabel,
									children: t("aml_screening_modal.profile_description_label")
								}), /* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileValue,
									children: profile.description
								})]
							}),
							profile.businessTypes && profile.businessTypes.length > 0 && /* @__PURE__ */ jsxs("div", {
								className: AmlScreeningRoot_module_default.profileRow,
								children: [/* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileLabel,
									children: t("aml_screening_modal.profile_business_types_label")
								}), /* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileValue,
									children: profile.businessTypes.join(", ")
								})]
							}),
							profile.activities && profile.activities.length > 0 && /* @__PURE__ */ jsxs("div", {
								className: AmlScreeningRoot_module_default.profileRow,
								children: [/* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileLabel,
									children: t("aml_screening_modal.profile_activities_label")
								}), /* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileValue,
									children: profile.activities.map((activity, index) => /* @__PURE__ */ jsx("span", { children: activity }, `${activity}-${index}`))
								})]
							}),
							profile.datasetLabels && profile.datasetLabels.length > 0 && /* @__PURE__ */ jsxs("div", {
								className: AmlScreeningRoot_module_default.profileRow,
								children: [/* @__PURE__ */ jsx("span", {
									className: AmlScreeningRoot_module_default.profileLabel,
									children: t("aml_screening_modal.datasets_label")
								}), /* @__PURE__ */ jsx("div", {
									className: AmlScreeningRoot_module_default.badgeRow,
									children: profile.datasetLabels.map((label, index) => /* @__PURE__ */ jsx("span", {
										className: `${AmlScreeningRoot_module_default.badge} ${AmlScreeningRoot_module_default["badge--danger"]}`,
										children: label
									}, `${label}-${index}`))
								})]
							})
						]
					})]
				})
			}),
			profile.notes && profile.notes.length > 0 && /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.card,
				children: /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileSection,
					children: [/* @__PURE__ */ jsx("p", {
						className: AmlScreeningRoot_module_default.profileSectionHeading,
						children: t("aml_screening_modal.profile_notes_heading")
					}), /* @__PURE__ */ jsx("ul", {
						className: AmlScreeningRoot_module_default.notesList,
						children: profile.notes.map((note, index) => /* @__PURE__ */ jsx("li", { children: note }, `${note}-${index}`))
					})]
				})
			}),
			/* @__PURE__ */ jsx(AdditionalInformationCard, { profile })
		]
	});
};
var ProfilePhoto = ({ photoUrls }) => {
	const { t } = useTranslation();
	const [index, setIndex] = useState(0);
	const total = photoUrls.length;
	const currentIndex = total > 0 ? Math.min(index, total - 1) : 0;
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.profilePhoto,
		children: [/* @__PURE__ */ jsx(Avatar, { photoUrl: photoUrls[currentIndex] }), total > 1 && /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.profilePhotoPager,
			children: [
				/* @__PURE__ */ jsx("button", {
					type: "button",
					className: AmlScreeningRoot_module_default.profilePhotoPagerButton,
					onClick: () => setIndex((current) => Math.max(0, current - 1)),
					disabled: currentIndex === 0,
					"aria-label": t("aml_screening_modal.profile_photo_previous"),
					children: /* @__PURE__ */ jsx(ChevronLeftIcon, { size: 16 })
				}),
				/* @__PURE__ */ jsx("span", { children: `${currentIndex + 1}/${total}` }),
				/* @__PURE__ */ jsx("button", {
					type: "button",
					className: AmlScreeningRoot_module_default.profilePhotoPagerButton,
					onClick: () => setIndex((current) => Math.min(total - 1, current + 1)),
					disabled: currentIndex === total - 1,
					"aria-label": t("aml_screening_modal.profile_photo_next"),
					children: /* @__PURE__ */ jsx(ChevronRightIcon, { size: 16 })
				})
			]
		})]
	});
};
var AdditionalInformationCard = ({ profile }) => {
	var _profile$aliases, _profile$addresses, _profile$contacts, _profile$identifiers;
	const { t } = useTranslation();
	const aliases = (_profile$aliases = profile.aliases) !== null && _profile$aliases !== void 0 ? _profile$aliases : [];
	const addresses = (_profile$addresses = profile.addresses) !== null && _profile$addresses !== void 0 ? _profile$addresses : [];
	const contacts = (_profile$contacts = profile.contacts) !== null && _profile$contacts !== void 0 ? _profile$contacts : [];
	const identifiers = (_profile$identifiers = profile.identifiers) !== null && _profile$identifiers !== void 0 ? _profile$identifiers : [];
	if (aliases.length === 0 && addresses.length === 0 && contacts.length === 0 && identifiers.length === 0) return null;
	return /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.card,
		children: /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.profileSection,
			children: [
				/* @__PURE__ */ jsx("p", {
					className: AmlScreeningRoot_module_default.profileSectionHeading,
					children: t("aml_screening_modal.profile_additional_information_heading")
				}),
				aliases.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileLabel,
						children: t("aml_screening_modal.profile_aliases_label")
					}), /* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileValue,
						children: aliases.join(", ")
					})]
				}),
				addresses.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileLabel,
						children: t("aml_screening_modal.profile_addresses_label")
					}), /* @__PURE__ */ jsx("div", {
						className: AmlScreeningRoot_module_default.profileValue,
						children: addresses.map((address, index) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("p", {
							className: AmlScreeningRoot_module_default.profileAddressLabel,
							children: address.label
						}), /* @__PURE__ */ jsx("span", { children: address.lines.join(" / ") })] }, `${address.label}-${index}`))
					})]
				}),
				contacts.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileLabel,
						children: t("aml_screening_modal.profile_contacts_label")
					}), /* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileValue,
						children: contacts.map((contact, index) => /* @__PURE__ */ jsxs("span", { children: [
							contact.label,
							": ",
							contact.value
						] }, `${contact.label}-${index}`))
					})]
				}),
				identifiers.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileLabel,
						children: t("aml_screening_modal.profile_identifiers_label")
					}), /* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileValue,
						children: identifiers.map((identifier, index) => /* @__PURE__ */ jsxs("span", { children: [
							identifier.label,
							": ",
							identifier.value
						] }, `${identifier.label}-${index}`))
					})]
				})
			]
		})
	});
};
//#endregion
//#region src/aml-screening/components/detail-tabs/OtherSourcesTabContent.tsx
var OtherSourcesTabContent = ({ match }) => {
	var _match$regulatoryEnfo;
	const { t } = useTranslation();
	const entries = (_match$regulatoryEnfo = match.regulatoryEnforcementEntries) !== null && _match$regulatoryEnfo !== void 0 ? _match$regulatoryEnfo : [];
	if (entries.length === 0) return /* @__PURE__ */ jsx(EmptyTab, {});
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(AmlSegmentedControl, {
		ariaLabel: t("aml_screening_modal.tab_other_sources"),
		activeId: "regulatoryEnforcement",
		onChange: () => void 0,
		segments: [{
			id: "regulatoryEnforcement",
			label: t("aml_screening_modal.other_sources_regulatory_enforcement_label")
		}]
	}), /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.profileSections,
		children: entries.map((entry, index) => /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.eventCategory,
			children: [/* @__PURE__ */ jsx("span", {
				className: AmlScreeningRoot_module_default.eventCategoryHeading,
				children: entry.category || t("aml_screening_modal.regulatory_enforcement_category_fallback")
			}), /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.card,
				children: /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileSection,
					children: [entry.subCategory && /* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.profileRow,
						children: [/* @__PURE__ */ jsx("span", {
							className: AmlScreeningRoot_module_default.profileLabel,
							children: t("aml_screening_modal.subcategory_label")
						}), /* @__PURE__ */ jsx("span", {
							className: AmlScreeningRoot_module_default.profileValue,
							children: entry.subCategory
						})]
					}), /* @__PURE__ */ jsx(AmlEventsRow, { events: entry.events })]
				})
			})]
		}, index))
	})] });
};
//#endregion
//#region src/aml-screening/components/detail-tabs/PepTabContent.tsx
var PepEntryRow = ({ entry }) => {
	var _entry$dateFrom, _entry$dateTo;
	const { t } = useTranslation();
	return /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.profileRow,
		children: [/* @__PURE__ */ jsx("span", {
			className: AmlScreeningRoot_module_default.profileLabel,
			children: entry.position || t("aml_screening_modal.pep_position_fallback")
		}), /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.profileValue,
			children: [
				entry.segment && /* @__PURE__ */ jsx("span", { children: entry.segment }),
				entry.countryCode && /* @__PURE__ */ jsxs("span", { children: [
					t("aml_screening_modal.country_label"),
					": ",
					entry.countryCode
				] }),
				(entry.dateFrom || entry.dateTo) && /* @__PURE__ */ jsxs("span", { children: [
					(_entry$dateFrom = entry.dateFrom) !== null && _entry$dateFrom !== void 0 ? _entry$dateFrom : "—",
					" –",
					" ",
					(_entry$dateTo = entry.dateTo) !== null && _entry$dateTo !== void 0 ? _entry$dateTo : t("aml_screening_modal.pep_date_to_present")
				] })
			]
		})]
	});
};
var PepTabContent = ({ match }) => {
	var _pep$current, _pep$former;
	const { t } = useTranslation();
	const pep = match.pepInformation;
	const current = (_pep$current = pep === null || pep === void 0 ? void 0 : pep.current) !== null && _pep$current !== void 0 ? _pep$current : [];
	const former = (_pep$former = pep === null || pep === void 0 ? void 0 : pep.former) !== null && _pep$former !== void 0 ? _pep$former : [];
	const [segment, setSegment] = useState(() => current.length > 0 ? "current" : "former");
	if (!(pep === null || pep === void 0 ? void 0 : pep.pepTier) && current.length === 0 && former.length === 0) return /* @__PURE__ */ jsx(EmptyTab, {});
	const hasPositions = current.length > 0 || former.length > 0;
	const entries = segment === "current" ? current : former;
	return /* @__PURE__ */ jsxs(Fragment, { children: [hasPositions && /* @__PURE__ */ jsx(AmlSegmentedControl, {
		ariaLabel: t("aml_screening_modal.tab_pep"),
		activeId: segment,
		onChange: (id) => setSegment(id),
		segments: [{
			id: "current",
			label: t("aml_screening_modal.segment_current"),
			count: current.length
		}, {
			id: "former",
			label: t("aml_screening_modal.segment_former"),
			count: former.length
		}]
	}), /* @__PURE__ */ jsxs("div", {
		className: AmlScreeningRoot_module_default.profileSections,
		children: [(pep === null || pep === void 0 ? void 0 : pep.pepTier) && /* @__PURE__ */ jsx("div", {
			className: AmlScreeningRoot_module_default.card,
			children: /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.profileSection,
				children: /* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.profileRow,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileLabel,
						children: t("aml_screening_modal.pep_tier_label")
					}), /* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.profileValue,
						children: pep.pepTier
					})]
				})
			})
		}), hasPositions && (entries.length > 0 ? /* @__PURE__ */ jsx("div", {
			className: AmlScreeningRoot_module_default.card,
			children: /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.profileSection,
				children: entries.map((entry, index) => /* @__PURE__ */ jsx(PepEntryRow, { entry }, index))
			})
		}) : /* @__PURE__ */ jsx(EmptyTab, {}))]
	})] });
};
//#endregion
//#region src/aml-screening/components/detail-tabs/SanctionsTabContent.tsx
var SanctionEntryCard = ({ entry }) => {
	var _entry$measures, _entry$sanctionTypes;
	const { t } = useTranslation();
	const fields = [];
	if (entry.name) fields.push({
		label: t("aml_screening_modal.sanction_name_label"),
		value: entry.name
	});
	if (entry.body) fields.push({
		label: t("aml_screening_modal.sanction_body_label"),
		value: entry.body
	});
	if (entry.origin) fields.push({
		label: t("aml_screening_modal.sanction_origin_label"),
		value: entry.origin
	});
	if ((_entry$measures = entry.measures) === null || _entry$measures === void 0 ? void 0 : _entry$measures.length) fields.push({
		label: t("aml_screening_modal.sanction_measures_label"),
		value: entry.measures.join(", ")
	});
	if ((_entry$sanctionTypes = entry.sanctionTypes) === null || _entry$sanctionTypes === void 0 ? void 0 : _entry$sanctionTypes.length) fields.push({
		label: t("aml_screening_modal.sanction_types_label"),
		value: entry.sanctionTypes.join(", ")
	});
	return /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.card,
		children: /* @__PURE__ */ jsxs("div", {
			className: AmlScreeningRoot_module_default.profileSection,
			children: [fields.map((field) => /* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.profileRow,
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.profileLabel,
					children: field.label
				}), /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.profileValue,
					children: field.value
				})]
			}, field.label)), /* @__PURE__ */ jsx(AmlEventsRow, { events: entry.events })]
		})
	});
};
var SanctionsTabContent = ({ match }) => {
	var _match$sanctions$curr, _match$sanctions, _match$sanctions$form, _match$sanctions2;
	const { t } = useTranslation();
	const current = (_match$sanctions$curr = (_match$sanctions = match.sanctions) === null || _match$sanctions === void 0 ? void 0 : _match$sanctions.current) !== null && _match$sanctions$curr !== void 0 ? _match$sanctions$curr : [];
	const former = (_match$sanctions$form = (_match$sanctions2 = match.sanctions) === null || _match$sanctions2 === void 0 ? void 0 : _match$sanctions2.former) !== null && _match$sanctions$form !== void 0 ? _match$sanctions$form : [];
	const [segment, setSegment] = useState(() => current.length > 0 ? "current" : "former");
	if (current.length === 0 && former.length === 0) return /* @__PURE__ */ jsx(EmptyTab, {});
	const entries = segment === "current" ? current : former;
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(AmlSegmentedControl, {
		ariaLabel: t("aml_screening_modal.tab_sanctions"),
		activeId: segment,
		onChange: (id) => setSegment(id),
		segments: [{
			id: "current",
			label: t("aml_screening_modal.segment_current"),
			count: current.length
		}, {
			id: "former",
			label: t("aml_screening_modal.segment_former"),
			count: former.length
		}]
	}), entries.length === 0 ? /* @__PURE__ */ jsx(EmptyTab, {}) : /* @__PURE__ */ jsx("div", {
		className: AmlScreeningRoot_module_default.profileSections,
		children: entries.map((entry, index) => /* @__PURE__ */ jsx(SanctionEntryCard, { entry }, index))
	})] });
};
//#endregion
//#region src/aml-screening/components/useModalTransition.ts
var DEFAULT_TRANSITION_MS = 200;
var getTransitionDurationMs = (node) => {
	if (!node) return DEFAULT_TRANSITION_MS;
	const [first] = getComputedStyle(node).transitionDuration.split(",");
	const raw = first === null || first === void 0 ? void 0 : first.trim();
	if (!raw) return DEFAULT_TRANSITION_MS;
	const value = parseFloat(raw);
	if (Number.isNaN(value)) return DEFAULT_TRANSITION_MS;
	return raw.endsWith("ms") ? value : value * 1e3;
};
var useModalTransition = (onClose) => {
	const [phase, setPhase] = useState("entering");
	const modalRef = useRef(null);
	useEffect(() => {
		const frame = requestAnimationFrame(() => {
			setPhase((current) => current === "entering" ? "open" : current);
		});
		return () => cancelAnimationFrame(frame);
	}, []);
	useEffect(() => {
		if (phase !== "closing") return;
		const duration = getTransitionDurationMs(modalRef.current);
		const timeoutId = window.setTimeout(onClose, duration);
		return () => window.clearTimeout(timeoutId);
	}, [phase, onClose]);
	const requestClose = useCallback(() => {
		setPhase("closing");
	}, []);
	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === "Escape") requestClose();
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [requestClose]);
	return {
		isVisible: phase === "open",
		isClosing: phase === "closing",
		requestClose,
		modalRef
	};
};
//#endregion
//#region src/aml-screening/components/AmlMatchDetail.tsx
var TABS = [
	{
		id: "main",
		labelKey: "aml_screening_modal.tab_main"
	},
	{
		id: "sanctions",
		labelKey: "aml_screening_modal.tab_sanctions"
	},
	{
		id: "pep",
		labelKey: "aml_screening_modal.tab_pep"
	},
	{
		id: "adverseMedia",
		labelKey: "aml_screening_modal.tab_adverse_media"
	},
	{
		id: "associations",
		labelKey: "aml_screening_modal.tab_associations"
	},
	{
		id: "otherSources",
		labelKey: "aml_screening_modal.tab_other_sources"
	}
];
var tabBadge = (tab, match) => {
	switch (tab) {
		case "sanctions": {
			const counts = match.sanctionCounts;
			if (!counts || counts.current + counts.former === 0) return null;
			return {
				primary: counts.current,
				secondary: counts.former
			};
		}
		case "pep": {
			var _match$pepInformation, _match$pepInformation2, _match$pepInformation3, _match$pepInformation4;
			const current = (_match$pepInformation = (_match$pepInformation2 = match.pepInformation) === null || _match$pepInformation2 === void 0 || (_match$pepInformation2 = _match$pepInformation2.current) === null || _match$pepInformation2 === void 0 ? void 0 : _match$pepInformation2.length) !== null && _match$pepInformation !== void 0 ? _match$pepInformation : 0;
			const former = (_match$pepInformation3 = (_match$pepInformation4 = match.pepInformation) === null || _match$pepInformation4 === void 0 || (_match$pepInformation4 = _match$pepInformation4.former) === null || _match$pepInformation4 === void 0 ? void 0 : _match$pepInformation4.length) !== null && _match$pepInformation3 !== void 0 ? _match$pepInformation3 : 0;
			return current + former > 0 ? {
				primary: current,
				secondary: former
			} : null;
		}
		case "adverseMedia": {
			var _match$adverseMediaEn, _match$adverseMediaEn2;
			const count = (_match$adverseMediaEn = (_match$adverseMediaEn2 = match.adverseMediaEntries) === null || _match$adverseMediaEn2 === void 0 ? void 0 : _match$adverseMediaEn2.length) !== null && _match$adverseMediaEn !== void 0 ? _match$adverseMediaEn : 0;
			return count > 0 ? {
				primary: count,
				secondary: null
			} : null;
		}
		case "associations": {
			var _match$associations$i, _match$associations, _match$associations$b, _match$associations2;
			const individuals = (_match$associations$i = (_match$associations = match.associations) === null || _match$associations === void 0 || (_match$associations = _match$associations.individuals) === null || _match$associations === void 0 ? void 0 : _match$associations.length) !== null && _match$associations$i !== void 0 ? _match$associations$i : 0;
			const businesses = (_match$associations$b = (_match$associations2 = match.associations) === null || _match$associations2 === void 0 || (_match$associations2 = _match$associations2.businesses) === null || _match$associations2 === void 0 ? void 0 : _match$associations2.length) !== null && _match$associations$b !== void 0 ? _match$associations$b : 0;
			return individuals + businesses > 0 ? {
				primary: individuals,
				secondary: businesses
			} : null;
		}
		case "otherSources": {
			var _match$regulatoryEnfo, _match$regulatoryEnfo2;
			const count = (_match$regulatoryEnfo = (_match$regulatoryEnfo2 = match.regulatoryEnforcementEntries) === null || _match$regulatoryEnfo2 === void 0 ? void 0 : _match$regulatoryEnfo2.length) !== null && _match$regulatoryEnfo !== void 0 ? _match$regulatoryEnfo : 0;
			return count > 0 ? {
				primary: count,
				secondary: null
			} : null;
		}
		default: return null;
	}
};
var AmlMatchDetail = ({ match, onClose }) => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState("main");
	const { isVisible, requestClose, modalRef } = useModalTransition(onClose);
	const handleBackdropClick = (event) => {
		if (event.target === event.currentTarget) requestClose();
	};
	return /* @__PURE__ */ jsx("div", {
		className: `${AmlScreeningRoot_module_default.detailBackdrop} ${isVisible ? AmlScreeningRoot_module_default["detailBackdrop--visible"] : ""}`,
		onClick: handleBackdropClick,
		role: "dialog",
		"aria-modal": "true",
		"aria-label": match.entityName,
		children: /* @__PURE__ */ jsxs("div", {
			ref: modalRef,
			className: `${AmlScreeningRoot_module_default.detailModal} ${isVisible ? AmlScreeningRoot_module_default["detailModal--visible"] : ""}`,
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: AmlScreeningRoot_module_default.header,
					children: [/* @__PURE__ */ jsx("span", {
						className: AmlScreeningRoot_module_default.detailTitle,
						children: match.entityName
					}), /* @__PURE__ */ jsx("button", {
						type: "button",
						className: AmlScreeningRoot_module_default.closeButton,
						onClick: requestClose,
						"aria-label": t("aml_screening_modal.close_button"),
						children: /* @__PURE__ */ jsx(CloseIcon, {})
					})]
				}),
				/* @__PURE__ */ jsx("div", {
					className: AmlScreeningRoot_module_default.tabs,
					children: TABS.map((tab) => {
						const badge = tabBadge(tab.id, match);
						const isActive = activeTab === tab.id;
						return /* @__PURE__ */ jsxs("button", {
							type: "button",
							className: `${AmlScreeningRoot_module_default.tab} ${isActive ? AmlScreeningRoot_module_default["tab--active"] : ""}`,
							onClick: () => setActiveTab(tab.id),
							children: [t(tab.labelKey), badge && /* @__PURE__ */ jsx("span", {
								"aria-hidden": "true",
								className: `${AmlScreeningRoot_module_default.tabBadge} ${isActive ? AmlScreeningRoot_module_default["tabBadge--active"] : ""}`,
								children: badge.secondary === null ? badge.primary : `${badge.primary} | ${badge.secondary}`
							})]
						}, tab.id);
					})
				}),
				activeTab === "main" && /* @__PURE__ */ jsx(MainTabContent, { match }),
				activeTab === "sanctions" && /* @__PURE__ */ jsx(SanctionsTabContent, { match }),
				activeTab === "pep" && /* @__PURE__ */ jsx(PepTabContent, { match }),
				activeTab === "adverseMedia" && /* @__PURE__ */ jsx(AdverseMediaTabContent, { match }),
				activeTab === "associations" && /* @__PURE__ */ jsx(AssociationsTabContent, { match }),
				activeTab === "otherSources" && /* @__PURE__ */ jsx(OtherSourcesTabContent, { match })
			]
		})
	});
};
//#endregion
//#region src/aml-screening/components/AmlMatchProfileDialog.tsx
var AmlMatchProfileDialog = ({ canResolveOthers, onConfirm, onClose }) => {
	const { t } = useTranslation();
	const { isVisible, isClosing, requestClose, modalRef } = useModalTransition(onClose);
	const commentRef = useRef(null);
	const [comment, setComment] = useState("");
	const [resolveOthers, setResolveOthers] = useState(false);
	const [falsePositiveComment, setFalsePositiveComment] = useState("");
	useEffect(() => {
		var _commentRef$current;
		(_commentRef$current = commentRef.current) === null || _commentRef$current === void 0 || _commentRef$current.focus();
	}, []);
	const handleConfirm = () => {
		if (isClosing) return;
		onConfirm({
			comment: comment.trim() || void 0,
			resolveOthersToFalsePositive: canResolveOthers && resolveOthers,
			falsePositiveComment: falsePositiveComment.trim() || void 0
		});
		requestClose();
	};
	const handleBackdropClick = (event) => {
		if (event.target === event.currentTarget) requestClose();
	};
	const showFalsePositiveComment = canResolveOthers && resolveOthers;
	return /* @__PURE__ */ jsx("div", {
		className: `${AmlScreeningRoot_module_default.detailBackdrop} ${isVisible ? AmlScreeningRoot_module_default["detailBackdrop--visible"] : ""}`,
		onClick: handleBackdropClick,
		role: "dialog",
		"aria-modal": "true",
		"aria-label": t("aml_screening_modal.match_profile_title"),
		children: /* @__PURE__ */ jsxs("div", {
			ref: modalRef,
			className: `${AmlScreeningRoot_module_default.confirmModal} ${isVisible ? AmlScreeningRoot_module_default["confirmModal--visible"] : ""}`,
			children: [/* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.confirmBody,
				children: [
					/* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.confirmTitleRow,
						children: [/* @__PURE__ */ jsxs("div", {
							className: AmlScreeningRoot_module_default.confirmTitleGroup,
							children: [/* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.confirmTitle,
								children: t("aml_screening_modal.match_profile_title")
							}), /* @__PURE__ */ jsx("p", {
								className: AmlScreeningRoot_module_default.confirmSubtitle,
								children: t("aml_screening_modal.match_profile_subtitle")
							})]
						}), /* @__PURE__ */ jsx("button", {
							type: "button",
							className: AmlScreeningRoot_module_default.closeButton,
							onClick: requestClose,
							"aria-label": t("aml_screening_modal.close_button"),
							children: /* @__PURE__ */ jsx(CloseIcon, {})
						})]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.field,
						children: [/* @__PURE__ */ jsx("span", {
							className: AmlScreeningRoot_module_default.confirmFieldLabel,
							children: t("aml_screening_modal.match_profile_comment_label")
						}), /* @__PURE__ */ jsx("textarea", {
							ref: commentRef,
							className: AmlScreeningRoot_module_default.textarea,
							value: comment,
							onChange: (event) => setComment(event.target.value),
							placeholder: t("aml_screening_modal.match_profile_comment_placeholder"),
							"aria-label": t("aml_screening_modal.match_profile_comment_label")
						})]
					}),
					canResolveOthers && /* @__PURE__ */ jsxs("label", {
						className: AmlScreeningRoot_module_default.confirmCheckbox,
						children: [/* @__PURE__ */ jsx("input", {
							type: "checkbox",
							className: AmlScreeningRoot_module_default.confirmCheckboxInput,
							checked: resolveOthers,
							onChange: (event) => setResolveOthers(event.target.checked)
						}), t("aml_screening_modal.match_profile_resolve_others")]
					}),
					showFalsePositiveComment && /* @__PURE__ */ jsxs("div", {
						className: AmlScreeningRoot_module_default.field,
						children: [/* @__PURE__ */ jsx("span", {
							className: AmlScreeningRoot_module_default.confirmFieldLabel,
							children: t("aml_screening_modal.match_profile_false_positive_comment_label")
						}), /* @__PURE__ */ jsx("textarea", {
							className: AmlScreeningRoot_module_default.textarea,
							value: falsePositiveComment,
							onChange: (event) => setFalsePositiveComment(event.target.value),
							placeholder: t("aml_screening_modal.match_profile_comment_placeholder"),
							"aria-label": t("aml_screening_modal.match_profile_false_positive_comment_label")
						})]
					})
				]
			}), /* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.confirmActions,
				children: [/* @__PURE__ */ jsx("button", {
					type: "button",
					className: `${AmlScreeningRoot_module_default.dialogButton} ${AmlScreeningRoot_module_default.dialogButtonSecondary}`,
					onClick: requestClose,
					children: t("aml_screening_modal.close_button")
				}), /* @__PURE__ */ jsx("button", {
					type: "button",
					className: `${AmlScreeningRoot_module_default.dialogButton} ${AmlScreeningRoot_module_default.dialogButtonPrimary}`,
					onClick: handleConfirm,
					children: t("aml_screening_modal.action_match_profile")
				})]
			})]
		})
	});
};
//#endregion
//#region src/aml-screening/components/AmlEmptyState.tsx
var AmlEmptyState = ({ heading, description }) => /* @__PURE__ */ jsxs("div", {
	className: AmlScreeningRoot_module_default.emptyState,
	children: [
		/* @__PURE__ */ jsx("div", {
			className: AmlScreeningRoot_module_default.emptyIcon,
			children: /* @__PURE__ */ jsx(SearchOffIcon, {})
		}),
		/* @__PURE__ */ jsx("p", {
			className: AmlScreeningRoot_module_default.emptyHeading,
			children: heading
		}),
		/* @__PURE__ */ jsx("p", {
			className: AmlScreeningRoot_module_default.emptyDescription,
			children: description
		})
	]
});
//#endregion
//#region src/aml-screening/data/client.ts
var cloneResults = (results) => _objectSpread2(_objectSpread2({}, results), {}, {
	criteria: _objectSpread2(_objectSpread2({}, results.criteria), {}, { datasets: [...results.criteria.datasets] }),
	matches: results.matches.map((match) => _objectSpread2({}, match))
});
var withMatchResolution = (results, matchId, resolution) => _objectSpread2(_objectSpread2({}, results), {}, { matches: results.matches.map((match) => match.id === matchId ? _objectSpread2(_objectSpread2({}, match), {}, { resolution }) : match) });
var withMatchesResolution = (results, matchIds, resolution) => {
	const ids = new Set(matchIds);
	return _objectSpread2(_objectSpread2({}, results), {}, { matches: results.matches.map((match) => ids.has(match.id) ? _objectSpread2(_objectSpread2({}, match), {}, { resolution }) : match) });
};
var withAllOpenResolved = (results) => _objectSpread2(_objectSpread2({}, results), {}, { matches: results.matches.map((match) => match.resolution === MatchResolution.Open ? _objectSpread2(_objectSpread2({}, match), {}, { resolution: MatchResolution.FalsePositive }) : match) });
var openMatchIds = (results) => results.matches.filter((match) => match.resolution === MatchResolution.Open).map((match) => match.id);
//#endregion
//#region src/aml-screening/data/snapshot-mappers.ts
var DATASET_LABELS = new Map([
	["OndatoPepCurrent", "PEP (Ondato)"],
	["OndatoSanctionsCurrent", "Sanctions (Ondato)"],
	["ExternalPepCurrent", "PEP"],
	["ExternalPepFormer", "PEP (Former)"],
	["ExternalPepLinked", "PEP (Linked)"],
	["ExternalSanctionsCurrent", "Sanctions"],
	["ExternalSanctionsFormer", "Sanctions (Former)"],
	["ExternalAdverseMedia", "Adverse Media"],
	["ExternalRegulatoryEnforcementList", "Regulatory Enforcement"],
	["ExternalControversialWeapons", "Controversial Weapons"]
]);
var ADDRESS_TYPE_LABELS = new Map([
	["PlaceOfBirth", "Place of birth"],
	["Residential", "Residential"],
	["Business", "Business"],
	["PreviousResidential", "Previous residential"],
	["PreviousBusiness", "Previous business"]
]);
var datasetLabel = (value) => {
	var _DATASET_LABELS$get;
	return (_DATASET_LABELS$get = DATASET_LABELS.get(value)) !== null && _DATASET_LABELS$get !== void 0 ? _DATASET_LABELS$get : value;
};
var isNonEmptyString = (value) => typeof value === "string" && value.length > 0;
var joinNameParts = (parts) => parts.filter(isNonEmptyString).join(" ");
var deriveReason = (snapshot) => {
	var _snapshot$sanctionEnt, _snapshot$sanctionEnt2, _snapshot$sanctionEnt3, _sanction$regime, _snapshot$pepEntries$, _snapshot$pepEntries, _snapshot$pepEntries2, _snapshot$adverseMedi, _snapshot$regulatoryE;
	const sanction = (_snapshot$sanctionEnt = snapshot === null || snapshot === void 0 || (_snapshot$sanctionEnt2 = snapshot.sanctionEntries) === null || _snapshot$sanctionEnt2 === void 0 || (_snapshot$sanctionEnt2 = _snapshot$sanctionEnt2.current) === null || _snapshot$sanctionEnt2 === void 0 ? void 0 : _snapshot$sanctionEnt2[0]) !== null && _snapshot$sanctionEnt !== void 0 ? _snapshot$sanctionEnt : snapshot === null || snapshot === void 0 || (_snapshot$sanctionEnt3 = snapshot.sanctionEntries) === null || _snapshot$sanctionEnt3 === void 0 || (_snapshot$sanctionEnt3 = _snapshot$sanctionEnt3.former) === null || _snapshot$sanctionEnt3 === void 0 ? void 0 : _snapshot$sanctionEnt3[0];
	if (sanction === null || sanction === void 0 || (_sanction$regime = sanction.regime) === null || _sanction$regime === void 0 ? void 0 : _sanction$regime.name) return sanction.regime.name;
	const pep = (_snapshot$pepEntries$ = snapshot === null || snapshot === void 0 || (_snapshot$pepEntries = snapshot.pepEntries) === null || _snapshot$pepEntries === void 0 || (_snapshot$pepEntries = _snapshot$pepEntries.current) === null || _snapshot$pepEntries === void 0 ? void 0 : _snapshot$pepEntries[0]) !== null && _snapshot$pepEntries$ !== void 0 ? _snapshot$pepEntries$ : snapshot === null || snapshot === void 0 || (_snapshot$pepEntries2 = snapshot.pepEntries) === null || _snapshot$pepEntries2 === void 0 || (_snapshot$pepEntries2 = _snapshot$pepEntries2.former) === null || _snapshot$pepEntries2 === void 0 ? void 0 : _snapshot$pepEntries2[0];
	if (pep === null || pep === void 0 ? void 0 : pep.position) return pep.position;
	const adverseMedia = snapshot === null || snapshot === void 0 || (_snapshot$adverseMedi = snapshot.adverseMediaEntries) === null || _snapshot$adverseMedi === void 0 || (_snapshot$adverseMedi = _snapshot$adverseMedi[0]) === null || _snapshot$adverseMedi === void 0 ? void 0 : _snapshot$adverseMedi.category;
	if (adverseMedia) return adverseMedia;
	const regulatory = snapshot === null || snapshot === void 0 || (_snapshot$regulatoryE = snapshot.regulatoryEnforcementListEntries) === null || _snapshot$regulatoryE === void 0 || (_snapshot$regulatoryE = _snapshot$regulatoryE[0]) === null || _snapshot$regulatoryE === void 0 ? void 0 : _snapshot$regulatoryE.category;
	return regulatory !== null && regulatory !== void 0 ? regulatory : "";
};
var mapEvidence = (evidence, position) => {
	var _evidence$evidenceId, _evidence$title, _evidence$summary, _evidence$keywords, _evidence$credibility, _evidence$dataSets, _evidence$originalUrl, _evidence$assetUrl, _evidence$publication;
	return {
		id: (_evidence$evidenceId = evidence.evidenceId) !== null && _evidence$evidenceId !== void 0 ? _evidence$evidenceId : `evidence-${position}`,
		title: (_evidence$title = evidence.title) !== null && _evidence$title !== void 0 ? _evidence$title : void 0,
		summary: (_evidence$summary = evidence.summary) !== null && _evidence$summary !== void 0 ? _evidence$summary : void 0,
		keywords: (_evidence$keywords = evidence.keywords) !== null && _evidence$keywords !== void 0 ? _evidence$keywords : void 0,
		credibility: (_evidence$credibility = evidence.credibility) !== null && _evidence$credibility !== void 0 ? _evidence$credibility : void 0,
		sources: ((_evidence$dataSets = evidence.dataSets) !== null && _evidence$dataSets !== void 0 ? _evidence$dataSets : []).filter(isNonEmptyString).map(datasetLabel),
		originalUrl: (_evidence$originalUrl = evidence.originalUrl) !== null && _evidence$originalUrl !== void 0 ? _evidence$originalUrl : void 0,
		assetUrl: (_evidence$assetUrl = evidence.assetUrl) !== null && _evidence$assetUrl !== void 0 ? _evidence$assetUrl : void 0,
		publicationDate: (_evidence$publication = evidence.publicationDate) !== null && _evidence$publication !== void 0 ? _evidence$publication : void 0
	};
};
var buildEvidenceIndex = (snapshot) => {
	var _snapshot$evidences;
	const index = /* @__PURE__ */ new Map();
	((_snapshot$evidences = snapshot === null || snapshot === void 0 ? void 0 : snapshot.evidences) !== null && _snapshot$evidences !== void 0 ? _snapshot$evidences : []).forEach((evidence, position) => {
		if (isNonEmptyString(evidence.evidenceId)) index.set(evidence.evidenceId, mapEvidence(evidence, position));
	});
	return index;
};
var resolveEvidence = (evidenceIds, index) => (evidenceIds !== null && evidenceIds !== void 0 ? evidenceIds : []).map((id) => index.get(id)).filter((evidence) => Boolean(evidence));
var mapEvent = (event, index) => {
	var _event$type, _event$amount, _event$currencyCode, _event$period$years, _event$period$months, _event$period$days;
	return {
		type: (_event$type = event.type) !== null && _event$type !== void 0 ? _event$type : void 0,
		amount: (_event$amount = event.amount) !== null && _event$amount !== void 0 ? _event$amount : void 0,
		currencyCode: (_event$currencyCode = event.currencyCode) !== null && _event$currencyCode !== void 0 ? _event$currencyCode : void 0,
		period: event.period ? {
			years: (_event$period$years = event.period.years) !== null && _event$period$years !== void 0 ? _event$period$years : void 0,
			months: (_event$period$months = event.period.months) !== null && _event$period$months !== void 0 ? _event$period$months : void 0,
			days: (_event$period$days = event.period.days) !== null && _event$period$days !== void 0 ? _event$period$days : void 0
		} : void 0,
		evidence: resolveEvidence(event.evidenceIds, index)
	};
};
var mapSanctionEntry = (entry, index) => {
	var _entry$regime$name, _entry$regime, _entry$body, _entry$regime$origin, _entry$regime2, _entry$measures, _entry$regime3, _entry$events;
	return {
		name: (_entry$regime$name = (_entry$regime = entry.regime) === null || _entry$regime === void 0 ? void 0 : _entry$regime.name) !== null && _entry$regime$name !== void 0 ? _entry$regime$name : void 0,
		body: (_entry$body = entry.body) !== null && _entry$body !== void 0 ? _entry$body : void 0,
		origin: (_entry$regime$origin = (_entry$regime2 = entry.regime) === null || _entry$regime2 === void 0 ? void 0 : _entry$regime2.origin) !== null && _entry$regime$origin !== void 0 ? _entry$regime$origin : void 0,
		measures: ((_entry$measures = entry.measures) === null || _entry$measures === void 0 ? void 0 : _entry$measures.length) ? entry.measures : void 0,
		sanctionTypes: ((_entry$regime3 = entry.regime) === null || _entry$regime3 === void 0 || (_entry$regime3 = _entry$regime3.types) === null || _entry$regime3 === void 0 ? void 0 : _entry$regime3.length) ? entry.regime.types : void 0,
		events: ((_entry$events = entry.events) !== null && _entry$events !== void 0 ? _entry$events : []).map((event) => mapEvent(event, index))
	};
};
var buildSanctions = (snapshot, index) => {
	var _snapshot$sanctionEnt4, _snapshot$sanctionEnt5, _snapshot$sanctionEnt6, _snapshot$sanctionEnt7;
	const current = (_snapshot$sanctionEnt4 = snapshot === null || snapshot === void 0 || (_snapshot$sanctionEnt5 = snapshot.sanctionEntries) === null || _snapshot$sanctionEnt5 === void 0 ? void 0 : _snapshot$sanctionEnt5.current) !== null && _snapshot$sanctionEnt4 !== void 0 ? _snapshot$sanctionEnt4 : [];
	const former = (_snapshot$sanctionEnt6 = snapshot === null || snapshot === void 0 || (_snapshot$sanctionEnt7 = snapshot.sanctionEntries) === null || _snapshot$sanctionEnt7 === void 0 ? void 0 : _snapshot$sanctionEnt7.former) !== null && _snapshot$sanctionEnt6 !== void 0 ? _snapshot$sanctionEnt6 : [];
	if (current.length === 0 && former.length === 0) return;
	return {
		current: current.map((entry) => mapSanctionEntry(entry, index)),
		former: former.map((entry) => mapSanctionEntry(entry, index))
	};
};
var buildSanctionCounts = (snapshot) => {
	var _snapshot$sanctionEnt8, _snapshot$sanctionEnt9, _snapshot$sanctionEnt10, _snapshot$sanctionEnt11;
	const current = (_snapshot$sanctionEnt8 = snapshot === null || snapshot === void 0 || (_snapshot$sanctionEnt9 = snapshot.sanctionEntries) === null || _snapshot$sanctionEnt9 === void 0 || (_snapshot$sanctionEnt9 = _snapshot$sanctionEnt9.current) === null || _snapshot$sanctionEnt9 === void 0 ? void 0 : _snapshot$sanctionEnt9.length) !== null && _snapshot$sanctionEnt8 !== void 0 ? _snapshot$sanctionEnt8 : 0;
	const former = (_snapshot$sanctionEnt10 = snapshot === null || snapshot === void 0 || (_snapshot$sanctionEnt11 = snapshot.sanctionEntries) === null || _snapshot$sanctionEnt11 === void 0 || (_snapshot$sanctionEnt11 = _snapshot$sanctionEnt11.former) === null || _snapshot$sanctionEnt11 === void 0 ? void 0 : _snapshot$sanctionEnt11.length) !== null && _snapshot$sanctionEnt10 !== void 0 ? _snapshot$sanctionEnt10 : 0;
	return current + former > 0 ? {
		current,
		former
	} : void 0;
};
var mapAddress = (address) => {
	var _ADDRESS_TYPE_LABELS$;
	return {
		label: address.addressType ? (_ADDRESS_TYPE_LABELS$ = ADDRESS_TYPE_LABELS.get(address.addressType)) !== null && _ADDRESS_TYPE_LABELS$ !== void 0 ? _ADDRESS_TYPE_LABELS$ : address.addressType : "",
		lines: [
			address.line1,
			address.line2,
			address.city,
			address.county,
			address.postcode,
			address.countryIsoCode
		].filter(isNonEmptyString)
	};
};
var mapContact = (contact) => {
	var _contact$category, _contact$value;
	return {
		label: (_contact$category = contact.category) !== null && _contact$category !== void 0 ? _contact$category : "",
		value: (_contact$value = contact.value) !== null && _contact$value !== void 0 ? _contact$value : ""
	};
};
var mapIdentifier = (identifier) => {
	var _identifier$category, _identifier$value;
	return {
		label: (_identifier$category = identifier.category) !== null && _identifier$category !== void 0 ? _identifier$category : "",
		value: (_identifier$value = identifier.value) !== null && _identifier$value !== void 0 ? _identifier$value : ""
	};
};
var formatAlias = (alias) => {
	var _alias$fullName;
	return (_alias$fullName = alias.fullName) !== null && _alias$fullName !== void 0 ? _alias$fullName : joinNameParts([
		alias.firstName,
		alias.middleName,
		alias.lastName
	]);
};
var buildProfile = (snapshot) => {
	var _snapshot$dataSets, _snapshot$notes, _snapshot$aliases, _snapshot$addresses, _snapshot$contactEntr, _snapshot$identifiers;
	if (!snapshot) return;
	const datasetLabels = (_snapshot$dataSets = snapshot.dataSets) === null || _snapshot$dataSets === void 0 ? void 0 : _snapshot$dataSets.map(datasetLabel);
	const notes = (_snapshot$notes = snapshot.notes) === null || _snapshot$notes === void 0 ? void 0 : _snapshot$notes.map((note) => note.value).filter(isNonEmptyString);
	const aliases = (_snapshot$aliases = snapshot.aliases) === null || _snapshot$aliases === void 0 ? void 0 : _snapshot$aliases.map(formatAlias).filter(isNonEmptyString);
	const addresses = (_snapshot$addresses = snapshot.addresses) === null || _snapshot$addresses === void 0 ? void 0 : _snapshot$addresses.map(mapAddress);
	const contacts = (_snapshot$contactEntr = snapshot.contactEntries) === null || _snapshot$contactEntr === void 0 ? void 0 : _snapshot$contactEntr.map(mapContact);
	const identifiers = (_snapshot$identifiers = snapshot.identifiers) === null || _snapshot$identifiers === void 0 ? void 0 : _snapshot$identifiers.map(mapIdentifier);
	const profile = {
		datasetLabels: (datasetLabels === null || datasetLabels === void 0 ? void 0 : datasetLabels.length) ? datasetLabels : void 0,
		notes: (notes === null || notes === void 0 ? void 0 : notes.length) ? notes : void 0,
		aliases: (aliases === null || aliases === void 0 ? void 0 : aliases.length) ? aliases : void 0,
		addresses: (addresses === null || addresses === void 0 ? void 0 : addresses.length) ? addresses : void 0,
		contacts: (contacts === null || contacts === void 0 ? void 0 : contacts.length) ? contacts : void 0,
		identifiers: (identifiers === null || identifiers === void 0 ? void 0 : identifiers.length) ? identifiers : void 0
	};
	return Object.values(profile).some((value) => value !== void 0) ? profile : void 0;
};
var mapPepEntry = (entry) => {
	var _entry$countryIsoCode, _entry$segment, _entry$position, _entry$dateFromIso, _entry$dateToIso;
	return {
		countryCode: (_entry$countryIsoCode = entry.countryIsoCode) !== null && _entry$countryIsoCode !== void 0 ? _entry$countryIsoCode : void 0,
		segment: (_entry$segment = entry.segment) !== null && _entry$segment !== void 0 ? _entry$segment : void 0,
		position: (_entry$position = entry.position) !== null && _entry$position !== void 0 ? _entry$position : void 0,
		dateFrom: (_entry$dateFromIso = entry.dateFromIso) !== null && _entry$dateFromIso !== void 0 ? _entry$dateFromIso : void 0,
		dateTo: (_entry$dateToIso = entry.dateToIso) !== null && _entry$dateToIso !== void 0 ? _entry$dateToIso : void 0
	};
};
var buildPepInformation = (snapshot) => {
	var _pep$current, _pep$former, _pep$pepTier;
	const pep = snapshot === null || snapshot === void 0 ? void 0 : snapshot.pepEntries;
	if (!pep) return;
	const current = (_pep$current = pep.current) === null || _pep$current === void 0 ? void 0 : _pep$current.map(mapPepEntry);
	const former = (_pep$former = pep.former) === null || _pep$former === void 0 ? void 0 : _pep$former.map(mapPepEntry);
	if (!pep.pepTier && !(current === null || current === void 0 ? void 0 : current.length) && !(former === null || former === void 0 ? void 0 : former.length)) return;
	return {
		pepTier: (_pep$pepTier = pep.pepTier) !== null && _pep$pepTier !== void 0 ? _pep$pepTier : void 0,
		current: (current === null || current === void 0 ? void 0 : current.length) ? current : void 0,
		former: (former === null || former === void 0 ? void 0 : former.length) ? former : void 0
	};
};
var buildAdverseMediaEntries = (snapshot, index) => {
	const entries = snapshot === null || snapshot === void 0 ? void 0 : snapshot.adverseMediaEntries;
	if (!(entries === null || entries === void 0 ? void 0 : entries.length)) return;
	return entries.map((entry) => {
		var _entry$category, _entry$subCategory, _entry$events2;
		return {
			category: (_entry$category = entry.category) !== null && _entry$category !== void 0 ? _entry$category : void 0,
			subCategory: (_entry$subCategory = entry.subCategory) !== null && _entry$subCategory !== void 0 ? _entry$subCategory : void 0,
			events: ((_entry$events2 = entry.events) !== null && _entry$events2 !== void 0 ? _entry$events2 : []).map((event) => mapEvent(event, index))
		};
	});
};
var buildRegulatoryEnforcementEntries = (snapshot, index) => {
	const entries = snapshot === null || snapshot === void 0 ? void 0 : snapshot.regulatoryEnforcementListEntries;
	if (!(entries === null || entries === void 0 ? void 0 : entries.length)) return;
	return entries.map((entry) => {
		var _entry$category2, _entry$subCategory2, _entry$events3;
		return {
			category: (_entry$category2 = entry.category) !== null && _entry$category2 !== void 0 ? _entry$category2 : void 0,
			subCategory: (_entry$subCategory2 = entry.subCategory) !== null && _entry$subCategory2 !== void 0 ? _entry$subCategory2 : void 0,
			events: ((_entry$events3 = entry.events) !== null && _entry$events3 !== void 0 ? _entry$events3 : []).map((event) => mapEvent(event, index))
		};
	});
};
var formatIndividualLinkName = (link) => joinNameParts([
	link.firstName,
	link.middleName,
	link.lastName
]);
var buildAssociations = (snapshot) => {
	var _snapshot$individualL, _snapshot$businessLin;
	const individuals = snapshot === null || snapshot === void 0 || (_snapshot$individualL = snapshot.individualLinks) === null || _snapshot$individualL === void 0 ? void 0 : _snapshot$individualL.map((link) => {
		var _link$relationship, _link$ownershipPercen;
		return {
			name: formatIndividualLinkName(link),
			relationship: (_link$relationship = link.relationship) !== null && _link$relationship !== void 0 ? _link$relationship : void 0,
			ownershipPercentage: (_link$ownershipPercen = link.ownershipPercentage) !== null && _link$ownershipPercen !== void 0 ? _link$ownershipPercen : void 0
		};
	}).filter((association) => association.name.length > 0);
	const businesses = snapshot === null || snapshot === void 0 || (_snapshot$businessLin = snapshot.businessLinks) === null || _snapshot$businessLin === void 0 ? void 0 : _snapshot$businessLin.map((link) => {
		var _link$name, _link$relationship2, _link$ownershipPercen2;
		return {
			name: (_link$name = link.name) !== null && _link$name !== void 0 ? _link$name : void 0,
			relationship: (_link$relationship2 = link.relationship) !== null && _link$relationship2 !== void 0 ? _link$relationship2 : void 0,
			ownershipPercentage: (_link$ownershipPercen2 = link.ownershipPercentage) !== null && _link$ownershipPercen2 !== void 0 ? _link$ownershipPercen2 : void 0
		};
	});
	if (!(individuals === null || individuals === void 0 ? void 0 : individuals.length) && !(businesses === null || businesses === void 0 ? void 0 : businesses.length)) return;
	return {
		individuals: (individuals === null || individuals === void 0 ? void 0 : individuals.length) ? individuals : void 0,
		businesses: (businesses === null || businesses === void 0 ? void 0 : businesses.length) ? businesses : void 0
	};
};
var deriveResolution = (reviews) => {
	var _reviews$data, _sorted$;
	const latestStatus = (_sorted$ = [...(_reviews$data = reviews.data) !== null && _reviews$data !== void 0 ? _reviews$data : []].sort((a, b) => {
		const aTime = a.createdAtUtc ? Date.parse(a.createdAtUtc) : 0;
		return (b.createdAtUtc ? Date.parse(b.createdAtUtc) : 0) - aTime;
	})[0]) === null || _sorted$ === void 0 ? void 0 : _sorted$.status;
	if (latestStatus === MatchResolution.TruePositive) return MatchResolution.TruePositive;
	if (latestStatus === MatchResolution.FalsePositive) return MatchResolution.FalsePositive;
	return MatchResolution.Open;
};
var buildEvidenceLookup = buildEvidenceIndex;
//#endregion
//#region src/aml-screening/data/http-client.ts
var apiFetch = function() {
	var _ref = _asyncToGenerator(function* (url, method, getAuthToken, body) {
		const token = getAuthToken();
		const headers = new Headers();
		if (token) headers.set("Authorization", `Bearer ${token}`);
		if (body) headers.set("Content-Type", "application/json");
		const response = yield fetch(url, {
			method,
			mode: "cors",
			credentials: "include",
			headers,
			body: body ? JSON.stringify(body) : void 0
		});
		if (!response.ok) throw new Error(`AML screening request to ${url} failed: ${response.status}`);
		return response.headers.get("content-type") ? yield response.json() : void 0;
	});
	return function apiFetch(_x, _x2, _x3, _x4) {
		return _ref.apply(this, arguments);
	};
}();
var matchesUrl = (apiBaseUrl, identificationId) => `${apiBaseUrl}/v1/identifications/${encodeURIComponent(identificationId)}/aml-screening-matches`;
var matchReviewsUrl = (apiBaseUrl, identificationId, matchId) => `${matchesUrl(apiBaseUrl, identificationId)}/${encodeURIComponent(matchId)}/match-reviews`;
var matchSnapshotUrl = (apiBaseUrl, identificationId, matchId) => `${matchesUrl(apiBaseUrl, identificationId)}/${encodeURIComponent(matchId)}/natural-entity-snapshots`;
var buildMatch = function() {
	var _ref6 = _asyncToGenerator(function* (apiBaseUrl, getAuthToken, identificationId, candidate) {
		var _snapshotResponse$sna, _ref2, _candidate$dataSets, _ref3, _ref4, _candidate$name, _candidate$matchScore, _candidate$countries, _ref5, _candidate$gender, _candidate$birthDates, _candidate$birthDates2, _snapshot$datesOfBirt, _snapshot$profileImag;
		const matchId = candidate.resourceId;
		const [reviews, snapshotResponse] = yield Promise.all([apiFetch(matchReviewsUrl(apiBaseUrl, identificationId, matchId), "GET", getAuthToken), apiFetch(matchSnapshotUrl(apiBaseUrl, identificationId, matchId), "GET", getAuthToken)]);
		const snapshot = (_snapshotResponse$sna = snapshotResponse.snapshot) !== null && _snapshotResponse$sna !== void 0 ? _snapshotResponse$sna : null;
		const dataSets = (_ref2 = (_candidate$dataSets = candidate.dataSets) !== null && _candidate$dataSets !== void 0 ? _candidate$dataSets : snapshot === null || snapshot === void 0 ? void 0 : snapshot.dataSets) !== null && _ref2 !== void 0 ? _ref2 : [];
		const evidenceIndex = buildEvidenceLookup(snapshot);
		return {
			id: matchId,
			entityName: (_ref3 = (_ref4 = (_candidate$name = candidate.name) !== null && _candidate$name !== void 0 ? _candidate$name : candidate.match) !== null && _ref4 !== void 0 ? _ref4 : snapshot === null || snapshot === void 0 ? void 0 : snapshot.fullName) !== null && _ref3 !== void 0 ? _ref3 : "",
			matchScore: (_candidate$matchScore = candidate.matchScore) !== null && _candidate$matchScore !== void 0 ? _candidate$matchScore : 0,
			countries: ((_candidate$countries = candidate.countries) !== null && _candidate$countries !== void 0 ? _candidate$countries : []).filter(isNonEmptyString),
			sanctionTypes: dataSets.map(datasetLabel),
			dataset: dataSets.map(datasetLabel).join(", "),
			reason: deriveReason(snapshot),
			resolution: deriveResolution(reviews),
			sanctions: buildSanctions(snapshot, evidenceIndex),
			sanctionCounts: buildSanctionCounts(snapshot),
			profile: buildProfile(snapshot),
			pepInformation: buildPepInformation(snapshot),
			adverseMediaEntries: buildAdverseMediaEntries(snapshot, evidenceIndex),
			regulatoryEnforcementEntries: buildRegulatoryEnforcementEntries(snapshot, evidenceIndex),
			associations: buildAssociations(snapshot),
			gender: (_ref5 = (_candidate$gender = candidate.gender) !== null && _candidate$gender !== void 0 ? _candidate$gender : snapshot === null || snapshot === void 0 ? void 0 : snapshot.gender) !== null && _ref5 !== void 0 ? _ref5 : void 0,
			dateOfBirth: (_candidate$birthDates = (_candidate$birthDates2 = candidate.birthDates) === null || _candidate$birthDates2 === void 0 ? void 0 : _candidate$birthDates2[0]) !== null && _candidate$birthDates !== void 0 ? _candidate$birthDates : snapshot === null || snapshot === void 0 || (_snapshot$datesOfBirt = snapshot.datesOfBirthIso) === null || _snapshot$datesOfBirt === void 0 ? void 0 : _snapshot$datesOfBirt[0],
			photoUrls: ((_snapshot$profileImag = snapshot === null || snapshot === void 0 ? void 0 : snapshot.profileImages) !== null && _snapshot$profileImag !== void 0 ? _snapshot$profileImag : []).filter(isNonEmptyString)
		};
	});
	return function buildMatch(_x5, _x6, _x7, _x8) {
		return _ref6.apply(this, arguments);
	};
}();
var createHttpAmlScreeningClient = (options) => {
	const { apiBaseUrl, getAuthToken, personGender, personCountry } = options;
	const resultsCache = /* @__PURE__ */ new Map();
	const loadResults = function() {
		var _ref7 = _asyncToGenerator(function* (identificationId) {
			var _list$data;
			const candidates = ((_list$data = (yield apiFetch(matchesUrl(apiBaseUrl, identificationId), "GET", getAuthToken)).data) !== null && _list$data !== void 0 ? _list$data : []).filter((candidate) => isNonEmptyString(candidate.resourceId));
			const matches = yield Promise.all(candidates.map((candidate) => buildMatch(apiBaseUrl, getAuthToken, identificationId, candidate)));
			return {
				status: matches.length > 0 ? AmlScreeningStatus.Fail : AmlScreeningStatus.Success,
				criteria: {
					datasets: [
						"Sanctions",
						"PEP",
						"Adverse Media",
						"Regulatory Enforcement"
					],
					country: personCountry !== null && personCountry !== void 0 ? personCountry : "",
					gender: personGender !== null && personGender !== void 0 ? personGender : ""
				},
				matches
			};
		});
		return function loadResults(_x9) {
			return _ref7.apply(this, arguments);
		};
	}();
	const getOrLoad = (identificationId) => {
		let cached = resultsCache.get(identificationId);
		if (!cached) {
			cached = loadResults(identificationId).catch((error) => {
				resultsCache.delete(identificationId);
				throw error;
			});
			resultsCache.set(identificationId, cached);
		}
		return cached;
	};
	return {
		fetchResults(identificationId) {
			return _asyncToGenerator(function* () {
				return cloneResults(yield getOrLoad(identificationId));
			})();
		},
		resolveMatch(identificationId, matchId, resolution) {
			return _asyncToGenerator(function* () {
				yield apiFetch(matchReviewsUrl(apiBaseUrl, identificationId, matchId), "POST", getAuthToken, { matchStatus: resolution });
				const updated = withMatchResolution(yield getOrLoad(identificationId), matchId, resolution);
				resultsCache.set(identificationId, Promise.resolve(updated));
				return cloneResults(updated);
			})();
		},
		resolveMatches(identificationId, matchIds, resolution) {
			return _asyncToGenerator(function* () {
				yield Promise.all(matchIds.map((matchId) => apiFetch(matchReviewsUrl(apiBaseUrl, identificationId, matchId), "POST", getAuthToken, { matchStatus: resolution })));
				const updated = withMatchesResolution(yield getOrLoad(identificationId), matchIds, resolution);
				resultsCache.set(identificationId, Promise.resolve(updated));
				return cloneResults(updated);
			})();
		},
		matchProfiles(identificationId, matchIds, input) {
			return _asyncToGenerator(function* () {
				yield Promise.all(matchIds.map((matchId) => apiFetch(matchReviewsUrl(apiBaseUrl, identificationId, matchId), "POST", getAuthToken, {
					matchStatus: MatchResolution.TruePositive,
					comment: input.comment
				})));
				let updated = withMatchesResolution(yield getOrLoad(identificationId), matchIds, MatchResolution.TruePositive);
				if (input.resolveOthersToFalsePositive) {
					const otherOpenIds = openMatchIds(updated);
					if (otherOpenIds.length > 0) {
						yield Promise.all(otherOpenIds.map((matchId) => apiFetch(matchReviewsUrl(apiBaseUrl, identificationId, matchId), "POST", getAuthToken, {
							matchStatus: MatchResolution.FalsePositive,
							comment: input.falsePositiveComment
						})));
						updated = withMatchesResolution(updated, otherOpenIds, MatchResolution.FalsePositive);
					}
				}
				resultsCache.set(identificationId, Promise.resolve(updated));
				return cloneResults(updated);
			})();
		},
		bulkCloseRemaining(identificationId) {
			return _asyncToGenerator(function* () {
				const results = yield getOrLoad(identificationId);
				const openMatches = results.matches.filter((match) => match.resolution === MatchResolution.Open);
				yield Promise.all(openMatches.map((match) => apiFetch(matchReviewsUrl(apiBaseUrl, identificationId, match.id), "POST", getAuthToken, { matchStatus: MatchResolution.FalsePositive })));
				const updated = withAllOpenResolved(results);
				resultsCache.set(identificationId, Promise.resolve(updated));
				return cloneResults(updated);
			})();
		}
	};
};
//#endregion
//#region src/aml-screening/useAmlScreening.ts
var useAmlScreening = ({ identificationId, personGender, personCountry, getAuthToken, apiBaseUrl, open, onStatusChange, client: injectedClient }) => {
	const client = useMemo(() => injectedClient !== null && injectedClient !== void 0 ? injectedClient : createHttpAmlScreeningClient({
		apiBaseUrl,
		getAuthToken,
		personGender,
		personCountry
	}), [
		injectedClient,
		apiBaseUrl,
		getAuthToken,
		personGender,
		personCountry
	]);
	const [results, setResults] = useState(null);
	const [viewingMatch, setViewingMatch] = useState(null);
	const [filter, setFilter] = useState("all");
	const [matchProfileTarget, setMatchProfileTarget] = useState(null);
	const [selectedIds, setSelectedIds] = useState(/* @__PURE__ */ new Set());
	const [busy, setBusy] = useState(false);
	useEffect(() => {
		if (!open) return;
		setResults(null);
		setViewingMatch(null);
		setFilter("all");
		setSelectedIds(/* @__PURE__ */ new Set());
		setMatchProfileTarget(null);
		client.fetchResults(identificationId).then(setResults, () => setResults({
			status: AmlScreeningStatus.Unavailable,
			criteria: {
				datasets: [],
				country: "",
				gender: ""
			},
			matches: []
		}));
	}, [
		client,
		identificationId,
		open
	]);
	const filteredMatches = useMemo(() => {
		if (!results) return [];
		if (filter === "all") return results.matches;
		return results.matches.filter((match) => match.resolution === filter);
	}, [results, filter]);
	const applyUpdatedResults = (updated) => {
		setResults(updated);
		onStatusChange({
			status: updated.status,
			allResolved: updated.matches.every((match) => match.resolution !== MatchResolution.Open)
		});
	};
	const withBusy = function() {
		var _ref = _asyncToGenerator(function* (work) {
			setBusy(true);
			try {
				yield work();
			} finally {
				setBusy(false);
			}
		});
		return function withBusy(_x) {
			return _ref.apply(this, arguments);
		};
	}();
	const handleResolve = function() {
		var _ref2 = _asyncToGenerator(function* (matchId, resolution) {
			yield withBusy(_asyncToGenerator(function* () {
				applyUpdatedResults(yield client.resolveMatch(identificationId, matchId, resolution));
			}));
		});
		return function handleResolve(_x2, _x3) {
			return _ref2.apply(this, arguments);
		};
	}();
	const handleFilterChange = (value) => {
		setFilter(value);
		setSelectedIds(/* @__PURE__ */ new Set());
	};
	const toggleMatchSelected = (matchId) => {
		setSelectedIds((prev) => {
			const next = new Set(prev);
			if (next.has(matchId)) next.delete(matchId);
			else next.add(matchId);
			return next;
		});
	};
	const toggleSelectAll = () => {
		setSelectedIds((prev) => {
			const next = new Set(prev);
			if (allFilteredSelected) filteredMatches.forEach((match) => next.delete(match.id));
			else filteredMatches.forEach((match) => next.add(match.id));
			return next;
		});
	};
	const handleBulkResolve = function() {
		var _ref3 = _asyncToGenerator(function* (resolution) {
			const matchIds = [...selectedIds];
			if (matchIds.length === 0) return;
			yield withBusy(_asyncToGenerator(function* () {
				const updated = yield client.resolveMatches(identificationId, matchIds, resolution);
				setSelectedIds(/* @__PURE__ */ new Set());
				applyUpdatedResults(updated);
			}));
		});
		return function handleBulkResolve(_x4) {
			return _ref3.apply(this, arguments);
		};
	}();
	const handleCardResolve = (matchId, resolution) => {
		if (resolution === MatchResolution.TruePositive) {
			setMatchProfileTarget([matchId]);
			return;
		}
		handleResolve(matchId, resolution);
	};
	const handleBulkAction = (resolution) => {
		if (resolution === MatchResolution.TruePositive) {
			setMatchProfileTarget([...selectedIds]);
			return;
		}
		handleBulkResolve(resolution);
	};
	const handleMatchProfileConfirm = function() {
		var _ref4 = _asyncToGenerator(function* (input) {
			const matchIds = matchProfileTarget;
			if (!matchIds || matchIds.length === 0) return;
			yield withBusy(_asyncToGenerator(function* () {
				const updated = yield client.matchProfiles(identificationId, matchIds, input);
				setSelectedIds(/* @__PURE__ */ new Set());
				applyUpdatedResults(updated);
			}));
		});
		return function handleMatchProfileConfirm(_x5) {
			return _ref4.apply(this, arguments);
		};
	}();
	const matchProfileCanResolveOthers = Boolean(matchProfileTarget && (results === null || results === void 0 ? void 0 : results.matches.some((match) => match.resolution === MatchResolution.Open && !matchProfileTarget.includes(match.id))));
	const allFilteredSelected = filteredMatches.length > 0 && filteredMatches.every((match) => selectedIds.has(match.id));
	return {
		results,
		busy,
		filter,
		filteredMatches,
		selectedIds,
		allFilteredSelected,
		viewingMatch,
		matchProfileTarget,
		matchProfileCanResolveOthers,
		changeFilter: handleFilterChange,
		toggleMatchSelected,
		toggleSelectAll,
		resolveFromCard: handleCardResolve,
		resolveBulk: handleBulkAction,
		confirmMatchProfile: handleMatchProfileConfirm,
		viewMatch: (match) => setViewingMatch(match),
		closeDetail: () => setViewingMatch(null),
		closeMatchProfileDialog: () => setMatchProfileTarget(null)
	};
};
//#endregion
//#region src/aml-screening/AmlScreeningRoot.tsx
var _excluded = ["locale"];
var FILTER_OPTION_KEYS = [
	{
		value: "all",
		labelKey: "aml_screening_modal.list_all_matches"
	},
	{
		value: MatchResolution.Open,
		labelKey: "aml_screening_modal.badge_open"
	},
	{
		value: MatchResolution.FalsePositive,
		labelKey: "aml_screening_modal.badge_false_positive"
	},
	{
		value: MatchResolution.TruePositive,
		labelKey: "aml_screening_modal.badge_match"
	}
];
var BULK_ACTION_KEYS = [
	{
		resolution: MatchResolution.Open,
		labelKey: "aml_screening_modal.action_open_match"
	},
	{
		resolution: MatchResolution.FalsePositive,
		labelKey: "aml_screening_modal.action_false_positive"
	},
	{
		resolution: MatchResolution.TruePositive,
		labelKey: "aml_screening_modal.action_match_profile"
	}
];
var AmlScreeningContent = ({ identificationId, personName, personDateOfBirth, personGender, personCountry, getAuthToken, apiBaseUrl, onClose, onStatusChange, open, client }) => {
	const { t } = useTranslation();
	const { results, busy, filter, filteredMatches, selectedIds, allFilteredSelected, viewingMatch, matchProfileTarget, matchProfileCanResolveOthers, changeFilter, toggleMatchSelected, toggleSelectAll, resolveFromCard, resolveBulk, confirmMatchProfile, viewMatch, closeDetail, closeMatchProfileDialog } = useAmlScreening({
		identificationId,
		personGender,
		personCountry,
		getAuthToken,
		apiBaseUrl,
		open,
		onStatusChange,
		client
	});
	if (!open) return null;
	const bulkActions = BULK_ACTION_KEYS.filter((action) => action.resolution !== filter).map((action) => ({
		resolution: action.resolution,
		label: t(action.labelKey)
	}));
	return /* @__PURE__ */ jsxs("div", {
		className: `${tokens_module_default.root} ${AmlScreeningRoot_module_default.root}`,
		children: [
			/* @__PURE__ */ jsx(AmlHeader, {
				personName,
				personDateOfBirth,
				onClose,
				closeLabel: t("aml_screening_modal.close_button")
			}),
			results === null ? /* @__PURE__ */ jsxs("div", {
				className: AmlScreeningRoot_module_default.loadingState,
				role: "status",
				"aria-live": "polite",
				children: [/* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.spinner,
					"aria-hidden": "true"
				}), /* @__PURE__ */ jsx("span", { children: t("aml_screening_modal.loading") })]
			}) : /* @__PURE__ */ jsxs(Fragment, { children: [
				results.matches.length > 0 && /* @__PURE__ */ jsx(AmlToolbar, {
					listLabel: t("aml_screening_modal.list_label"),
					matchesFoundLabel: t(filteredMatches.length === 1 ? "aml_screening_modal.matches_found_one" : "aml_screening_modal.matches_found_other", { n: filteredMatches.length }),
					selectAllLabel: t(allFilteredSelected ? "aml_screening_modal.unselect_all" : "aml_screening_modal.select_all"),
					onSelectAll: toggleSelectAll,
					selectAllDisabled: filteredMatches.length === 0,
					filterValue: filter,
					filterOptions: FILTER_OPTION_KEYS.map((option) => ({
						value: option.value,
						label: t(option.labelKey)
					})),
					onFilterChange: changeFilter
				}),
				selectedIds.size > 0 && /* @__PURE__ */ jsx(AmlBulkActionBar, {
					selectedCountLabel: t(selectedIds.size === 1 ? "aml_screening_modal.matches_selected_one" : "aml_screening_modal.matches_selected_other", { n: selectedIds.size }),
					setThemAsLabel: t("aml_screening_modal.set_them_as"),
					actions: bulkActions,
					onResolve: resolveBulk
				}),
				/* @__PURE__ */ jsx(AmlCriteriaBar, {
					criteria: results.criteria,
					datasetsLabel: t("aml_screening_modal.datasets_label"),
					countryLabel: t("aml_screening_modal.country_label"),
					genderLabel: t("aml_screening_modal.gender_label")
				}),
				results.matches.length === 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("hr", { className: AmlScreeningRoot_module_default.divider }), /* @__PURE__ */ jsx(AmlEmptyState, {
					heading: t("aml_screening_modal.empty_heading"),
					description: t("aml_screening_modal.empty_description")
				})] }) : filteredMatches.length === 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("hr", { className: AmlScreeningRoot_module_default.divider }), /* @__PURE__ */ jsx(AmlEmptyState, {
					heading: t("aml_screening_modal.filtered_empty_heading"),
					description: t("aml_screening_modal.filtered_empty_description")
				})] }) : /* @__PURE__ */ jsx("div", {
					className: AmlScreeningRoot_module_default.matchList,
					children: filteredMatches.map((match) => /* @__PURE__ */ jsx(AmlMatchCard, {
						match,
						selected: selectedIds.has(match.id),
						onToggleSelected: () => toggleMatchSelected(match.id),
						onResolve: (resolution) => resolveFromCard(match.id, resolution),
						onViewProfile: () => viewMatch(match)
					}, match.id))
				})
			] }),
			viewingMatch && /* @__PURE__ */ jsx(AmlMatchDetail, {
				match: viewingMatch,
				onClose: closeDetail
			}),
			matchProfileTarget && /* @__PURE__ */ jsx(AmlMatchProfileDialog, {
				canResolveOthers: matchProfileCanResolveOthers,
				onConfirm: confirmMatchProfile,
				onClose: closeMatchProfileDialog
			}),
			busy && /* @__PURE__ */ jsx("div", {
				className: AmlScreeningRoot_module_default.busyOverlay,
				role: "status",
				"aria-live": "polite",
				"aria-label": t("aml_screening_modal.processing"),
				children: /* @__PURE__ */ jsx("span", {
					className: AmlScreeningRoot_module_default.spinner,
					"aria-hidden": "true"
				})
			})
		]
	});
};
var AmlScreeningRoot = (_ref) => {
	let { locale } = _ref, props = _objectWithoutProperties$1(_ref, _excluded);
	useEffect(() => {
		if (locale && i18n.language !== locale) i18n.changeLanguage(locale);
	}, [locale]);
	return /* @__PURE__ */ jsx(I18nextProvider, {
		i18n,
		children: /* @__PURE__ */ jsx(AmlScreeningContent, _objectSpread2({}, props))
	});
};
//#endregion
export { AmlScreeningRoot };
